import type { PageGrounding } from './grounding';

/**
 * GENERATED from the live guide articles (Sep 23, 2026) by the Labs grounding scripts. Do not
 * hand-edit. Skills: what the article's first-round description names, then its skills chart,
 * filtered to its role family. `processLine` paraphrases only the article's interview section.
 */
export const PAGES: Record<string, PageGrounding> = {
  '1password-internship-guide': {
    family: 'software',
    processLine:
      '1Password starts with a recruiter screen on motivation and background; there is no timed LeetCode-style assessment.',
    skills: ['coding-fundamentals', 'product-sense'],
  },
  '3m-internship-guide': {
    family: 'other',
    processLine:
      "3M's first conversation is a recruiter phone screen on fit and motivation: why 3M and why this function.",
    skills: ['case-structure', 'operations'],
  },
  '7-eleven-internship-guide': {
    family: 'other',
    processLine:
      '7-Eleven starts with a 20-30 minute recruiter phone screen on your qualifications, availability and fit.',
    skills: ['sql-data', 'marketing-strategy'],
  },
  'a-mark-precious-metals-internship-guide': {
    family: 'finance',
    processLine: null,
    skills: ['financial-modeling', 'markets'],
  },
  'a24-internship-guide': {
    family: 'marketing',
    processLine:
      "A24's first round is a roughly 30-minute virtual group interview alongside about five other candidates.",
    skills: ['marketing-strategy', 'consumer-insight'],
  },
  'abb-internship-guide': {
    family: 'operations',
    processLine:
      'ABB starts with a short recruiter or HR phone screen confirming your major, availability and interest in the role.',
    skills: ['case-structure', 'operations'],
  },
  'abbott-internship-guide': {
    family: 'other',
    processLine: 'Abbott opens with a 15-45 minute recruiter call or a one-way video of behavioral questions.',
    skills: ['communication', 'sql-data'],
  },
  'abbvie-internship-guide': {
    family: 'other',
    processLine:
      'AbbVie starts with a 15-30 minute recruiter phone screen on motivation and your interest in pharma and AbbVie.',
    skills: ['operations', 'sql-data'],
  },
  'abm-industries-internship-guide': {
    family: 'operations',
    processLine: 'ABM starts with a mostly behavioral HR phone screen, then a hiring manager interview.',
    skills: ['communication', 'operations'],
  },
  'abnormal-security-internship-guide': {
    family: 'software',
    processLine: 'Abnormal starts with a recruiter screen on background, motivation and team fit.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'abridge-internship-guide': {
    family: 'ai-ml',
    processLine:
      'Abridge starts with a recruiter call on background and motivation, then a 45-minute technical project deep dive.',
    skills: ['ml-fundamentals', 'coding-fundamentals'],
  },
  'accel-internship-guide': {
    family: 'finance',
    processLine:
      "Accel's first round is a roughly 10-minute phone screen on your interest in the firm and its investments.",
    skills: ['markets', 'coding-fundamentals'],
  },
  'accenture-internship-guide': {
    family: 'consulting',
    processLine:
      "Accenture's first interview is a recorded HireVue of 3-8 competency questions, after an online assessment.",
    skills: ['sql-data', 'case-structure'],
  },
  'ace-hardware-internship-guide': {
    family: 'other',
    processLine: 'Ace starts with a 30-minute phone screen: resume walkthrough, motivation and salary expectations.',
    skills: ['operations', 'quant-reasoning'],
  },
  'activision-blizzard-internship-guide': {
    family: 'software',
    processLine:
      'Activision Blizzard starts with a recruiter screen on your resume, motivation and target engineering area.',
    skills: ['coding-fundamentals', 'product-sense'],
  },
  'addepar-internship-guide': {
    family: 'software',
    processLine: 'Addepar starts with a 30-minute recruiter screen: resume walkthrough, motivation and logistics.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'adept-ai-internship-guide': {
    family: 'ai-ml',
    processLine:
      "Adept's main filter is a one-hour technical phone screen of hard LeetCode-level problems, after a recruiter call.",
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'adidas-internship-guide': {
    family: 'marketing',
    processLine:
      "Adidas' first live interview is 30-45 minutes on video, after a HireVue assessment with games and recorded questions.",
    skills: ['marketing-strategy', 'consumer-insight'],
  },
  'adobe-internship-guide': {
    family: 'software',
    processLine:
      "Adobe's recruiter screen is 20-30 minutes on logistics and team matching, after a HackerRank assessment.",
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'adp-internship-guide': {
    family: 'software',
    processLine:
      "ADP's interviews are behavioral, mapped to its three competencies; data science roles add an ML and SQL round.",
    skills: ['sql-data', 'ml-fundamentals'],
  },
  'adt-internship-guide': {
    family: 'software',
    processLine:
      'ADT starts with a 15-30 minute recruiter phone screen on your interest in ADT, availability and qualifications.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'advance-auto-parts-internship-guide': {
    family: 'other',
    processLine: 'Advance Auto Parts starts with a recruiter phone screen, then a conversational manager interview.',
    skills: ['sql-data', 'marketing-strategy'],
  },
  'advanced-micro-devices-internship-guide': {
    family: 'software',
    processLine: 'AMD starts with a 30-minute recruiter phone screen on resume fit, logistics and motivation.',
    skills: ['coding-fundamentals', 'product-sense'],
  },
  'advent-international-internship-guide': {
    family: 'finance',
    processLine:
      "Advent's first round is a 30-45 minute phone screen: resume, why PE, why Advent, and basic LBO and valuation questions.",
    skills: ['valuation', 'financial-modeling'],
  },
  'aecom-internship-guide': {
    family: 'operations',
    processLine:
      'AECOM starts with an Early Careers recruiter screen on background, office fit and work authorization.',
    skills: ['excel', 'operations'],
  },
  'aes-internship-guide': {
    family: 'operations',
    processLine: 'AES opens with a HireVue: recorded video answers plus online logic and problem-solving games.',
    skills: ['operations', 'supply-chain'],
  },
  'affirm-internship-guide': {
    family: 'software',
    processLine:
      "Affirm's first conversation is a 30-minute non-technical recruiter screen, after a 60-minute coding assessment.",
    skills: ['coding-fundamentals', 'product-sense'],
  },
  'aflac-internship-guide': {
    family: 'finance',
    processLine:
      "Aflac's first screen is a pre-recorded interview you answer on your own time, not a live recruiter call.",
    skills: ['coding-fundamentals', 'excel'],
  },
  'agco-internship-guide': {
    family: 'operations',
    processLine:
      "AGCO doesn't publish its format; expect an interview with engineers rather than a pure behavioral screen.",
    skills: ['communication', 'operations'],
  },
  'ai21-labs-internship-guide': {
    family: 'ai-ml',
    processLine:
      'AI21 Labs starts with a 30-minute recruiter screen, then a hiring manager interview on your research.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'aig-internship-guide': {
    family: 'finance',
    processLine: "AIG's first round is a pre-recorded HireVue with several behavioral questions.",
    skills: ['communication', 'sql-data'],
  },
  'air-products-internship-guide': {
    family: 'operations',
    processLine:
      'Air Products opens with a recorded video screen of behavioral questions on leadership, teamwork and safety.',
    skills: ['communication', 'operations'],
  },
  'airbnb-internship-guide': {
    family: 'software',
    processLine: 'Airbnb starts with a 30-minute recruiter screen, after a mandatory CodeSignal coding assessment.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'airbus-internship-guide': {
    family: 'operations',
    processLine:
      'Airbus interviews after online psychometric tests; formats vary from phone screens to panels and HireVue.',
    skills: ['operations', 'supply-chain'],
  },
  'airtable-internship-guide': {
    family: 'software',
    processLine: "Airtable's new-grad route starts with a HackerRank assessment, often a table-style data problem.",
    skills: ['coding-fundamentals', 'product-sense'],
  },
  'akamai-internship-guide': {
    family: 'software',
    processLine:
      'Akamai runs 2-3 rounds: a recruiter screen, a coding and networking interview, and a behavioral round.',
    skills: ['coding-fundamentals', 'product-sense'],
  },
  'akuna-capital-internship-guide': {
    family: 'finance',
    processLine:
      "Akuna's technical phone interview is one-on-one with a trader or engineer, after math and coding tests.",
    skills: ['coding-fundamentals', 'quant-reasoning'],
  },
  'alaska-air-internship-guide': {
    family: 'other',
    processLine: "Alaska starts with a 30-minute HR phone screen: school, major, why Alaska and what you'd bring.",
    skills: ['sql-data', 'operations'],
  },
  'albertsons-internship-guide': {
    family: 'other',
    processLine:
      'Albertsons interviews lean behavioral: a recruiter screen, then a one-on-one with the hiring manager.',
    skills: ['communication', 'sql-data'],
  },
  'alcoa-internship-guide': {
    family: 'operations',
    processLine: "Alcoa's shortlist gets a short online video interview, then an HR phone screen.",
    skills: ['operations', 'case-structure'],
  },
  'alcon-internship-guide': {
    family: 'other',
    processLine:
      "Alcon's main interview is a roughly 45-minute behavioral conversation, after an initial screening call.",
    skills: ['communication', 'sql-data'],
  },
  'alfa-insurance-internship-guide': {
    family: 'finance',
    processLine: 'Alfa runs one conversational interview, usually with the department head, on personality and values.',
    skills: ['case-structure', 'coding-fundamentals'],
  },
  'allstate-internship-guide': {
    family: 'data-analytics',
    processLine:
      "Allstate's first round is a pre-recorded HireVue video interview; there's no standard coding assessment.",
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'alphasights-internship-guide': {
    family: 'consulting',
    processLine: "AlphaSights' recruiter screen is about 30 minutes, after a HireVue or AI interview stage.",
    skills: ['communication', 'case-structure'],
  },
  'altice-usa-internship-guide': {
    family: 'data-analytics',
    processLine: null,
    skills: ['sql-data', 'coding-fundamentals'],
  },
  'altria-internship-guide': {
    family: 'other',
    processLine: 'Altria starts with a recruiter phone call or email, then a phone screen and a panel interview.',
    skills: ['sql-data', 'case-structure'],
  },
  'alvarez-and-marsal-internship-guide': {
    family: 'consulting',
    processLine:
      'A&M starts with a roughly 30-minute recruiter screen: resume walkthrough, why A&M and why this practice.',
    skills: ['case-structure', 'sql-data'],
  },
  'amazon-internship-guide': {
    family: 'software',
    processLine:
      'Amazon opens with a roughly two-hour online assessment: two coding problems, debugging and a work simulation.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'amc-networks-internship-guide': {
    family: 'marketing',
    processLine:
      "AMC starts with a short recruiter or HR screen on fit, availability and track interest; there's no coding test.",
    skills: ['marketing-strategy', 'research'],
  },
  'amd-internship-guide': {
    family: 'software',
    processLine:
      'AMD starts with a 30-minute recruiter phone screen confirming your background, role fit and timeline.',
    skills: ['coding-fundamentals', 'product-sense'],
  },
  'amentum-internship-guide': {
    family: 'operations',
    processLine: 'Amentum starts with a recruiter screen on background, availability and clearance eligibility.',
    skills: ['operations', 'case-structure'],
  },
  'american-airlines-internship-guide': {
    family: 'other',
    processLine:
      "American Airlines starts with a 20-30 minute recruiter phone screen, including 'Why American Airlines?'",
    skills: ['sql-data', 'quant-reasoning'],
  },
  'american-bureau-of-shipping-internship-guide': {
    family: 'operations',
    processLine: 'ABS runs one virtual interview only, described by students as quick and clear.',
    skills: ['excel', 'supply-chain'],
  },
  'american-electric-power-internship-guide': {
    family: 'operations',
    processLine: "AEP's interview is behavioral; one candidate called it 'all behavioral. 90%.'",
    skills: ['communication', 'operations'],
  },
  'american-express-internship-guide': {
    family: 'finance',
    processLine:
      "AmEx's first interview is a HireVue of 3 recorded behavioral questions, after online reasoning tests.",
    skills: ['sql-data', 'coding-fundamentals'],
  },
  'american-family-insurance-internship-guide': {
    family: 'finance',
    processLine: 'AmFam starts with a 30-45 minute phone screen or one-on-one interview of behavioral questions.',
    skills: ['communication', 'sql-data'],
  },
  'american-financial-internship-guide': {
    family: 'finance',
    processLine:
      'Great American starts with an HR phone or video screen on your background and why specialty insurance.',
    skills: ['sql-data', 'financial-modeling'],
  },
  'american-heart-association-internship-guide': {
    family: 'other',
    processLine:
      "The AHA starts with a recruiter phone interview and/or a one-way recorded video; there's no coding test.",
    skills: ['sql-data', 'marketing-strategy'],
  },
  'american-tower-internship-guide': {
    family: 'operations',
    processLine: 'American Tower starts with an HR phone or video screen on your classes and experience.',
    skills: ['case-structure', 'excel'],
  },
  'ameriprise-financial-internship-guide': {
    family: 'finance',
    processLine: 'Ameriprise starts with a phone interview for some positions, then a first-round interview.',
    skills: ['sql-data', 'coding-fundamentals'],
  },
  'amgen-internship-guide': {
    family: 'other',
    processLine: 'Amgen starts with a 25-30 minute recruiter phone screen on work authorization, availability and fit.',
    skills: ['sql-data', 'operations'],
  },
  'amphenol-internship-guide': {
    family: 'operations',
    processLine:
      'Amphenol starts with a 20-30 minute HR phone screen: tell me about yourself, why Amphenol, salary expectations.',
    skills: ['communication', 'operations'],
  },
  'analog-devices-internship-guide': {
    family: 'software',
    processLine:
      'ADI interviews by phone, video or in person; technical rounds center on a project you can walk through.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'analysis-group-internship-guide': {
    family: 'consulting',
    processLine:
      "Analysis Group's first round is a roughly 30-minute virtual behavioral interview, including why economic consulting.",
    skills: ['communication', 'excel'],
  },
  'andersons-internship-guide': { family: 'other', processLine: null, skills: ['excel', 'quant-reasoning'] },
  'andreessen-horowitz-internship-guide': {
    family: 'finance',
    processLine: 'a16z starts with a 30-minute recruiter screen on background and fit: why VC and why a16z.',
    skills: ['sql-data', 'valuation'],
  },
  'anduril-internship-guide': {
    family: 'software',
    processLine:
      'Anduril starts with a 30-minute recruiter screen that directly tests your motivation to work in defense.',
    skills: ['coding-fundamentals', 'product-sense'],
  },
  'anheuser-busch-inbev-internship-guide': {
    family: 'operations',
    processLine: "AB InBev's first interview is a 15-45 minute call: resume walkthrough and behavioral questions.",
    skills: ['case-structure', 'operations'],
  },
  'anthropic-internship-guide': {
    family: 'ai-ml',
    processLine:
      "Anthropic's first live round is a 90-minute coding screen with an engineer, after a CodeSignal assessment.",
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'anyscale-internship-guide': {
    family: 'ai-ml',
    processLine:
      'Anyscale starts with a 30-minute recruiter screen on your background and interest in distributed systems.',
    skills: ['ml-fundamentals', 'coding-fundamentals'],
  },
  'apa-corporation-internship-guide': {
    family: 'operations',
    processLine:
      'Apache starts with a recruiter phone screen on your background, interest in oil and gas and logistics.',
    skills: ['case-structure', 'supply-chain'],
  },
  'api-internship-guide': {
    family: 'operations',
    processLine:
      "APi Group's interview is with the hiring manager: relevant skills, motivation for the subsidiary, onsite work.",
    skills: ['operations', 'excel'],
  },
  'apollo-global-internship-guide': {
    family: 'finance',
    processLine:
      "Apollo's screening interviews are 1-2 rounds of 30 minutes: CV walkthrough, why Apollo and a deal example.",
    skills: ['financial-modeling', 'valuation'],
  },
  'apple-internship-guide': {
    family: 'software',
    processLine:
      "Apple starts with a recruiter phone screen once a team pulls your resume; there's no company-wide OA.",
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'applied-materials-internship-guide': {
    family: 'operations',
    processLine:
      'Applied Materials runs behavioral and technical rounds, often a panel, after an online assessment for some roles.',
    skills: ['operations', 'supply-chain'],
  },
  'applovin-internship-guide': {
    family: 'software',
    processLine:
      'AppLovin starts with a 15-30 minute recruiter screen on interest, resume and basic programming questions.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'aprio-internship-guide': {
    family: 'accounting-firm',
    processLine:
      "Aprio's first round is a fit conversation on public accounting, career goals and teamwork, with no technical questions.",
    skills: ['accounting', 'case-structure'],
  },
  'aptiv-internship-guide': {
    family: 'software',
    processLine: "Aptiv's first round is technical: core-course fundamentals, small C snippets and protocol questions.",
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'aqr-capital-internship-guide': {
    family: 'finance',
    processLine:
      'AQR starts with a 30-minute recruiter screen on background and motivation, probing its published research.',
    skills: ['sql-data', 'statistics'],
  },
  'aramark-internship-guide': {
    family: 'other',
    processLine: 'Aramark starts with a recruiter or unit-manager phone screen of basic behavioral questions.',
    skills: ['communication', 'marketing-strategy'],
  },
  'arch-capital-group-internship-guide': {
    family: 'finance',
    processLine: "Arch opens with a one-way HireVue of behavioral prompts, including 'why insurance.'",
    skills: ['communication', 'quant-reasoning'],
  },
  'archer-daniels-midland-internship-guide': {
    family: 'operations',
    processLine: 'ADM starts with a phone or recruiter screen on basic qualifications and fit.',
    skills: ['case-structure', 'excel'],
  },
  'ares-management-internship-guide': {
    family: 'finance',
    processLine:
      'Ares starts with a 15-30 minute recruiter screen on motivation, why alternatives, and which business group you want.',
    skills: ['communication', 'case-structure'],
  },
  'arista-networks-internship-guide': {
    family: 'software',
    processLine: 'Arista screens with a C/C++ and Python coding assessment plus networking fundamentals questions.',
    skills: ['coding-fundamentals', 'product-sense'],
  },
  'arm-internship-guide': {
    family: 'software',
    processLine:
      "Arm's initial virtual interview covers your motivations, how you think and how you approach problem-solving.",
    skills: ['coding-fundamentals', 'product-sense'],
  },
  'armanino-internship-guide': {
    family: 'accounting-firm',
    processLine:
      'Armanino starts with a 20-30 minute recruiter call on your background, interest in the firm, and CPA eligibility.',
    skills: ['tax', 'accounting'],
  },
  'arrow-electronics-internship-guide': {
    family: 'operations',
    processLine: 'Arrow starts with a recruiter phone screen, then interviews with the department manager.',
    skills: ['communication', 'supply-chain'],
  },
  'arthrex-internship-guide': {
    family: 'operations',
    processLine:
      'Arthrex starts with a 20-30 minute recruiter phone screen on your background and interest in medical devices.',
    skills: ['case-structure', 'quant-reasoning'],
  },
  'arthur-j-gallagher-internship-guide': {
    family: 'finance',
    processLine: 'Gallagher usually runs one behavioral interview of about 30 minutes with two interviewers.',
    skills: ['communication', 'financial-modeling'],
  },
  'asana-internship-guide': {
    family: 'software',
    processLine:
      "Asana's first interview is a collaborative, IDE-based coding call with a senior engineer or hiring manager.",
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'asbury-automotive-internship-guide': {
    family: 'software',
    processLine: "Asbury's expected loop is an HR phone screen, then a technical interview with the team lead.",
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'assurant-internship-guide': {
    family: 'finance',
    processLine: "Assurant starts with a 15-30 minute phone screen on background, motivation and 'why insurance?'",
    skills: ['sql-data', 'financial-modeling'],
  },
  'astrazeneca-internship-guide': {
    family: 'other',
    processLine: 'AstraZeneca opens with an on-demand HireVue of behavioral and motivational questions.',
    skills: ['communication', 'sql-data'],
  },
  'at-and-t-internship-guide': {
    family: 'software',
    processLine: "AT&T's first interview is a recruiter screen, after an online technical assessment.",
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'atlassian-internship-guide': {
    family: 'software',
    processLine:
      "Atlassian's first conversation is a 30-minute recruiter screen, after a HackerRank coding assessment.",
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'attentive-internship-guide': {
    family: 'software',
    processLine: 'Attentive starts with a 30-minute recruiter screen on your goals and one project you built.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'aurora-internship-guide': {
    family: 'ai-ml',
    processLine: 'Aurora starts with a 20-30 minute recruiter screen on background, logistics and motivation.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'auto-owners-insurance-internship-guide': {
    family: 'finance',
    processLine:
      'Auto-Owners runs one to two interview rounds by video or on-site: behavioral plus role-specific questions.',
    skills: ['communication', 'case-structure'],
  },
  'autoliv-internship-guide': {
    family: 'operations',
    processLine:
      'Autoliv usually runs a one-on-one interview: behavioral questions plus technical fundamentals and your projects.',
    skills: ['case-structure', 'quant-reasoning'],
  },
  'autonation-internship-guide': {
    family: 'other',
    processLine: 'AutoNation starts with a 15-30 minute recruiter phone screen on your background and academics.',
    skills: ['sql-data', 'operations'],
  },
  'autozone-internship-guide': {
    family: 'other',
    processLine:
      'AutoZone starts with an HR phone screen on your qualifications, availability and interest in the track.',
    skills: ['sql-data', 'marketing-strategy'],
  },
  'avery-dennison-internship-guide': {
    family: 'operations',
    processLine: 'Avery Dennison starts with a behavioral HR phone screen on motivation, teamwork and logistics.',
    skills: ['communication', 'operations'],
  },
  'avis-budget-internship-guide': {
    family: 'other',
    processLine:
      "Avis Budget's first stage is a 30-minute Teams call with about three questions, mostly informational.",
    skills: ['sql-data', 'excel'],
  },
  'avnet-internship-guide': {
    family: 'operations',
    processLine:
      "Avnet's interviews are competency-based: a phone screen, a personality or skills test, then a one-on-one.",
    skills: ['supply-chain', 'operations'],
  },
  'bae-systems-internship-guide': {
    family: 'operations',
    processLine:
      'BAE starts with a roughly 30-minute recruiter screen on motivation, why defense and clearance eligibility.',
    skills: ['operations', 'quant-reasoning'],
  },
  'bain-capital-internship-guide': {
    family: 'finance',
    processLine: "Bain Capital's first round is two 30-minute Zoom sessions, one of them a case study.",
    skills: ['case-structure', 'markets'],
  },
  'bain-internship-guide': {
    family: 'consulting',
    processLine: "Bain's first round is two back-to-back 30-minute sessions, each half behavioral and half case.",
    skills: ['case-structure', 'quant-reasoning'],
  },
  'baker-hughes-internship-guide': {
    family: 'operations',
    processLine: 'Baker Hughes opens with a one-way HireVue of STAR behavioral questions.',
    skills: ['communication', 'case-structure'],
  },
  'baker-tilly-internship-guide': {
    family: 'accounting-firm',
    processLine:
      'Baker Tilly starts with a roughly 15-minute conversational recruiter screen on your interest and background.',
    skills: ['case-structure', 'accounting'],
  },
  'ball-internship-guide': { family: 'operations', processLine: null, skills: ['operations', 'supply-chain'] },
  'balyasny-internship-guide': {
    family: 'finance',
    processLine:
      "Balyasny's first interview is a one-way HireVue of behavioral and basic technical questions, after online tests.",
    skills: ['sql-data', 'statistics'],
  },
  'bamboohr-internship-guide': {
    family: 'software',
    processLine: null,
    skills: ['coding-fundamentals', 'product-sense'],
  },
  'bank-of-america-internship-guide': {
    family: 'finance',
    processLine: 'Bank of America opens with a HireVue: a handful of behavioral questions, up to three minutes each.',
    skills: ['communication', 'case-structure'],
  },
  'bank-of-new-york-internship-guide': {
    family: 'finance',
    processLine:
      'BNY tech roles start with a DSA interview after a HackerRank test; non-tech roles get two 25-minute interviews.',
    skills: ['coding-fundamentals', 'quant-reasoning'],
  },
  'barclays-internship-guide': {
    family: 'finance',
    processLine: "Barclays' first interview is a HireVue of 4-6 mostly behavioral questions, after SHL tests.",
    skills: ['financial-modeling', 'valuation'],
  },
  'bates-white-internship-guide': {
    family: 'consulting',
    processLine:
      "Bates White's first round is virtual: behavioral questions plus a case of brainstorming, calculations and discussion.",
    skills: ['case-structure', 'quant-reasoning'],
  },
  'battelle-internship-guide': {
    family: 'operations',
    processLine:
      'Battelle starts with a phone or video screen on eligibility and role fit, then a technical interview.',
    skills: ['case-structure', 'communication'],
  },
  'baxter-international-internship-guide': {
    family: 'operations',
    processLine: 'Baxter starts with a 20-30 minute recruiter phone screen on background, motivation and availability.',
    skills: ['excel', 'operations'],
  },
  'baycrest-internship-guide': {
    family: 'finance',
    processLine: 'BayCrest runs a group panel interview: why finance, why BayCrest and basic finance concepts.',
    skills: ['markets', 'excel'],
  },
  'bbdo-internship-guide': {
    family: 'marketing',
    processLine:
      'BBDO starts with a 15-20 minute recruiter screen on motivation, cultural fit and basic qualifications.',
    skills: ['consumer-insight', 'marketing-strategy'],
  },
  'bcg-internship-guide': {
    family: 'consulting',
    processLine:
      "BCG's first round is two 45-minute interviews, each part behavioral and part case, after the Casey chatbot.",
    skills: ['case-structure', 'sql-data'],
  },
  'bdo-internship-guide': {
    family: 'accounting-firm',
    processLine: "BDO's screening interview is about 40 minutes of behavioral questions, after an online assessment.",
    skills: ['accounting', 'audit'],
  },
  'becton-dickinson-internship-guide': {
    family: 'other',
    processLine:
      'BD starts with a recruiter screen that explains the role before scheduling hiring-manager interviews.',
    skills: ['sql-data', 'operations'],
  },
  'benesch-internship-guide': {
    family: 'operations',
    processLine:
      'Benesch interviews are conversational: often a phone interview or one-on-one, with no online assessment.',
    skills: ['case-structure', 'operations'],
  },
  'bennett-thrasher-internship-guide': {
    family: 'accounting-firm',
    processLine:
      "Bennett Thrasher runs an office visit and a behavioral panel interview; there's no online assessment.",
    skills: ['accounting', 'tax'],
  },
  'berkshire-hathaway-internship-guide': {
    family: 'other',
    processLine:
      'Berkshire interviews usually run 1-2 rounds: a recruiter phone screen, then a hiring manager interview.',
    skills: ['communication', 'sql-data'],
  },
  'berry-global-internship-guide': {
    family: 'operations',
    processLine: 'Berry starts with a recruiter or HR phone screen, then a hiring manager interview at the facility.',
    skills: ['case-structure', 'operations'],
  },
  'best-buy-internship-guide': {
    family: 'other',
    processLine: 'Best Buy opens with a pre-recorded video interview on customer-centricity and teamwork.',
    skills: ['communication', 'quant-reasoning'],
  },
  'bill-com-internship-guide': {
    family: 'software',
    processLine:
      "BILL's recruiter screen is 30 minutes on background and interest in BILL, after a HackerRank OA for engineers.",
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'biogen-internship-guide': {
    family: 'other',
    processLine:
      'Biogen starts with a 20-30 minute recruiter phone screen on your resume, motivation for biotech and logistics.',
    skills: ['sql-data', 'case-structure'],
  },
  'bjs-wholesale-club-internship-guide': {
    family: 'other',
    processLine: "BJ's starts with a recruiter screen, then a hiring-manager interview with the function lead.",
    skills: ['case-structure', 'consumer-insight'],
  },
  'blackrock-internship-guide': {
    family: 'finance',
    processLine:
      "BlackRock's first step after applying is a short pre-interview video assessment you must finish within 5 days.",
    skills: ['case-structure', 'coding-fundamentals'],
  },
  'blackstone-internship-guide': {
    family: 'finance',
    processLine: "Blackstone's first interview is a 30-minute technical phone screen on accounting and a verbal LBO.",
    skills: ['accounting', 'financial-modeling'],
  },
  'block-square-internship-guide': {
    family: 'software',
    processLine: "Block's recruiter screen is 15-30 minutes on background and motivation, after a coding assessment.",
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'bloomberg-internship-guide': {
    family: 'software',
    processLine: "Bloomberg's first interview is a video call with a department employee, after an assessment.",
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'blue-origin-internship-guide': {
    family: 'operations',
    processLine:
      'Blue Origin starts with a 30-minute recruiter phone screen on background, motivation and work authorization.',
    skills: ['case-structure', 'operations'],
  },
  'bmo-capital-markets-internship-guide': {
    family: 'finance',
    processLine: "BMO's first round is a 15-30 minute HireVue with behavioral and technical questions.",
    skills: ['financial-modeling', 'quant-reasoning'],
  },
  'bmss-internship-guide': {
    family: 'accounting-firm',
    processLine: 'BMSS hires through relationships; the final step is an invite-only half-day Fall Office Visit.',
    skills: ['tax', 'audit'],
  },
  'bmw-internship-guide': {
    family: 'operations',
    processLine: 'BMW starts with a 15-30 minute HR phone screen: a fit check on background, motivation and basics.',
    skills: ['quant-reasoning', 'excel'],
  },
  'bnp-paribas-internship-guide': {
    family: 'finance',
    processLine: "BNP Paribas' first interview is a pre-recorded video, after Pymetrics games and reasoning tests.",
    skills: ['financial-modeling', 'markets'],
  },
  'bny-mellon-internship-guide': {
    family: 'finance',
    processLine:
      'BNY interviews you with team members after an assessment; tech roles take a 4-question HackerRank first.',
    skills: ['coding-fundamentals', 'case-structure'],
  },
  'boehringer-ingelheim-internship-guide': {
    family: 'other',
    processLine:
      'Boehringer Ingelheim interviews you with HR and the hiring manager, virtually or on-site, after a recruiter review.',
    skills: ['operations', 'quant-reasoning'],
  },
  'boeing-internship-guide': {
    family: 'operations',
    processLine: 'Boeing starts with a short HR or recruiter screen on the role, your eligibility and availability.',
    skills: ['quant-reasoning', 'case-structure'],
  },
  'booking-holdings-internship-guide': {
    family: 'software',
    processLine:
      'Priceline starts with a roughly 30-minute recruiter screen on background, motivation, and Java and SQL skills.',
    skills: ['sql-data', 'coding-fundamentals'],
  },
  'booz-allen-hamilton-internship-guide': {
    family: 'software',
    processLine:
      'Booz Allen starts with a 30-minute recruiter screen on your resume and why Booz Allen; it is not a case round.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'booz-allen-internship-guide': {
    family: 'software',
    processLine:
      'Booz Allen starts with a 30-minute recruiter screen on your resume and why Booz Allen; it is not a case round.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'borgwarner-internship-guide': {
    family: 'operations',
    processLine:
      'BorgWarner starts with a recruiter phone screen on your background, availability and interest in its technology.',
    skills: ['quant-reasoning', 'communication'],
  },
  'bosch-internship-guide': {
    family: 'operations',
    processLine: 'Bosch starts with a 15-20 minute HR phone screen on background, motivation and basic qualifications.',
    skills: ['case-structure', 'operations'],
  },
  'boston-scientific-internship-guide': {
    family: 'other',
    processLine: 'Boston Scientific starts with a 15-30 minute recruiter screen or career fair conversation.',
    skills: ['sql-data', 'case-structure'],
  },
  'boyer-and-ritter-internship-guide': {
    family: 'accounting-firm',
    processLine:
      'Boyer & Ritter interviews you with partners and managers on fit, interest in accounting and career goals.',
    skills: ['accounting', 'tax'],
  },
  'bp-internship-guide': {
    family: 'operations',
    processLine: 'BP opens with a HireVue video interview, after situational judgement and reasoning tests.',
    skills: ['case-structure', 'quant-reasoning'],
  },
  'brattle-group-internship-guide': {
    family: 'consulting',
    processLine:
      'Brattle opens with a recruiter call on your interest in economic consulting and your quantitative background.',
    skills: ['sql-data', 'case-structure'],
  },
  'braze-internship-guide': {
    family: 'software',
    processLine: 'Braze starts with a 30-minute recruiter call on your background, motivations and career goals.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'brex-internship-guide': {
    family: 'software',
    processLine: 'Brex starts with a 30-minute recruiter screen on behavioral fit, motivation and its core values.',
    skills: ['communication', 'coding-fundamentals'],
  },
  'bridgewater-internship-guide': {
    family: 'finance',
    processLine:
      "Bridgewater's first filter is a blind cognitive and personality assessment, then a Personal Development interview.",
    skills: ['markets', 'case-structure'],
  },
  'brightspring-health-services-internship-guide': {
    family: 'other',
    processLine: 'BrightSpring runs a phone interview, then an in-person interview at its Louisville support center.',
    skills: ['operations', 'excel'],
  },
  'bristol-myers-squibb-internship-guide': {
    family: 'other',
    processLine:
      'BMS starts with a 20-30 minute recruiter screen on qualifications and your interest in its therapeutic areas.',
    skills: ['sql-data', 'case-structure'],
  },
  'broadcom-internship-guide': {
    family: 'software',
    processLine:
      'Broadcom starts with a 15-30 minute recruiter screen confirming your target division, level and location.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'broadridge-internship-guide': {
    family: 'software',
    processLine: "Broadridge's first round is a conversational, behavioral video interview with the recruitment team.",
    skills: ['communication', 'coding-fundamentals'],
  },
  'brown-gibbons-lang-internship-guide': {
    family: 'finance',
    processLine:
      'BGL starts with a virtual recruiter interview, mostly behavioral with one or two technical questions.',
    skills: ['accounting', 'case-structure'],
  },
  'buck-internship-guide': {
    family: 'finance',
    processLine: 'Buck hiring now runs through Gallagher: a phone or video screen if selected, per Glassdoor reports.',
    skills: ['excel', 'quant-reasoning'],
  },
  'builders-firstsource-internship-guide': {
    family: 'operations',
    processLine:
      'Builders FirstSource starts with a 30-60 minute phone interview with a peer or manager, including hypotheticals.',
    skills: ['supply-chain', 'operations'],
  },
  'bunge-internship-guide': {
    family: 'operations',
    processLine: 'Bunge starts with an HR screen on why Bunge and your resume, after a games-based assessment.',
    skills: ['quant-reasoning', 'excel'],
  },
  'bungie-internship-guide': {
    family: 'software',
    processLine: 'Bungie usually starts with a phone screen, then a one-on-one with the hiring manager.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'burlington-stores-internship-guide': {
    family: 'other',
    processLine: 'Burlington opens with a HireVue: recorded behavioral answers plus game-based cognitive assessments.',
    skills: ['case-structure', 'sql-data'],
  },
  'caci-international-internship-guide': {
    family: 'software',
    processLine: 'CACI starts with a recruiter screen on background, motivation, citizenship and clearance status.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'caesars-entertainment-internship-guide': {
    family: 'other',
    processLine: "Caesars' first round is a HireVue or 20-30 minute phone screen on motivation and customer service.",
    skills: ['communication', 'operations'],
  },
  'calix-internship-guide': {
    family: 'software',
    processLine:
      'Calix starts with a recruiter screen by phone or video on background, motivation and remote-first fit.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'campbells-internship-guide': {
    family: 'marketing',
    processLine:
      "Campbell's interviews are STAR-format behavioral, on teamwork, analytical thinking and brand passion.",
    skills: ['communication', 'marketing-strategy'],
  },
  'canva-internship-guide': {
    family: 'software',
    processLine: 'Canva kicks off with a 20-30 minute recruiter Zoom on your aspirations, experience and culture fit.',
    skills: ['ml-fundamentals', 'product-sense'],
  },
  'cape-cod-5-internship-guide': {
    family: 'finance',
    processLine: "Cape Cod 5 starts with a short phone or online screen; there's no case, online test or HireVue.",
    skills: ['case-structure', 'quant-reasoning'],
  },
  'capital-group-internship-guide': {
    family: 'finance',
    processLine:
      'Capital Group opens with a recruiter screen on your qualifications, interests, and why Capital Group.',
    skills: ['markets', 'coding-fundamentals'],
  },
  'capital-one-internship-guide': {
    family: 'finance',
    processLine:
      'Capital One has no classic first round: after an online assessment, Power Day mixes case, technical and behavioral.',
    skills: ['case-structure', 'sql-data'],
  },
  'capstone-internship-guide': {
    family: 'consulting',
    processLine:
      'Capstone starts with a 20-30 minute HR phone screen: why Capstone, why policy, what area interests you.',
    skills: ['case-structure', 'quant-reasoning'],
  },
  'captech-internship-guide': {
    family: 'consulting',
    processLine: 'CapTech starts with a roughly 30-minute recruiter screen with STAR-format behavioral questions.',
    skills: ['communication', 'sql-data'],
  },
  'cardinal-health-internship-guide': {
    family: 'other',
    processLine: 'Cardinal Health starts with a recruiter phone screen, described as mostly behavioral.',
    skills: ['communication', 'sql-data'],
  },
  'caresource-internship-guide': {
    family: 'data-analytics',
    processLine:
      'CareSource starts with a 20-30 minute recruiter phone screen on your interest in CareSource and Medicaid.',
    skills: ['sql-data', 'markets'],
  },
  'carmax-internship-guide': {
    family: 'software',
    processLine: 'CarMax starts with a short recruiter or HR phone screen on background, track motivation and fit.',
    skills: ['sql-data', 'coding-fundamentals'],
  },
  'carnival-internship-guide': {
    family: 'other',
    processLine: 'Carnival opens with an on-demand HireVue video interview.',
    skills: ['communication', 'excel'],
  },
  'carrier-internship-guide': {
    family: 'operations',
    processLine: 'Carrier sends a recorded HireVue video interview very early, sometimes the day after you apply.',
    skills: ['communication', 'supply-chain'],
  },
  'carvana-internship-guide': {
    family: 'other',
    processLine:
      'Carvana starts with a recruiter phone screen on motivation, fit and logistics; no online assessment is documented.',
    skills: ['product-sense', 'case-structure'],
  },
  'caseys-internship-guide': {
    family: 'other',
    processLine:
      "Casey's starts with a phone or video screen with an HR recruiter on your background and interest in Casey's.",
    skills: ['sql-data', 'marketing-strategy'],
  },
  'caterpillar-internship-guide': {
    family: 'operations',
    processLine:
      'Caterpillar starts with a 15-30 minute recruiter screen on qualifications, motivation and location flexibility.',
    skills: ['operations', 'case-structure'],
  },
  'cbiz-internship-guide': {
    family: 'accounting-firm',
    processLine: 'CBIZ opens with a 15-20 minute recruiter fit check: why CBIZ, why this office, your target track.',
    skills: ['accounting', 'excel'],
  },
  'cboe-internship-guide': {
    family: 'data-analytics',
    processLine:
      "Cboe's first interview is a 30-minute video call on your experience and skills, plus technical depth for some roles.",
    skills: ['sql-data', 'markets'],
  },
  'cbre-internship-guide': {
    family: 'finance',
    processLine:
      'CBRE reviews applicants in a batch, then runs digital interviews before a one-on-one Zoom second round.',
    skills: ['case-structure', 'financial-modeling'],
  },
  'cdk-global-internship-guide': {
    family: 'software',
    processLine: 'CDK Global starts with a 15-minute recruiter phone screen with its Early Career Talent Team.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'cdm-smith-internship-guide': {
    family: 'operations',
    processLine:
      "CDM Smith's intern interviews are behavioral, on coursework, teamwork and projects; no coding tests are reported.",
    skills: ['operations', 'excel'],
  },
  'cdw-internship-guide': {
    family: 'software',
    processLine: 'CDW starts with a recruiter screen or a prerecorded HireVue-style video of about four questions.',
    skills: ['communication', 'sql-data'],
  },
  'cedar-internship-guide': {
    family: 'software',
    processLine:
      'Cedar starts with a recruiter phone screen on your background and a genuine why-healthcare, why-Cedar filter.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'celanese-internship-guide': {
    family: 'operations',
    processLine:
      'Celanese starts with a recruiter phone or video screen on your background, interest in Celanese and availability.',
    skills: ['operations', 'excel'],
  },
  'cencora-internship-guide': {
    family: 'other',
    processLine:
      'Cencora opens with a HireVue of 3-5 behavioral questions, sometimes replaced by a 20-30 minute recruiter call.',
    skills: ['operations', 'quant-reasoning'],
  },
  'centene-internship-guide': {
    family: 'data-analytics',
    processLine:
      'Centene starts with a recruiter phone call or panel interview; no coding assessment is reported for interns.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'centerpoint-energy-internship-guide': {
    family: 'operations',
    processLine: "CenterPoint's intern interviews are behavioral, often about 30 minutes with department heads.",
    skills: ['communication', 'excel'],
  },
  'centerview-internship-guide': {
    family: 'finance',
    processLine:
      "Centerview's first round is a 30-45 minute phone or Zoom interview mixing behavioral and DCF-level technicals.",
    skills: ['valuation', 'financial-modeling'],
  },
  'central-intelligence-agency-internship-guide': {
    family: 'other',
    processLine:
      'CIA interviews often start with a round involving multiple candidates, then one-on-ones with the directorate.',
    skills: ['case-structure', 'research'],
  },
  'centric-brands-internship-guide': {
    family: 'marketing',
    processLine:
      'Centric Brands runs at least one interview with a hiring manager or mentor from your target department.',
    skills: ['marketing-strategy', 'product-sense'],
  },
  'cerebras-internship-guide': {
    family: 'software',
    processLine:
      'Cerebras starts with a 45-60 minute screen with the hiring manager on background and basic technical questions.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'cg-tax-audit-advisory-internship-guide': {
    family: 'accounting-firm',
    processLine: 'CG starts with a phone or video screen with the recruiting team about your background.',
    skills: ['accounting', 'tax'],
  },
  'ch-robinson-internship-guide': {
    family: 'operations',
    processLine:
      'C.H. Robinson starts with a recruiter phone screen on your background, interest in logistics and role fit.',
    skills: ['excel', 'operations'],
  },
  'character-ai-internship-guide': {
    family: 'ai-ml',
    processLine:
      'Character AI starts with a roughly 30-minute recruiter screen on motivation and your interest in consumer AI.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'charles-river-associates-internship-guide': {
    family: 'consulting',
    processLine: "CRA's first round is a 45-minute virtual interview: behavioral questions plus a mini economics case.",
    skills: ['case-structure', 'quant-reasoning'],
  },
  'charles-schwab-internship-guide': {
    family: 'finance',
    processLine: 'Schwab starts with a Talent Advisor phone screen on the role, logistics and your availability.',
    skills: ['sql-data', 'quant-reasoning'],
  },
  'charter-communications-internship-guide': {
    family: 'other',
    processLine:
      "Spectrum's first interview is a one-way video of about five behavioral questions, after a required video intro.",
    skills: ['communication', 'sql-data'],
  },
  'checkr-internship-guide': {
    family: 'software',
    processLine:
      'Checkr starts with a recruiter screen on motivation, logistics, and why background-check infrastructure.',
    skills: ['coding-fundamentals', 'product-sense'],
  },
  'cheniere-energy-internship-guide': {
    family: 'operations',
    processLine: 'Cheniere opens with a HireVue of pre-recorded STAR behavioral questions, about 3 minutes per answer.',
    skills: ['communication', 'operations'],
  },
  'cherry-bekaert-internship-guide': {
    family: 'accounting-firm',
    processLine: 'Cherry Bekaert starts with a 15-20 minute phone or video screen with a recruiter.',
    skills: ['accounting', 'excel'],
  },
  'chevron-internship-guide': {
    family: 'operations',
    processLine:
      'Chevron starts with a brief recruiter screening, on campus or virtual, then STAR behavioral interviews.',
    skills: ['communication', 'case-structure'],
  },
  'chewy-internship-guide': {
    family: 'software',
    processLine:
      "Chewy's recruiter chat is about 30 minutes on background and interest, after a HackerRank assessment.",
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'childrens-minnesota-internship-guide': {
    family: 'other',
    processLine:
      "Children's Minnesota interviews with the clinical team, using scenarios about distressed children and families.",
    skills: ['operations', 'quant-reasoning'],
  },
  'chime-internship-guide': {
    family: 'software',
    processLine: "Chime's first round is a 45-60 minute technical phone screen on data structures and algorithms.",
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'chipotle-internship-guide': {
    family: 'other',
    processLine: 'Chipotle opens with a 20-30 minute on-demand video screen of behavioral questions.',
    skills: ['communication', 'case-structure'],
  },
  'chs-internship-guide': {
    family: 'operations',
    processLine:
      'CHS starts with a 20-30 minute phone or video screen on your background and interest in the cooperative.',
    skills: ['quant-reasoning', 'excel'],
  },
  'cibc-internship-guide': {
    family: 'finance',
    processLine:
      'CIBC starts with a recruiter phone or video screen on motivation and experience, after an online assessment.',
    skills: ['financial-modeling', 'sql-data'],
  },
  'cigna-internship-guide': {
    family: 'finance',
    processLine: "Cigna's first interview is an informal, roughly one-hour phone or video fit interview with an FSA.",
    skills: ['sql-data', 'statistics'],
  },
  'cincinnati-financial-internship-guide': {
    family: 'finance',
    processLine:
      'Cincinnati Financial starts with an HR phone or video screen on your background, interests and culture fit.',
    skills: ['sql-data', 'case-structure'],
  },
  'cintas-internship-guide': {
    family: 'operations',
    processLine:
      'Cintas usually starts with a phone screen of straightforward behavioral questions, like what you know about Cintas.',
    skills: ['communication', 'operations'],
  },
  'cisco-internship-guide': {
    family: 'software',
    processLine: "Cisco's first interviews are two 45-60 minute technical rounds, after a HackerRank assessment.",
    skills: ['coding-fundamentals', 'product-sense'],
  },
  'citadel-internship-guide': {
    family: 'finance',
    processLine: "Citadel's first round is a 45-60 minute technical video interview, after an online assessment.",
    skills: ['sql-data', 'quant-reasoning'],
  },
  'citi-internship-guide': {
    family: 'finance',
    processLine:
      "Citi's first round is a recorded digital interview: 3-5 video questions plus a situational judgment section.",
    skills: ['coding-fundamentals', 'markets'],
  },
  'citizens-financial-internship-guide': {
    family: 'finance',
    processLine: 'Citizens opens with a self-guided video interview you must complete within 4 days.',
    skills: ['markets', 'sql-data'],
  },
  'clearview-healthcare-partners-internship-guide': {
    family: 'consulting',
    processLine:
      "ClearView's case interview tests problem-solving and quantitative reasoning on a life-sciences problem.",
    skills: ['case-structure', 'market-sizing'],
  },
  'cleveland-cliffs-internship-guide': {
    family: 'operations',
    processLine: 'Cleveland-Cliffs starts with a phone interview after resume review, then an onsite interview.',
    skills: ['operations', 'quant-reasoning'],
  },
  'clorox-internship-guide': {
    family: 'marketing',
    processLine: 'Clorox starts with a recruiter phone screen confirming the role, your background and basic fit.',
    skills: ['consumer-insight', 'marketing-strategy'],
  },
  'cloudflare-internship-guide': {
    family: 'software',
    processLine: "Cloudflare's recruiter screen is 20-30 minutes and non-technical, after a HackerRank assessment.",
    skills: ['coding-fundamentals', 'product-sense'],
  },
  'cme-group-internship-guide': {
    family: 'finance',
    processLine:
      "CME's technology track starts with a coding pre-assessment, then virtual coding and behavioral interviews.",
    skills: ['coding-fundamentals', 'markets'],
  },
  'cms-energy-internship-guide': {
    family: 'operations',
    processLine: "Consumers Energy's first-round interview is behavioral, on teamwork, problem-solving and leadership.",
    skills: ['communication', 'case-structure'],
  },
  'cna-financial-internship-guide': {
    family: 'finance',
    processLine: null,
    skills: ['case-structure', 'coding-fundamentals'],
  },
  'coca-cola-internship-guide': {
    family: 'marketing',
    processLine: 'Coca-Cola starts with a recruiter call: eligibility, availability, motivation, and why Coca-Cola.',
    skills: ['marketing-strategy', 'consumer-insight'],
  },
  'cockroach-labs-internship-guide': {
    family: 'software',
    processLine:
      'Cockroach Labs starts with a roughly 30-minute recruiter screen; after it, your resume is withheld from the team.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'cognition-internship-guide': {
    family: 'ai-ml',
    processLine: null,
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'cognizant-internship-guide': {
    family: 'consulting',
    processLine:
      'Cognizant starts with a 20-30 minute recruiter screen on your background and interest in Cognizant, mostly behavioral.',
    skills: ['communication', 'sql-data'],
  },
  'cohere-internship-guide': {
    family: 'ai-ml',
    processLine:
      'Cohere starts with a 30-minute recruiter screen on background, motivation and logistics; it is not technical.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'cohnreznick-internship-guide': {
    family: 'accounting-firm',
    processLine:
      'CohnReznick starts with a recruiter or video screen, then mostly behavioral interviews with basic accounting questions.',
    skills: ['accounting', 'case-structure'],
  },
  'coinbase-internship-guide': {
    family: 'software',
    processLine:
      "Coinbase's recruiter screen is 15-30 minutes on background, motivation and crypto interest, after a CodeSignal OA.",
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'colgate-palmolive-internship-guide': {
    family: 'marketing',
    processLine: 'Colgate starts with a behavioral recruiter screen on motivation, availability and fit.',
    skills: ['communication', 'marketing-analytics'],
  },
  'college-works-painting-internship-guide': {
    family: 'other',
    processLine:
      'College Works starts with a 15-20 minute phone screen on your interest, availability and general sales aptitude.',
    skills: ['case-structure', 'marketing-strategy'],
  },
  'collins-aerospace-internship-guide': {
    family: 'operations',
    processLine:
      'Collins invites qualified candidates to a virtual, behavioral-heavy interview, often a friendly panel.',
    skills: ['communication', 'case-structure'],
  },
  'comcast-internship-guide': {
    family: 'other',
    processLine: 'Comcast opens with a one-way HireVue: 4-6 behavioral questions including why Comcast.',
    skills: ['case-structure', 'sql-data'],
  },
  'comfort-systems-usa-internship-guide': { family: 'operations', processLine: null, skills: ['excel', 'operations'] },
  'community-health-systems-internship-guide': {
    family: 'other',
    processLine: 'CHS starts with an HR phone screen on your background, interest in healthcare and availability.',
    skills: ['sql-data', 'case-structure'],
  },
  'compass-internship-guide': {
    family: 'software',
    processLine:
      'Compass starts with a 20-30 minute recruiter screen: background, why Compass and why real estate tech.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'conagra-brands-internship-guide': {
    family: 'marketing',
    processLine:
      'Conagra starts with a roughly 30-minute recruiter screen, by phone or one-way video, of behavioral questions.',
    skills: ['communication', 'consumer-insight'],
  },
  'concentrix-internship-guide': {
    family: 'other',
    processLine:
      "Concentrix's first screen is a brief phone or video interview, often one STAR question, after a Harver assessment.",
    skills: ['sql-data', 'case-structure'],
  },
  'confluent-internship-guide': {
    family: 'software',
    processLine:
      "Confluent's recruiter screen is 30-60 minutes on background and fit; some candidates get a HackerRank OA first.",
    skills: ['coding-fundamentals', 'product-sense'],
  },
  'conocophillips-internship-guide': {
    family: 'operations',
    processLine: "ConocoPhillips' first round is a 30-minute behavioral STAR interview, usually on campus.",
    skills: ['communication', 'quant-reasoning'],
  },
  'consolidated-edison-internship-guide': {
    family: 'operations',
    processLine: 'Con Edison uses a behavioral events interview and recommends practicing STAR-format answers.',
    skills: ['communication', 'operations'],
  },
  'constellation-brands-internship-guide': {
    family: 'marketing',
    processLine:
      'Constellation starts with a 20-30 minute recruiter call on motivation, role fit and behavioral basics.',
    skills: ['communication', 'marketing-strategy'],
  },
  'constellation-energy-internship-guide': {
    family: 'operations',
    processLine:
      'Constellation starts with a 15-30 minute recruiter screen on your qualifications, interest and logistics.',
    skills: ['quant-reasoning', 'operations'],
  },
  'contextual-ai-internship-guide': {
    family: 'ai-ml',
    processLine:
      'Contextual AI starts with a roughly 30-minute call on your research background, technical interests and motivation.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'corebridge-financial-internship-guide': {
    family: 'finance',
    processLine:
      'Corebridge starts with an HR phone screen on the role and your qualifications; actuarial candidates discuss SOA exams.',
    skills: ['financial-modeling', 'sql-data'],
  },
  'coreweave-internship-guide': {
    family: 'software',
    processLine:
      'CoreWeave starts with a roughly 30-minute recruiter screen on background, motivation and interest in its mission.',
    skills: ['coding-fundamentals', 'product-sense'],
  },
  'corient-internship-guide': {
    family: 'finance',
    processLine: "Corient's first round is an HR behavioral screen on motivation, background and basic qualifications.",
    skills: ['communication', 'markets'],
  },
  'cornerstone-research-internship-guide': {
    family: 'consulting',
    processLine:
      "Cornerstone's first round is two 30-minute virtual interviews, each about 10 minutes behavioral and 20 minutes case.",
    skills: ['case-structure', 'sql-data'],
  },
  'corning-internship-guide': {
    family: 'operations',
    processLine:
      'Corning starts with a recruiter or HR phone screen of basic fit questions, like why you want to work there.',
    skills: ['communication', 'supply-chain'],
  },
  'corteva-internship-guide': {
    family: 'other',
    processLine:
      "Corteva's interviews mix behavioral questions on teamwork and agriculture with technical questions for your discipline.",
    skills: ['sql-data', 'research'],
  },
  'costco-internship-guide': {
    family: 'software',
    processLine:
      'Costco starts with a roughly 30-minute HR phone screen on your background, experience and motivation.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'coty-internship-guide': {
    family: 'operations',
    processLine:
      'Coty starts with a 15-30 minute recruiter screen on your interest in manufacturing, availability and basic fit.',
    skills: ['operations', 'supply-chain'],
  },
  'coupang-internship-guide': {
    family: 'software',
    processLine:
      "Coupang's recruiter screen is about 30 minutes on background and role fit, after a HackerRank assessment.",
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'cowen-group-internship-guide': {
    family: 'finance',
    processLine:
      "TD Cowen's first round is a 30-minute call with a banker: behavioral plus intro technicals like a DCF walkthrough.",
    skills: ['valuation', 'financial-modeling'],
  },
  'cox-enterprises-internship-guide': {
    family: 'other',
    processLine: 'Cox starts with a 15-30 minute recruiter phone screen on the role and your background.',
    skills: ['sql-data', 'operations'],
  },
  'credit-one-bank-internship-guide': {
    family: 'finance',
    processLine: 'Credit One starts with a phone interview on your background, interest in the bank and availability.',
    skills: ['sql-data', 'financial-modeling'],
  },
  'crestron-internship-guide': {
    family: 'software',
    processLine: 'Crestron starts with a brief recruiter call: your background, why AV automation and why Crestron.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'crowdstrike-internship-guide': {
    family: 'software',
    processLine:
      'CrowdStrike starts with a 15-30 minute recruiter screen on motivation and your interest in cybersecurity.',
    skills: ['sql-data', 'coding-fundamentals'],
  },
  'crowe-internship-guide': {
    family: 'accounting-firm',
    processLine:
      "Crowe's first interview is about 30 minutes on video, covering work history, education and activities.",
    skills: ['case-structure', 'tax'],
  },
  'crown-holdings-internship-guide': { family: 'operations', processLine: null, skills: ['operations', 'excel'] },
  'cruise-internship-guide': {
    family: 'software',
    processLine: "GM's autonomous-driving intern path usually opens with a one-way HireVue of behavioral questions.",
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'csx-internship-guide': {
    family: 'operations',
    processLine: "CSX's first filter is a recruiter phone or video screen, per community reports.",
    skills: ['operations', 'supply-chain'],
  },
  'cummins-internship-guide': {
    family: 'operations',
    processLine: 'Cummins opens with a recorded HireVue, mostly behavioral, on why you want to work at Cummins.',
    skills: ['operations', 'supply-chain'],
  },
  'cursor-internship-guide': {
    family: 'ai-ml',
    processLine:
      'Cursor starts with a 30-45 minute recruiter screen on motivation, product familiarity and culture fit.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'cushman-and-wakefield-internship-guide': {
    family: 'finance',
    processLine:
      'C&W starts with a 15-30 minute phone or video screen: why CRE, why C&W, and which market interests you.',
    skills: ['case-structure', 'financial-modeling'],
  },
  'cvs-health-internship-guide': {
    family: 'other',
    processLine:
      'CVS Health opens with an on-demand HireVue of behavioral questions tied to its Heart At Work Behaviors.',
    skills: ['sql-data', 'case-structure'],
  },
  'd-r-horton-internship-guide': {
    family: 'other',
    processLine:
      'D.R. Horton starts with a recruiter phone screen on motivation and fit, then a hiring manager interview.',
    skills: ['case-structure', 'excel'],
  },
  'danaher-internship-guide': {
    family: 'other',
    processLine:
      'Danaher starts with a recruiter phone or video screen confirming your background, availability and fit.',
    skills: ['sql-data', 'case-structure'],
  },
  'darden-restaurants-internship-guide': {
    family: 'other',
    processLine: null,
    skills: ['operations', 'quant-reasoning'],
  },
  'dassault-systemes-internship-guide': {
    family: 'software',
    processLine:
      'Dassault starts with a 20-30 minute recruiter screen on your background and interest in the specific brand.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'databricks-internship-guide': {
    family: 'software',
    processLine:
      "Databricks' first interviews are 1-2 CoderPad technical screens of 45-60 minutes, after a CodeSignal OA.",
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'datadog-internship-guide': {
    family: 'software',
    processLine:
      "Datadog's first interview is a 45-60 minute live coding session with an engineer, after a HackerRank test.",
    skills: ['coding-fundamentals', 'product-sense'],
  },
  'davita-internship-guide': {
    family: 'consulting',
    processLine: 'DaVita Redwoods pairs a behavioral STAR round with a healthcare case interview.',
    skills: ['case-structure', 'sql-data'],
  },
  'dbt-labs-internship-guide': {
    family: 'software',
    processLine: "dbt Labs' full-time loop starts with a recruiter screen on background, motivation and role fit.",
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'ddb-internship-guide': {
    family: 'marketing',
    processLine:
      'DDB starts with a recruiter screen on interest and fit; creative recruiters review your portfolio there.',
    skills: ['marketing-strategy', 'consumer-insight'],
  },
  'de-shaw-internship-guide': {
    family: 'finance',
    processLine: "D.E. Shaw's first interviews test coding and CS fundamentals, after a hard HackerRank assessment.",
    skills: ['coding-fundamentals', 'quant-reasoning'],
  },
  'decagon-internship-guide': {
    family: 'ai-ml',
    processLine:
      'Decagon starts with a 30-minute recruiter call on your background, interest in Decagon and logistics.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'deel-internship-guide': {
    family: 'software',
    processLine:
      'Deel starts with a 15-30 minute recruiter screen on your motivations, background and communication skills.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'deepl-internship-guide': {
    family: 'ai-ml',
    processLine:
      'DeepL starts with a virtual recruiter screen on your motivations, background and fit with its values.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'deere-internship-guide': {
    family: 'operations',
    processLine:
      'Deere starts with an HR or recruiter phone screen: experience, motivation and what you know about the company.',
    skills: ['operations', 'case-structure'],
  },
  'delek-us-internship-guide': {
    family: 'operations',
    processLine:
      'Delek starts with an HR phone or video screen on your motivation, background and basic qualifications.',
    skills: ['case-structure', 'operations'],
  },
  'dell-technologies-internship-guide': {
    family: 'software',
    processLine:
      "Dell's recruiter screen is 20-30 minutes on your resume and motivation, after a HackerRank or video assessment.",
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'deloitte-internship-guide': {
    family: 'accounting-firm',
    processLine:
      'Deloitte runs two 30-45 minute live interviews with practitioners, sometimes after a one-way video of 4-6 prompts.',
    skills: ['communication', 'case-structure'],
  },
  'delta-air-lines-internship-guide': {
    family: 'other',
    processLine:
      'Delta opens with a digital assessment: a HireVue-style video plus situational judgment and values questions.',
    skills: ['sql-data', 'operations'],
  },
  'deutsche-bank-internship-guide': {
    family: 'finance',
    processLine:
      "Deutsche Bank's first interview is a pre-recorded HireVue of 3-8 questions, after SJT and reasoning tests.",
    skills: ['markets', 'financial-modeling'],
  },
  'devon-energy-internship-guide': {
    family: 'operations',
    processLine: null,
    skills: ['case-structure', 'operations'],
  },
  'diageo-internship-guide': {
    family: 'marketing',
    processLine: 'Diageo opens with a roughly 30-minute HireVue of motivational, competency and situational questions.',
    skills: ['marketing-strategy', 'consumer-insight'],
  },
  'diamondback-energy-internship-guide': {
    family: 'operations',
    processLine: "Diamondback's intern interview is a group panel of STAR behavioral questions.",
    skills: ['communication', 'excel'],
  },
  'dicks-sporting-goods-internship-guide': {
    family: 'other',
    processLine: "Dick's starts with a 15-20 minute recruiter call on your background, why retail and why Dick's.",
    skills: ['sql-data', 'product-sense'],
  },
  'dime-community-bank-internship-guide': {
    family: 'finance',
    processLine: 'Dime starts with an HR phone screen: why community banking, why Dime, and your availability.',
    skills: ['markets', 'sql-data'],
  },
  'discord-internship-guide': {
    family: 'software',
    processLine:
      'Discord starts with a roughly 30-minute recruiter screen on eligibility, compensation and team preferences.',
    skills: ['coding-fundamentals', 'product-sense'],
  },
  'disney-internship-guide': {
    family: 'software',
    processLine: "Disney's tech track starts with a 20-30 minute recruiter screen on motivation and project alignment.",
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'docker-internship-guide': {
    family: 'software',
    processLine:
      'Docker starts with a recruiter phone screen on background, experience match and compensation expectations.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'docusign-internship-guide': {
    family: 'software',
    processLine:
      'DocuSign starts with a roughly 30-minute recruiter screen on background, motivation and basic behavioral questions.',
    skills: ['communication', 'coding-fundamentals'],
  },
  'dolby-internship-guide': {
    family: 'software',
    processLine:
      "Dolby's recruiter screen is a short non-technical call, after a basic coding test for technical roles.",
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'dollar-general-internship-guide': {
    family: 'other',
    processLine:
      'Dollar General is expected to start with a recruiter screen on your background and its Serving Others culture.',
    skills: ['sql-data', 'case-structure'],
  },
  'dollar-tree-internship-guide': {
    family: 'other',
    processLine: 'Dollar Tree likely starts with a short recruiter screen, including why discount retail.',
    skills: ['sql-data', 'product-sense'],
  },
  'dominion-energy-internship-guide': {
    family: 'operations',
    processLine: 'Dominion starts with a 15-30 minute recruiter screen on eligibility, graduation date and interest.',
    skills: ['operations', 'quant-reasoning'],
  },
  'doordash-internship-guide': {
    family: 'software',
    processLine:
      "DoorDash's recruiter screen is 30-45 minutes of behavioral questions, after a CodeSignal or HackerRank OA.",
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'dormakaba-internship-guide': {
    family: 'operations',
    processLine:
      'dormakaba starts with a recruiter phone or video screen on your background, interests and culture fit.',
    skills: ['excel', 'operations'],
  },
  'dow-internship-guide': {
    family: 'operations',
    processLine: 'Dow starts with an HR phone call confirming the role, location and fit.',
    skills: ['case-structure', 'operations'],
  },
  'dow-jones-internship-guide': {
    family: 'finance',
    processLine:
      'Dow Jones usually starts with a short phone or recruiter screen confirming the role and your background.',
    skills: ['financial-modeling', 'sql-data'],
  },
  'drata-internship-guide': {
    family: 'software',
    processLine:
      "Drata's full-time loop starts with a recruiter call on background, career goals and how you use AI tools.",
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'dreamworks-internship-guide': {
    family: 'other',
    processLine: 'DreamWorks typically runs a recruiter phone screen, then a video interview with hiring managers.',
    skills: ['consumer-insight', 'marketing-strategy'],
  },
  'droga5-internship-guide': {
    family: 'marketing',
    processLine:
      'Droga5 typically starts with a recruiter phone screen, then team interviews and a portfolio walk-through.',
    skills: ['marketing-strategy', 'consumer-insight'],
  },
  'dropbox-internship-guide': {
    family: 'software',
    processLine: "Dropbox's recruiter screen is about 20 minutes, after a 90-minute CodeSignal assessment.",
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'drw-internship-guide': {
    family: 'finance',
    processLine:
      "DRW's phone interview with a developer, trader or researcher mixes technical and behavioral questions.",
    skills: ['statistics', 'sql-data'],
  },
  'dtcc-internship-guide': {
    family: 'finance',
    processLine: 'DTCC opens with a recorded HireVue of timed behavioral questions.',
    skills: ['communication', 'markets'],
  },
  'dte-energy-internship-guide': {
    family: 'operations',
    processLine:
      "DTE's interview is behavioral in STAR format: teamwork, problem-solving, initiative and handling stress.",
    skills: ['communication', 'case-structure'],
  },
  'duke-energy-internship-guide': {
    family: 'operations',
    processLine:
      'Duke Energy starts with a roughly 30-minute phone screen on your background, interest in energy and the role.',
    skills: ['case-structure', 'operations'],
  },
  'duolingo-internship-guide': {
    family: 'software',
    processLine:
      "Duolingo's first live round is a 60-minute coding interview with an engineer, after a CodeSignal assessment.",
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'dupont-internship-guide': {
    family: 'operations',
    processLine: 'DuPont starts with an HR or recruiter phone screen on basic fit and logistics.',
    skills: ['operations', 'supply-chain'],
  },
  'dxc-technology-internship-guide': {
    family: 'software',
    processLine:
      'DXC starts with a 20-30 minute HR screen on your background, motivation for IT services and role fit.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'eastman-chemical-internship-guide': {
    family: 'operations',
    processLine: 'Eastman starts with a 20-30 minute recruiter call verifying eligibility, interest and availability.',
    skills: ['operations', 'supply-chain'],
  },
  'eaton-internship-guide': {
    family: 'operations',
    processLine:
      'Eaton runs a single hour-long interview with two interviewers, mixing STAR behavioral and technical questions.',
    skills: ['case-structure', 'operations'],
  },
  'ebay-internship-guide': {
    family: 'software',
    processLine: 'eBay starts with a 20-30 minute recruiter screen on background, motivation and visa status.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'echostar-internship-guide': {
    family: 'software',
    processLine:
      'EchoStar starts with a recruiter phone or video call on your background, interest in EchoStar and availability.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'ecolab-internship-guide': {
    family: 'operations',
    processLine: 'Ecolab starts with a recruiter phone screen confirming role fit, timeline and location.',
    skills: ['operations', 'supply-chain'],
  },
  'edelman-internship-guide': {
    family: 'marketing',
    processLine:
      'Edelman starts with a recruiter phone or video interview on your interest in PR and your writing background.',
    skills: ['marketing-strategy', 'consumer-insight'],
  },
  'edison-international-internship-guide': {
    family: 'operations',
    processLine: "SCE's recruiter phone screen follows an online assessment emailed shortly after you apply.",
    skills: ['case-structure', 'quant-reasoning'],
  },
  'edward-jones-internship-guide': {
    family: 'finance',
    processLine:
      'Edward Jones opens with a recorded video interview: short behavioral prompts, about 2 minutes per answer.',
    skills: ['communication', 'case-structure'],
  },
  'eide-bailly-internship-guide': {
    family: 'accounting-firm',
    processLine: 'Eide Bailly starts with a 15-20 minute recruiter call on your career interests and goals.',
    skills: ['accounting', 'audit'],
  },
  'eisneramper-internship-guide': {
    family: 'accounting-firm',
    processLine:
      "EisnerAmper's first round is a 30-45 minute behavioral interview: why accounting, why EisnerAmper, CPA plans.",
    skills: ['accounting', 'excel'],
  },
  'electronic-arts-internship-guide': {
    family: 'software',
    processLine: 'EA opens with a recruiter call on your background, interest and logistics.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'elevance-health-internship-guide': {
    family: 'other',
    processLine:
      'Elevance opens with an asynchronous HireVue of roughly 3-5 behavioral questions, like why healthcare.',
    skills: ['communication', 'excel'],
  },
  'elevenlabs-internship-guide': {
    family: 'ai-ml',
    processLine:
      'ElevenLabs starts with a 30-minute recruiter screen built around one question: what have you built end to end?',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'eli-lilly-internship-guide': {
    family: 'other',
    processLine: 'Eli Lilly starts with a 20-30 minute recruiter phone screen on background, motivation and logistics.',
    skills: ['case-structure', 'sql-data'],
  },
  'emcor-internship-guide': {
    family: 'operations',
    processLine: "EMCOR starts with a phone or video screen with the subsidiary's HR on your interest in construction.",
    skills: ['excel', 'operations'],
  },
  'emerson-electric-internship-guide': {
    family: 'operations',
    processLine:
      'Emerson starts with a recruiter phone or video screen: motivation, resume walk-through and technical fit.',
    skills: ['operations', 'quant-reasoning'],
  },
  'endeavor-internship-guide': {
    family: 'other',
    processLine: 'WME runs two or more interview rounds, with questions on your entertainment industry knowledge.',
    skills: ['sql-data', 'excel'],
  },
  'energy-transfer-internship-guide': {
    family: 'operations',
    processLine:
      'Energy Transfer starts with a recruiter phone or video screen on your background, interest and logistics.',
    skills: ['case-structure', 'excel'],
  },
  'enersys-internship-guide': {
    family: 'operations',
    processLine: 'EnerSys runs one screening call, then one interview with the supervisor, often virtual.',
    skills: ['operations', 'supply-chain'],
  },
  'enphase-energy-internship-guide': {
    family: 'software',
    processLine:
      "Enphase's recruiter screen covers why Enphase, your background and role fit; software tracks take an OA first.",
    skills: ['coding-fundamentals', 'product-sense'],
  },
  'entergy-internship-guide': {
    family: 'operations',
    processLine:
      'Entergy starts with a 15-30 minute personality-focused recruiter screen on eligibility, interest and logistics.',
    skills: ['excel', 'operations'],
  },
  'enterprise-products-partners-internship-guide': {
    family: 'operations',
    processLine:
      "Enterprise's intern interview is a short, casual one-on-one behavioral conversation about school and yourself.",
    skills: ['communication', 'supply-chain'],
  },
  'eog-resources-internship-guide': {
    family: 'operations',
    processLine: 'EOG starts with a phone or video screen on your background, interest in EOG and availability.',
    skills: ['case-structure', 'excel'],
  },
  'epic-games-internship-guide': {
    family: 'software',
    processLine:
      "Epic's recruiter screen is about 30 minutes on your background and passion for games, after a take-home assessment.",
    skills: ['coding-fundamentals', 'product-sense'],
  },
  'epic-systems-internship-guide': {
    family: 'software',
    processLine: "Epic's interview is one conversational final round, after the timed Sphinx skills assessment.",
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'epri-internship-guide': {
    family: 'operations',
    processLine:
      "EPRI's screen is a one-way recorded video or a live recruiter call on your background and interest in energy research.",
    skills: ['communication', 'operations'],
  },
  'eqt-internship-guide': {
    family: 'finance',
    processLine:
      "EQT's interviews are pre-recorded video interviews and panel discussions on your analytics skills and energy interest.",
    skills: ['sql-data', 'financial-modeling'],
  },
  'equinix-internship-guide': {
    family: 'operations',
    processLine:
      'Equinix starts with a 15-30 minute recruiter screen on qualifications, location and comfort with on-site facility work.',
    skills: ['quant-reasoning', 'operations'],
  },
  'equipmentshare-internship-guide': {
    family: 'other',
    processLine:
      'EquipmentShare starts with a recruiter conversation about your background, career goals and interests.',
    skills: ['case-structure', 'sql-data'],
  },
  'equitable-internship-guide': {
    family: 'finance',
    processLine: 'Equitable runs 1-2 conversational interviews with two interviewers each, after an AI resume screen.',
    skills: ['markets', 'quant-reasoning'],
  },
  'ericsson-internship-guide': {
    family: 'software',
    processLine: 'Ericsson starts with a 20-30 minute recruiter call on your background, why telecom and why Ericsson.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'erie-insurance-internship-guide': {
    family: 'finance',
    processLine: 'Erie opens with a one-way HireVue of behavioral questions, then a live panel of 3-4 team members.',
    skills: ['communication', 'sql-data'],
  },
  'espn-internship-guide': {
    family: 'marketing',
    processLine:
      "ESPN's most common first stage is a phone interview on fit, sports knowledge and cohort availability.",
    skills: ['product-sense', 'marketing-strategy'],
  },
  'estee-lauder-internship-guide': {
    family: 'marketing',
    processLine: 'Estee Lauder opens with a one-way HireVue of behavioral questions, sent right after you apply.',
    skills: ['communication', 'marketing-strategy'],
  },
  'etsy-internship-guide': {
    family: 'software',
    processLine: 'Etsy starts with a 20-30 minute recruiter call on fit and why Etsy; it is not a technical test.',
    skills: ['coding-fundamentals', 'product-sense'],
  },
  'evercore-internship-guide': {
    family: 'finance',
    processLine:
      "Evercore's first round is two 30-minute interviews: behavioral plus accounting, valuation and merger-math technicals.",
    skills: ['accounting', 'valuation'],
  },
  'evergy-internship-guide': {
    family: 'operations',
    processLine:
      "Evergy's interview is behavioral, sometimes a group panel, with STAR questions on teamwork and problem-solving.",
    skills: ['communication', 'case-structure'],
  },
  'eversource-energy-internship-guide': {
    family: 'operations',
    processLine: 'Eversource runs one roughly 30-minute conversational behavioral interview with the hiring manager.',
    skills: ['communication', 'operations'],
  },
  'exelon-internship-guide': {
    family: 'operations',
    processLine: 'Exelon starts with an initial screen by phone or recorded video, then a panel interview.',
    skills: ['case-structure', 'quant-reasoning'],
  },
  'expand-energy-internship-guide': {
    family: 'operations',
    processLine:
      'Expand Energy starts with an HR phone or video screen on your background, interests and technical skills.',
    skills: ['supply-chain', 'excel'],
  },
  'expedia-internship-guide': {
    family: 'software',
    processLine: 'Expedia opens with a 45-60 minute strengths-based situational judgment test, then a coding test.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'expeditors-internship-guide': {
    family: 'operations',
    processLine:
      'Expeditors interviews at the district level, with behavioral questions about problem-solving and teamwork.',
    skills: ['communication', 'excel'],
  },
  'exxonmobil-internship-guide': {
    family: 'operations',
    processLine:
      "ExxonMobil's first interview is a 30-45 minute STAR behavioral call, after an SHL aptitude assessment.",
    skills: ['case-structure', 'operations'],
  },
  'ey-internship-guide': {
    family: 'accounting-firm',
    processLine:
      "EY's first interview is a pre-recorded HireVue with 3-5 behavioral questions, after an online skills assessment.",
    skills: ['accounting', 'audit'],
  },
  'ey-parthenon-internship-guide': {
    family: 'consulting',
    processLine:
      "EY-Parthenon's first round is behavioral and case interviews with several EY-Parthenon professionals.",
    skills: ['case-structure', 'excel'],
  },
  'factset-internship-guide': {
    family: 'software',
    processLine:
      'FactSet runs recruiter and hiring-manager rounds focused on skills and curiosity; SWE adds a technical assessment.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'fanduel-internship-guide': {
    family: 'data-analytics',
    processLine:
      "FanDuel's first interview is virtual with team stakeholders on role and fit, after a recruiter and HireVue screen.",
    skills: ['communication', 'sql-data'],
  },
  'fannie-mae-internship-guide': {
    family: 'finance',
    processLine: 'Fannie Mae starts with a 30-minute behavioral phone screen with a recruiter.',
    skills: ['communication', 'quant-reasoning'],
  },
  'farmers-insurance-internship-guide': {
    family: 'finance',
    processLine:
      'Farmers starts with an HR phone or video screen on teamwork, customer service and interest in insurance.',
    skills: ['communication', 'sql-data'],
  },
  'fastenal-internship-guide': {
    family: 'operations',
    processLine: "Fastenal's interview is an informal one-on-one or phone call with the branch manager.",
    skills: ['supply-chain', 'operations'],
  },
  'fedex-internship-guide': {
    family: 'operations',
    processLine:
      'FedEx starts with a short recruiter phone screen, then one or two mostly behavioral virtual interviews.',
    skills: ['communication', 'excel'],
  },
  'ferguson-internship-guide': {
    family: 'operations',
    processLine:
      'Ferguson opens with a HireVue text interview, then a recorded video interview, before a live recruiter call.',
    skills: ['communication', 'supply-chain'],
  },
  'ferrari-internship-guide': {
    family: 'operations',
    processLine: "Ferrari's first live step is an HR phone or Teams call confirming fit, motivation and logistics.",
    skills: ['quant-reasoning', 'operations'],
  },
  'fg-annuities-life-internship-guide': { family: 'finance', processLine: null, skills: ['accounting', 'valuation'] },
  'fidelity-internship-guide': {
    family: 'finance',
    processLine:
      'Fidelity starts with a recruiter phone screen, officially not an interview, confirming the role and pay line up.',
    skills: ['sql-data', 'quant-reasoning'],
  },
  'fifth-third-bancorp-internship-guide': {
    family: 'finance',
    processLine:
      "Fifth Third's first round is a 30-minute non-technical interview on interpersonal skills and leadership.",
    skills: ['case-structure', 'financial-modeling'],
  },
  'figma-internship-guide': {
    family: 'software',
    processLine: 'Figma starts with a 30-minute recruiter screen on your background and motivation for Figma.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'figure-ai-internship-guide': {
    family: 'ai-ml',
    processLine:
      'Figure AI starts with a 30-minute recruiter screen on motivation, why Figure and your interest in humanoid robotics.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'fireworks-ai-internship-guide': {
    family: 'ai-ml',
    processLine: 'Fireworks AI starts with a 30-minute recruiter screen, then a coding and ML-systems phone screen.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'first-citizens-bank-internship-guide': {
    family: 'finance',
    processLine:
      'First Citizens starts with a recruiter phone screen on your background, interests and fit with the program.',
    skills: ['accounting', 'markets'],
  },
  'first-solar-internship-guide': {
    family: 'operations',
    processLine: 'First Solar starts with a recruiter call by phone or Teams on your background, availability and fit.',
    skills: ['operations', 'supply-chain'],
  },
  'firstenergy-internship-guide': {
    family: 'operations',
    processLine:
      "FirstEnergy's interview is behavioral, with STAR questions on problem-solving, teamwork and leadership.",
    skills: ['communication', 'operations'],
  },
  'fis-internship-guide': {
    family: 'software',
    processLine: 'FIS starts with a 30-45 minute recruiter screen and video interview of behavioral STAR questions.',
    skills: ['communication', 'coding-fundamentals'],
  },
  'fiserv-internship-guide': {
    family: 'software',
    processLine:
      "Fiserv's first interview is a 30-minute technical call on OOP, DBMS and SQL, after a HackerRank assessment.",
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'five-rings-internship-guide': {
    family: 'finance',
    processLine:
      "Five Rings' first round is 10-15 rapid-fire math questions, 30 seconds each, after a timed online assessment.",
    skills: ['sql-data', 'statistics'],
  },
  'fivetran-internship-guide': {
    family: 'software',
    processLine:
      'Fivetran starts with a recruiter screen on background, motivation and role fit, then a live coding round.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'flatiron-health-internship-guide': {
    family: 'software',
    processLine:
      'Flatiron starts with a roughly 30-minute recruiter screen on your interest in healthcare tech and the mission.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'flex-internship-guide': {
    family: 'operations',
    processLine:
      "Flex's interviews commonly include a phone screen and a one-on-one technical interview; there is no online test.",
    skills: ['case-structure', 'excel'],
  },
  'florida-blue-internship-guide': {
    family: 'data-analytics',
    processLine: "Florida Blue's interviews are behavioral-heavy, relaxed panels with a few light technical questions.",
    skills: ['sql-data', 'statistics'],
  },
  'flow-traders-internship-guide': {
    family: 'finance',
    processLine:
      "Flow Traders' first interview is about 30 minutes with HR, after a timed mental math test for trading roles.",
    skills: ['quant-reasoning', 'coding-fundamentals'],
  },
  'fluor-internship-guide': {
    family: 'operations',
    processLine: 'Fluor starts with a 15-20 minute recruiter phone screen on eligibility, interest and availability.',
    skills: ['case-structure', 'quant-reasoning'],
  },
  'fm-global-internship-guide': {
    family: 'other',
    processLine:
      'FM runs multiple interview rounds that may include behavioral and technical questions, presentations or writing samples.',
    skills: ['sql-data', 'case-structure'],
  },
  'ford-internship-guide': {
    family: 'operations',
    processLine: "Ford's first conversation is a 15-30 minute phone screen, after the One Ford personality assessment.",
    skills: ['case-structure', 'excel'],
  },
  'fox-corporation-internship-guide': {
    family: 'other',
    processLine: 'Fox opens with a pre-recorded video interview, then a live hiring-manager interview.',
    skills: ['excel', 'case-structure'],
  },
  'frank-rimerman-internship-guide': {
    family: 'accounting-firm',
    processLine: "Frank, Rimerman's first round is a casual recruiter conversation focused on character and fit.",
    skills: ['accounting', 'audit'],
  },
  'franklin-resources-internship-guide': {
    family: 'finance',
    processLine:
      'Franklin Templeton starts with a roughly 30-minute video or phone screen on your background, interests and fit.',
    skills: ['markets', 'sql-data'],
  },
  'frazier-deeter-internship-guide': {
    family: 'accounting-firm',
    processLine: 'Frazier & Deeter interviews you with two partners, separately, then lunch with two associates.',
    skills: ['tax', 'audit'],
  },
  'freddie-mac-internship-guide': {
    family: 'finance',
    processLine: "Freddie Mac's first round is a pre-recorded video interview, not a live conversation.",
    skills: ['communication', 'sql-data'],
  },
  'freeman-internship-guide': {
    family: 'other',
    processLine: 'Freeman starts with an HR phone screen on your interest in Freeman and the events industry.',
    skills: ['operations', 'sql-data'],
  },
  'freeport-mcmoran-internship-guide': {
    family: 'operations',
    processLine:
      'Freeport-McMoRan opens with a one-way HireVue of behavioral and technical questions, recorded within 48 hours.',
    skills: ['excel', 'quant-reasoning'],
  },
  'friedkin-group-internship-guide': {
    family: 'other',
    processLine:
      'Friedkin starts with a recruiter phone or virtual screen on qualifications, availability and role fit.',
    skills: ['sql-data', 'operations'],
  },
  'ft-partners-internship-guide': {
    family: 'finance',
    processLine:
      "FT Partners' first round is virtual technical and behavioral interviews, after a mandatory cognitive assessment.",
    skills: ['valuation', 'financial-modeling'],
  },
  'fti-consulting-internship-guide': {
    family: 'consulting',
    processLine:
      'FTI starts with a pre-recorded video interview: why FTI, why this segment, and an analytical-problem story.',
    skills: ['quant-reasoning', 'excel'],
  },
  'gap-internship-guide': {
    family: 'marketing',
    processLine: 'Gap starts with a recruiter or HR phone screen; GapTech roles take an online assessment first.',
    skills: ['marketing-strategy', 'consumer-insight'],
  },
  'garmin-internship-guide': {
    family: 'software',
    processLine:
      'Garmin starts with a recruiter or HR phone screen, then a technical interview with live coding for software roles.',
    skills: ['coding-fundamentals', 'product-sense'],
  },
  'garrett-companies-internship-guide': {
    family: 'other',
    processLine: null,
    skills: ['operations', 'marketing-strategy'],
  },
  'gartner-internship-guide': {
    family: 'consulting',
    processLine:
      "Gartner's preliminary interview is a mostly behavioral recruiter screen, after a role-specific assessment.",
    skills: ['sql-data', 'case-structure'],
  },
  'ge-aerospace-internship-guide': {
    family: 'operations',
    processLine:
      'GE Aerospace starts with a recruiter or HR phone screen confirming enrollment, availability and clearance eligibility.',
    skills: ['supply-chain', 'excel'],
  },
  'ge-appliances-internship-guide': {
    family: 'operations',
    processLine:
      'GE Appliances starts with a 20-30 minute recruiter screen on eligibility, track and 2-3 STAR questions.',
    skills: ['communication', 'operations'],
  },
  'ge-healthcare-internship-guide': {
    family: 'other',
    processLine:
      'GE HealthCare starts with a recruiter phone screen, then one 30-60 minute behavioral and light technical interview.',
    skills: ['sql-data', 'quant-reasoning'],
  },
  'ge-vernova-internship-guide': {
    family: 'operations',
    processLine: 'GE Vernova starts with a recruiter screen, then behavioral and technical rounds over Zoom or Teams.',
    skills: ['case-structure', 'excel'],
  },
  'genentech-internship-guide': {
    family: 'other',
    processLine:
      'Genentech starts with a 15-30 minute HR phone screen on your background, why Genentech and career goals.',
    skills: ['sql-data', 'case-structure'],
  },
  'general-atlantic-internship-guide': {
    family: 'finance',
    processLine:
      'General Atlantic starts with a 30-minute HR screen: resume walkthrough, fit and interest in growth equity.',
    skills: ['communication', 'financial-modeling'],
  },
  'general-dynamics-internship-guide': {
    family: 'operations',
    processLine:
      'General Dynamics starts with a 15-30 minute phone screen on your background and interest in defense work.',
    skills: ['case-structure', 'operations'],
  },
  'general-electric-internship-guide': {
    family: 'operations',
    processLine: 'GE starts with a 15-30 minute recruiter phone screen on background, motivation and qualifications.',
    skills: ['case-structure', 'operations'],
  },
  'general-mills-internship-guide': {
    family: 'marketing',
    processLine: 'General Mills runs one to two STAR-format behavioral interview rounds.',
    skills: ['communication', 'marketing-strategy'],
  },
  'general-motors-internship-guide': {
    family: 'software',
    processLine:
      "GM's first interview is a 45-60 minute STAR behavioral round with managers, after a coding assessment for tech roles.",
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'genuine-parts-internship-guide': {
    family: 'operations',
    processLine:
      'Genuine Parts starts with a brief Talent Acquisition call on your qualifications, availability and role fit.',
    skills: ['supply-chain', 'operations'],
  },
  'gilead-sciences-internship-guide': {
    family: 'other',
    processLine:
      'Gilead starts with a 20-30 minute recruiter screen on motivation, availability and salary expectations.',
    skills: ['sql-data', 'case-structure'],
  },
  'gitlab-internship-guide': {
    family: 'software',
    processLine:
      'GitLab starts with an automated technical assessment, then a live technical interview on applied problem-solving.',
    skills: ['coding-fundamentals', 'product-sense'],
  },
  'glean-internship-guide': {
    family: 'software',
    processLine:
      "Glean's first round is a one-hour live coding interview with an engineer on LeetCode-medium problems.",
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'global-partners-internship-guide': {
    family: 'operations',
    processLine: 'Global Partners usually starts with a phone screen: why Global Partners and tell me about yourself.',
    skills: ['operations', 'excel'],
  },
  'global-payments-internship-guide': {
    family: 'software',
    processLine:
      'Global Payments starts with a recruiter call on your background, current projects and familiarity with payments.',
    skills: ['sql-data', 'coding-fundamentals'],
  },
  'goldman-sachs-internship-guide': {
    family: 'finance',
    processLine: "Goldman's first interview is a HireVue of about 5-6 questions, with 1.5-2 minutes to answer each.",
    skills: ['communication', 'case-structure'],
  },
  'goodyear-internship-guide': {
    family: 'operations',
    processLine:
      'Goodyear starts with a 15-30 minute recruiter phone screen on background, interests and why Goodyear.',
    skills: ['operations', 'excel'],
  },
  'google-deepmind-internship-guide': {
    family: 'ai-ml',
    processLine: 'DeepMind starts with a 30-minute recruiter screen, then a 45-minute technical hiring manager chat.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'google-internship-guide': {
    family: 'software',
    processLine:
      'Google starts with a recruiter phone screen confirming role, background and timing; contact can lag 60-plus days.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'grafana-labs-internship-guide': {
    family: 'software',
    processLine: 'Grafana Labs starts with a 15-30 minute video recruiter screen on qualifications and two-way fit.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'grail-internship-guide': {
    family: 'data-analytics',
    processLine:
      'GRAIL starts with a recruiter phone screen on motivation, research interests and basic qualifications.',
    skills: ['sql-data', 'coding-fundamentals'],
  },
  'grainger-internship-guide': {
    family: 'data-analytics',
    processLine: "Grainger's first round is a phone or video behavioral interview in STAR format.",
    skills: ['communication', 'sql-data'],
  },
  'grammarly-internship-guide': {
    family: 'software',
    processLine:
      "Grammarly's first interview is a 30-45 minute behavioral video call on its EAGER values, after a HackerRank OA.",
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'grant-thornton-internship-guide': {
    family: 'accounting-firm',
    processLine:
      'Grant Thornton runs two back-to-back behavioral interviews, typically with a partner and a senior manager.',
    skills: ['communication', 'case-structure'],
  },
  'graphic-packaging-internship-guide': {
    family: 'operations',
    processLine: 'Graphic Packaging starts with a behavioral phone interview with HR and a plant or hiring manager.',
    skills: ['communication', 'case-structure'],
  },
  'graybar-electric-internship-guide': {
    family: 'operations',
    processLine:
      'Graybar starts with an HR phone or video screen on motivation, career interests and behavioral questions.',
    skills: ['communication', 'operations'],
  },
  'greenhill-internship-guide': {
    family: 'finance',
    processLine:
      "Mizuho | Greenhill's first round is a 20-30 minute HireVue with 4-6 behavioral and motivational questions.",
    skills: ['communication', 'financial-modeling'],
  },
  'groq-internship-guide': {
    family: 'ai-ml',
    processLine:
      'Groq starts with a brief recruiter call on your background, motivation and interest in its inference tech.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'group-1-automotive-internship-guide': {
    family: 'other',
    processLine: null,
    skills: ['marketing-strategy', 'operations'],
  },
  'gsk-internship-guide': {
    family: 'other',
    processLine:
      "GSK's first interview is a HireVue job simulation, after a digital assessment that cuts 50-80% of candidates.",
    skills: ['sql-data', 'quant-reasoning'],
  },
  'guardian-life-internship-guide': {
    family: 'finance',
    processLine:
      'Guardian starts with a 20-30 minute recruiter call on motivation, fit, availability and work authorization.',
    skills: ['sql-data', 'case-structure'],
  },
  'guess-internship-guide': {
    family: 'marketing',
    processLine:
      'Guess runs a phone or video screen, then a department interview; design candidates walk through a portfolio.',
    skills: ['marketing-strategy', 'consumer-insight'],
  },
  'guggenheim-partners-internship-guide': {
    family: 'finance',
    processLine:
      'Guggenheim opens with a 15-20 minute HireVue: two behavioral scenarios and one basic technical question.',
    skills: ['financial-modeling', 'accounting'],
  },
  'gusto-internship-guide': {
    family: 'software',
    processLine: "Gusto's recruiter screen is 30 minutes on Zoom, including why Gusto, after a CodeSignal assessment.",
    skills: ['coding-fundamentals', 'product-sense'],
  },
  'gxo-logistics-internship-guide': {
    family: 'operations',
    processLine: 'GXO starts with a phone or video screen on motivation, career interests, leadership and teamwork.',
    skills: ['communication', 'operations'],
  },
  'halliburton-internship-guide': {
    family: 'operations',
    processLine:
      'Halliburton starts with an HR phone or video screen on your background, interest in the role and logistics.',
    skills: ['quant-reasoning', 'operations'],
  },
  'hallmark-cards-internship-guide': {
    family: 'marketing',
    processLine: 'Hallmark starts with a recruiter call, then separate manager calls of about 30 minutes each.',
    skills: ['marketing-strategy', 'consumer-insight'],
  },
  'harris-williams-internship-guide': {
    family: 'finance',
    processLine:
      'Harris Williams opens with a roughly 30-minute HireVue on why banking and why Harris Williams, after Suited.',
    skills: ['communication', 'financial-modeling'],
  },
  'harvey-internship-guide': {
    family: 'ai-ml',
    processLine: 'Harvey starts with a 20-30 minute recruiter screen on why Harvey and your interest in AI plus legal.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'hashicorp-internship-guide': {
    family: 'software',
    processLine:
      'HashiCorp starts with a 30-minute recruiter call, then a behavioral hiring-manager screen on its Principles.',
    skills: ['communication', 'coding-fundamentals'],
  },
  'havas-internship-guide': {
    family: 'marketing',
    processLine: 'Havas starts with a recruiter or team phone or video screen on fit, interest and availability.',
    skills: ['marketing-strategy', 'consumer-insight'],
  },
  'hbo-internship-guide': {
    family: 'other',
    processLine: 'HBO (WBD) opens with a one-way HireVue video interview about a week after you apply.',
    skills: ['marketing-strategy', 'research'],
  },
  'hca-healthcare-internship-guide': {
    family: 'other',
    processLine:
      'HCA starts with a recruiter phone or video screen on your background, interest in HCA and availability.',
    skills: ['sql-data', 'quant-reasoning'],
  },
  'hcvt-internship-guide': {
    family: 'accounting-firm',
    processLine:
      "HCVT's first round is a 30-minute Zoom behavioral interview with a recruiter; the process has no technicals.",
    skills: ['tax', 'accounting'],
  },
  'health-advances-internship-guide': {
    family: 'consulting',
    processLine: "Health Advances' first round is 1-2 interviews, each a behavioral Q&A plus a healthcare case.",
    skills: ['case-structure', 'quant-reasoning'],
  },
  'hebbia-internship-guide': {
    family: 'ai-ml',
    processLine:
      'Hebbia starts with a 30-minute recruiter screen on background, motivation and fit for an in-office startup.',
    skills: ['coding-fundamentals', 'research'],
  },
  'henry-schein-internship-guide': {
    family: 'other',
    processLine:
      'Henry Schein starts with a 15-20 minute recruiter screen on teamwork, motivation and healthcare distribution.',
    skills: ['communication', 'sql-data'],
  },
  'hershey-internship-guide': {
    family: 'marketing',
    processLine: "Hershey's main interview is one roughly 30-minute STAR behavioral video call with two team members.",
    skills: ['communication', 'marketing-strategy'],
  },
  'hertz-internship-guide': {
    family: 'operations',
    processLine:
      'Hertz interviews are described as straightforward behavioral questions on customer service, conflict and teamwork.',
    skills: ['communication', 'operations'],
  },
  'hess-internship-guide': {
    family: 'operations',
    processLine: 'Hess interviews mixed STAR behavioral prompts with technical exercises like analyzing seismic data.',
    skills: ['supply-chain', 'excel'],
  },
  'hewlett-packard-internship-guide': {
    family: 'software',
    processLine:
      "HPE's first interview is a 30-45 minute behavioral and technical round, after a HackerRank assessment.",
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'hf-sinclair-internship-guide': {
    family: 'operations',
    processLine: 'HF Sinclair starts with a 20-minute behavioral phone screen with the hiring manager.',
    skills: ['communication', 'operations'],
  },
  'hilti-internship-guide': {
    family: 'operations',
    processLine:
      "Hilti's first interview is with a University Talent Partner on motivation, why Hilti and cultural fit.",
    skills: ['case-structure', 'quant-reasoning'],
  },
  'hilton-internship-guide': {
    family: 'other',
    processLine: 'Hilton opens with a one-way HireVue: 5-7 behavioral questions, 3 minutes to answer each.',
    skills: ['communication', 'sql-data'],
  },
  'hims-and-hers-internship-guide': {
    family: 'software',
    processLine:
      'Hims & Hers starts with a roughly 30-minute recruiter call, then a 45-minute CoderPad technical screen.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'hitt-futures-internship-guide': {
    family: 'operations',
    processLine: 'HITT starts with a phone or video screen on your motivation and interest in construction management.',
    skills: ['operations', 'case-structure'],
  },
  'home-depot-internship-guide': {
    family: 'software',
    processLine:
      "Home Depot's recruiter screen is 30 minutes of resume and behavioral questions, after a coding test for SWE.",
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'honda-internship-guide': {
    family: 'operations',
    processLine: 'Honda starts with a recruiter pre-screening call on your background, logistics and role fit.',
    skills: ['case-structure', 'excel'],
  },
  'honeywell-aerospace-internship-guide': {
    family: 'operations',
    processLine: "Honeywell Aerospace's HR phone screen is behavioral, after online aptitude and coding assessments.",
    skills: ['quant-reasoning', 'operations'],
  },
  'honeywell-internship-guide': {
    family: 'software',
    processLine:
      "Honeywell's first interview is a 20-45 minute technical and HR round, after a HackerRank test for technical roles.",
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'horizon-bcbsnj-internship-guide': {
    family: 'other',
    processLine:
      'Horizon runs one panel interview with four people, focused more on culture fit than technical skills.',
    skills: ['case-structure', 'quant-reasoning'],
  },
  'hormel-foods-internship-guide': {
    family: 'marketing',
    processLine: 'Hormel starts with a 30-minute recruiter phone screen of 4-5 STAR behavioral questions.',
    skills: ['communication', 'marketing-strategy'],
  },
  'houlihan-lokey-internship-guide': {
    family: 'finance',
    processLine:
      "Houlihan Lokey's first interview is a 30-minute phone screen on basic fit, after a cognitive and personality test.",
    skills: ['financial-modeling', 'markets'],
  },
  'howmet-aerospace-internship-guide': {
    family: 'operations',
    processLine: 'Howmet runs two online behavioral interviews, with no technical assessment.',
    skills: ['excel', 'quant-reasoning'],
  },
  'hr-block-internship-guide': { family: 'product', processLine: null, skills: ['product-sense', 'product-metrics'] },
  'hsbc-internship-guide': {
    family: 'finance',
    processLine:
      'HSBC starts with an immersive assessment: 60-90 minutes of scenario-based videos with written and selection answers.',
    skills: ['financial-modeling', 'markets'],
  },
  'hub-international-internship-guide': {
    family: 'finance',
    processLine: 'HUB starts with a quick recruiter call of 2-3 questions like why HUB and why insurance.',
    skills: ['coding-fundamentals', 'financial-modeling'],
  },
  'hubspot-internship-guide': {
    family: 'software',
    processLine:
      "HubSpot's recruiter screen is 15-30 minutes of behavioral and fit questions, after a track-specific assessment.",
    skills: ['sql-data', 'product-sense'],
  },
  'hudson-river-trading-hrt-internship-guide': {
    family: 'finance',
    processLine: "HRT's two technical phone screens follow a 60-90 minute coding assessment.",
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'hugging-face-internship-guide': {
    family: 'ai-ml',
    processLine: "Hugging Face's technical calls discuss your take-home project; there is no timed online assessment.",
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'humana-internship-guide': {
    family: 'data-analytics',
    processLine: 'Humana starts with a 20-30 minute recruiter screen on motivation, fit and work authorization.',
    skills: ['sql-data', 'statistics'],
  },
  'huntington-bank-internship-guide': {
    family: 'finance',
    processLine: 'Huntington runs an HR phone screen, then a team interview, often within days.',
    skills: ['markets', 'quant-reasoning'],
  },
  'huntington-ingalls-industries-internship-guide': {
    family: 'operations',
    processLine: 'HII opens with a one-way recorded video: about eight questions, 30 seconds each.',
    skills: ['communication', 'operations'],
  },
  'huron-consulting-group-internship-guide': {
    family: 'consulting',
    processLine: "Huron's first round is one 30-60 minute interviewer-led case, after a short recruiter screen.",
    skills: ['case-structure', 'sql-data'],
  },
  'hyatt-internship-guide': {
    family: 'other',
    processLine: 'Hyatt starts with a recruiter conversation on motivation, availability and hospitality interest.',
    skills: ['sql-data', 'case-structure'],
  },
  'hyundai-internship-guide': {
    family: 'operations',
    processLine: 'Hyundai starts with a recruiter prescreen on your experience and fit with the role.',
    skills: ['case-structure', 'operations'],
  },
  'ibm-internship-guide': {
    family: 'software',
    processLine:
      "IBM's recruiter screen is 20-30 minutes on background and motivation, after a HackerRank coding assessment.",
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'icahn-enterprises-internship-guide': {
    family: 'operations',
    processLine: null,
    skills: ['operations', 'supply-chain'],
  },
  'idaho-national-laboratory-internship-guide': {
    family: 'other',
    processLine: "INL's interview is usually a single 30-minute virtual call with your potential mentor and team.",
    skills: ['sql-data', 'research'],
  },
  'ideogram-internship-guide': {
    family: 'ai-ml',
    processLine:
      'Ideogram starts with an HR screen on background and motivation, then a 45-60 minute ML fundamentals interview.',
    skills: ['ml-fundamentals', 'coding-fundamentals'],
  },
  'iff-internship-guide': {
    family: 'other',
    processLine: 'IFF starts with an HR phone or video screen on background, motivation and culture fit.',
    skills: ['sql-data', 'consumer-insight'],
  },
  'iheartmedia-internship-guide': {
    family: 'marketing',
    processLine:
      'iHeartMedia runs short Zoom interviews: an intro and fit conversation, then a placement interview with a manager.',
    skills: ['marketing-strategy', 'consumer-insight'],
  },
  'illinois-tool-works-internship-guide': {
    family: 'operations',
    processLine:
      'ITW starts with a phone screen with a recruiter or hiring manager on fit, background and availability.',
    skills: ['excel', 'quant-reasoning'],
  },
  'illumina-internship-guide': {
    family: 'other',
    processLine: 'Illumina opens with a HireVue: 3-5 recorded behavioral questions, 60-90 seconds each.',
    skills: ['communication', 'case-structure'],
  },
  'imc-internship-guide': {
    family: 'finance',
    processLine:
      "IMC's recruiter call is a behavioral round on why trading and why IMC, after a timed online assessment.",
    skills: ['coding-fundamentals', 'markets'],
  },
  'included-health-internship-guide': {
    family: 'software',
    processLine:
      'Included Health starts with a 30-minute recruiter or hiring-manager screen on motivation and background.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'inflection-ai-internship-guide': {
    family: 'ai-ml',
    processLine:
      'Inflection AI starts with a 30-minute recruiter conversation, then 90 minutes of technical interviews.',
    skills: ['ml-fundamentals', 'coding-fundamentals'],
  },
  'ingram-micro-internship-guide': {
    family: 'operations',
    processLine:
      'Ingram Micro runs a structured behavioral interview: one competency question and one growth-area question.',
    skills: ['communication', 'excel'],
  },
  'insight-enterprises-internship-guide': {
    family: 'other',
    processLine: null,
    skills: ['consumer-insight', 'case-structure'],
  },
  'instacart-internship-guide': {
    family: 'software',
    processLine:
      "Instacart's recruiter screen is 30 minutes on background and motivation, after a CodeSignal assessment.",
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'insulet-internship-guide': {
    family: 'operations',
    processLine: 'Insulet runs three interviews with managers, mainly behavioral with no technical questions.',
    skills: ['supply-chain', 'operations'],
  },
  'intel-internship-guide': {
    family: 'software',
    processLine:
      'Intel starts with a 20-30 minute recruiter screen on qualifications, availability and behavioral fit.',
    skills: ['communication', 'coding-fundamentals'],
  },
  'intercontinental-exchange-internship-guide': {
    family: 'finance',
    processLine: 'ICE starts with a 15-minute talent acquisition call, then a 30-minute hiring manager interview.',
    skills: ['sql-data', 'coding-fundamentals'],
  },
  'international-monetary-fund-internship-guide': {
    family: 'other',
    processLine: "The IMF holds one interview, with the hiring manager or supervising unit, if you're shortlisted.",
    skills: ['case-structure', 'quant-reasoning'],
  },
  'international-paper-internship-guide': {
    family: 'operations',
    processLine:
      'International Paper starts with a career-fair or recruiter screen on your interest in packaging and manufacturing.',
    skills: ['operations', 'supply-chain'],
  },
  'interpublic-internship-guide': {
    family: 'marketing',
    processLine: null,
    skills: ['marketing-strategy', 'marketing-analytics'],
  },
  'intuit-internship-guide': {
    family: 'software',
    processLine: "Intuit's first interview is 30-45 minutes on CS fundamentals, after a 90-minute coding assessment.",
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'intuitive-surgical-internship-guide': {
    family: 'software',
    processLine: "Intuitive's first screen is a 30-45 minute call with the hiring manager, not a recruiter.",
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'invesco-internship-guide': {
    family: 'finance',
    processLine:
      "Invesco's first interview is a behavioral phone or video call with talent acquisition or the hiring manager.",
    skills: ['communication', 'sql-data'],
  },
  'iqvia-internship-guide': {
    family: 'data-analytics',
    processLine: 'IQVIA opens with a pre-recorded video interview on your interest in healthcare and teamwork.',
    skills: ['communication', 'sql-data'],
  },
  'iridium-internship-guide': {
    family: 'software',
    processLine:
      "Iridium's HR phone screen is 20-30 minutes of behavioral questions, after a Predictive Index assessment.",
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'isomorphic-labs-internship-guide': {
    family: 'ai-ml',
    processLine: 'Isomorphic Labs starts with screening calls, then a take-home or scenario technical assessment.',
    skills: ['ml-fundamentals', 'coding-fundamentals'],
  },
  'jabil-internship-guide': {
    family: 'operations',
    processLine: 'Jabil starts with an HR screen confirming enrollment, location and availability for the role.',
    skills: ['operations', 'excel'],
  },
  'jacobs-solutions-internship-guide': {
    family: 'operations',
    processLine: 'Jacobs interviews with a recruiter and hiring manager on coursework, projects and technical skills.',
    skills: ['operations', 'supply-chain'],
  },
  'jane-street-internship-guide': {
    family: 'finance',
    processLine:
      "Jane Street's first screen is a 30-45 minute phone interview with a trader on probability and expected value.",
    skills: ['quant-reasoning', 'coding-fundamentals'],
  },
  'jb-hunt-internship-guide': {
    family: 'operations',
    processLine: 'J.B. Hunt starts with a 30-minute HR phone screen of about three behavioral questions.',
    skills: ['communication', 'case-structure'],
  },
  'jefferies-internship-guide': {
    family: 'finance',
    processLine: "Jefferies' first round is a 20-30 minute phone or HireVue interview with analysts or associates.",
    skills: ['valuation', 'financial-modeling'],
  },
  'jetblue-airways-internship-guide': {
    family: 'other',
    processLine: 'JetBlue usually starts with a recruiter or HR phone screen, then a one-on-one with a hiring manager.',
    skills: ['operations', 'case-structure'],
  },
  'jll-internship-guide': {
    family: 'finance',
    processLine:
      "JLL's rounds mix phone and one-on-one interviews, panels and skills tests; there's no standard online assessment.",
    skills: ['markets', 'valuation'],
  },
  'john-deere-internship-guide': {
    family: 'software',
    processLine:
      "John Deere's first conversation is an HR phone screen; IT/SWE roles take a HackerRank assessment first.",
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'johns-hopkins-applied-physics-laboratory-internship-guide': {
    family: 'software',
    processLine: null,
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'johnson-and-johnson-internship-guide': {
    family: 'other',
    processLine: 'J&J opens with a 15-minute HireVue: three behavioral questions on motivation and Credo alignment.',
    skills: ['communication', 'sql-data'],
  },
  'jpmorgan-internship-guide': {
    family: 'finance',
    processLine: "JPMorgan's first round is a HireVue video interview with 3-5 mostly behavioral questions.",
    skills: ['communication', 'sql-data'],
  },
  'jump-trading-internship-guide': {
    family: 'finance',
    processLine: "Jump's first rounds are 45-60 minute live coding interviews focused on C++ and algorithms.",
    skills: ['coding-fundamentals', 'statistics'],
  },
  'kaiser-permanente-internship-guide': {
    family: 'other',
    processLine:
      "Kaiser's interview is 30-45 minutes, one-on-one or panel, with 6-8 behavioral and role-specific questions.",
    skills: ['communication', 'sql-data'],
  },
  'kearney-internship-guide': {
    family: 'consulting',
    processLine: "Kearney's first round is two 45-minute sessions: one case interview and one behavioral.",
    skills: ['case-structure', 'operations'],
  },
  'kellanova-internship-guide': {
    family: 'marketing',
    processLine: 'Kellanova starts with a recruiter screen: fit, why Kellanova, and a resume walk-through.',
    skills: ['consumer-insight', 'marketing-analytics'],
  },
  'kenvue-internship-guide': {
    family: 'marketing',
    processLine: 'Kenvue runs 2-5 behavioral-heavy rounds, possibly including a HireVue-style digital interview.',
    skills: ['marketing-strategy', 'consumer-insight'],
  },
  'keurig-dr-pepper-internship-guide': {
    family: 'marketing',
    processLine: 'KDP opens with a one-way HireVue of five values-based questions, reviewed by the hiring manager.',
    skills: ['communication', 'consumer-insight'],
  },
  'kiewit-internship-guide': {
    family: 'operations',
    processLine:
      'Kiewit starts with a recruiter phone or video screen, then a 30-minute behavioral hiring manager interview.',
    skills: ['communication', 'case-structure'],
  },
  'kimberly-clark-internship-guide': {
    family: 'marketing',
    processLine: 'Kimberly-Clark starts with an HR phone screen on background, fit and why Kimberly-Clark.',
    skills: ['marketing-strategy', 'consumer-insight'],
  },
  'kinder-morgan-internship-guide': {
    family: 'operations',
    processLine: 'Kinder Morgan starts with a behavioral phone or virtual screen with a recruiting manager.',
    skills: ['communication', 'quant-reasoning'],
  },
  'kkr-internship-guide': {
    family: 'finance',
    processLine:
      "KKR's first round is two 30-minute interviews with a deal walkthrough and accounting and valuation technicals.",
    skills: ['accounting', 'valuation'],
  },
  'kla-internship-guide': {
    family: 'software',
    processLine:
      "KLA's first conversation is reportedly a 45-minute hiring manager screen on your resume and past projects.",
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'klarna-internship-guide': {
    family: 'software',
    processLine:
      'Klarna starts with a 30-minute recruiter call on background and motivation, light on technical content.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'klaviyo-internship-guide': {
    family: 'software',
    processLine: 'Klaviyo starts with a recruiter call on your background, interest in Klaviyo and logistics.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'kohls-internship-guide': {
    family: 'other',
    processLine: "Kohl's first round is a virtual screening interview, then a final virtual interview 1-2 weeks later.",
    skills: ['case-structure', 'quant-reasoning'],
  },
  'komodo-health-internship-guide': {
    family: 'data-analytics',
    processLine:
      'Komodo Health starts with a roughly 30-minute recruiter screen on motivation, mission fit and your tech stack.',
    skills: ['sql-data', 'statistics'],
  },
  'kpmg-internship-guide': {
    family: 'accounting-firm',
    processLine: "KPMG's first step is an online assessment, usually a recorded or live behavioral video.",
    skills: ['accounting', 'excel'],
  },
  'kraft-heinz-internship-guide': {
    family: 'other',
    processLine:
      "Kraft Heinz's first interview is a recorded HireVue of 4-6 behavioral questions, after Pymetrics games.",
    skills: ['communication', 'sql-data'],
  },
  'kroger-internship-guide': {
    family: 'other',
    processLine: 'Kroger opens with a 20-30 minute one-way HireVue of behavioral questions mapped to its values.',
    skills: ['communication', 'sql-data'],
  },
  'kyndryl-internship-guide': {
    family: 'software',
    processLine: "Kyndryl's interview is behavioral, by phone or video, and candidates describe it as conversational.",
    skills: ['communication', 'coding-fundamentals'],
  },
  'l-e-k-consulting-internship-guide': {
    family: 'consulting',
    processLine:
      "L.E.K.'s first round is 2-3 thirty-minute interviews, each blending brief behavioral questions with a case.",
    skills: ['case-structure', 'market-sizing'],
  },
  'l3harris-internship-guide': {
    family: 'software',
    processLine: 'L3Harris starts with a 15-30 minute recruiter screen on motivation, citizenship and GPA.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'la-dodgers-internship-guide': {
    family: 'other',
    processLine:
      'The Dodgers run two to three rounds: a coordinator or HR screen, a manager interview, and possibly a VP.',
    skills: ['sql-data', 'operations'],
  },
  'labcorp-internship-guide': {
    family: 'other',
    processLine: 'Labcorp starts with a recruiter phone screen on you and your motivation for the internship.',
    skills: ['sql-data', 'case-structure'],
  },
  'lam-research-internship-guide': {
    family: 'operations',
    processLine:
      'Lam starts with a screening conversation with the hiring team about your experience and career goals.',
    skills: ['case-structure', 'quant-reasoning'],
  },
  'lambda-internship-guide': {
    family: 'ai-ml',
    processLine: 'Lambda starts with a 30-minute recruiter chat on background, goals and fit.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'land-olakes-internship-guide': {
    family: 'other',
    processLine: "Land O'Lakes starts with a 30-45 minute call on your background and why food and agriculture.",
    skills: ['communication', 'operations'],
  },
  'langchain-internship-guide': {
    family: 'ai-ml',
    processLine: "LangChain starts with a 30-minute recruiter screen: why LangChain and what you've built with LLMs.",
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'las-vegas-sands-internship-guide': {
    family: 'other',
    processLine: 'Las Vegas Sands interviews focus on teamwork, communication and your interest in integrated resorts.',
    skills: ['case-structure', 'quant-reasoning'],
  },
  'lazard-internship-guide': {
    family: 'finance',
    processLine: 'Lazard opens with a HireVue of 3-5 behavioral and basic technical questions.',
    skills: ['financial-modeling', 'valuation'],
  },
  'lear-internship-guide': {
    family: 'operations',
    processLine: 'Lear runs one to three rounds, starting with a phone or HR screen on motivation and fit.',
    skills: ['operations', 'excel'],
  },
  'leerink-partners-internship-guide': {
    family: 'finance',
    processLine: "Leerink's first round mixes behavioral questions with simple technicals, on campus or virtually.",
    skills: ['accounting', 'valuation'],
  },
  'leidos-internship-guide': {
    family: 'software',
    processLine:
      'Leidos runs a recruiter screen, then a technical interview; no standardized online assessment is reported.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'lennar-internship-guide': {
    family: 'operations',
    processLine: "Lennar's interviews are in person; Technology candidates take a Codility assessment first.",
    skills: ['operations', 'case-structure'],
  },
  'lenovo-internship-guide': {
    family: 'software',
    processLine: 'Lenovo starts with a conversational recruiter screen on your background and fit.',
    skills: ['sql-data', 'coding-fundamentals'],
  },
  'leo-burnett-internship-guide': {
    family: 'marketing',
    processLine:
      "Leo Burnett's first call is a 20-minute talent acquisition screen, after an Arctic Shores gamified assessment.",
    skills: ['marketing-strategy', 'research'],
  },
  'liberty-mutual-internship-guide': {
    family: 'finance',
    processLine: 'Liberty Mutual reportedly starts with a recruiter call before the technical or behavioral round.',
    skills: ['case-structure', 'sql-data'],
  },
  'life360-internship-guide': {
    family: 'software',
    processLine: 'Life360 starts with a recruiter phone screen on background, motivation and culture fit.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'lincoln-financial-group-internship-guide': {
    family: 'finance',
    processLine:
      'Lincoln Financial starts with a 20-30 minute recruiter call on your background and interest in the company.',
    skills: ['quant-reasoning', 'excel'],
  },
  'lincoln-international-internship-guide': {
    family: 'finance',
    processLine:
      "Lincoln's first round is about 30 minutes: why Lincoln, why IB, and a DCF walkthrough, after a cognitive test.",
    skills: ['valuation', 'accounting'],
  },
  'linear-internship-guide': {
    family: 'software',
    processLine:
      'Linear starts with 30-45 minute calls with a recruiter and the hiring manager on background, motivation and fit.',
    skills: ['coding-fundamentals', 'product-sense'],
  },
  'linkedin-internship-guide': {
    family: 'software',
    processLine:
      "LinkedIn's interviews are coding rounds plus resume discussion, after a required HackerRank code challenge.",
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'lionsgate-internship-guide': {
    family: 'other',
    processLine:
      'Lionsgate opens with a pre-recorded video: 5-8 behavioral questions on motivation, goals and deadlines.',
    skills: ['communication', 'research'],
  },
  'lithia-motors-internship-guide': { family: 'other', processLine: null, skills: ['excel', 'marketing-strategy'] },
  'live-nation-internship-guide': {
    family: 'other',
    processLine:
      'Live Nation starts with a HireVue or a 20-30 minute recruiter call of straightforward behavioral questions.',
    skills: ['communication', 'sql-data'],
  },
  'lkq-internship-guide': { family: 'other', processLine: null, skills: ['case-structure', 'consumer-insight'] },
  'll-bean-internship-guide': {
    family: 'marketing',
    processLine: 'L.L.Bean starts with an HR phone interview, then a hiring manager interview in your department.',
    skills: ['marketing-strategy', 'consumer-insight'],
  },
  'lockheed-martin-internship-guide': {
    family: 'operations',
    processLine:
      'Lockheed Martin starts with a 30-minute recruiter screen: resume, motivation and clearance eligibility.',
    skills: ['excel', 'operations'],
  },
  'loews-internship-guide': {
    family: 'other',
    processLine: 'Loews candidates report multiple interviews, sometimes at more than one property, before a decision.',
    skills: ['case-structure', 'excel'],
  },
  'loreal-internship-guide': {
    family: 'marketing',
    processLine:
      "L'Oreal's first interview is a recorded HireVue, after an aptitude assessment that cuts most applicants.",
    skills: ['marketing-strategy', 'consumer-insight'],
  },
  'lowes-internship-guide': {
    family: 'other',
    processLine:
      "Lowe's recruiter screen is 20-30 minutes on motivation and fit; tech tracks take a coding assessment first.",
    skills: ['case-structure', 'sql-data'],
  },
  'lpl-financial-internship-guide': {
    family: 'finance',
    processLine:
      'LPL starts with a recruiter phone screen, then a WebEx or in-person interview with the hiring manager.',
    skills: ['sql-data', 'quant-reasoning'],
  },
  'lucid-motors-internship-guide': {
    family: 'software',
    processLine:
      "Lucid's recruiter screen is 25-30 minutes on background and logistics; technical roles take a coding test first.",
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'lululemon-internship-guide': {
    family: 'marketing',
    processLine: 'Lululemon starts with an HR screening call: why lululemon and how you live its IDEA values.',
    skills: ['marketing-strategy', 'consumer-insight'],
  },
  'luma-ai-internship-guide': {
    family: 'ai-ml',
    processLine: 'Luma AI starts with a recruiter screen on your background, motivation and technical experience.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'lumen-technologies-internship-guide': {
    family: 'software',
    processLine:
      'Lumen opens with a HireVue: 3-5 recorded questions on behavioral scenarios and basic technical understanding.',
    skills: ['ml-fundamentals', 'sql-data'],
  },
  'lumsden-mccormick-internship-guide': {
    family: 'accounting-firm',
    processLine: 'Lumsden McCormick typically runs one virtual interview on fit and interest in the firm.',
    skills: ['accounting', 'audit'],
  },
  'lyft-internship-guide': {
    family: 'software',
    processLine: 'Lyft starts with a 30-minute recruiter screen on background, motivation and why Lyft.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'lyondellbasell-internship-guide': {
    family: 'operations',
    processLine:
      "LyondellBasell's interview is a 30-45 minute two-person panel: behavioral STAR questions plus light technical probes.",
    skills: ['operations', 'case-structure'],
  },
  'macys-internship-guide': {
    family: 'other',
    processLine:
      "Macy's opens with a HireVue of 3-5 recorded behavioral questions, then a 30-minute recruiter interview.",
    skills: ['communication', 'sql-data'],
  },
  'magna-internship-guide': {
    family: 'operations',
    processLine: 'Magna typically runs a recruiter or HR phone screen, then a hiring manager or technical interview.',
    skills: ['case-structure', 'operations'],
  },
  'mandt-bank-internship-guide': {
    family: 'finance',
    processLine:
      "M&T's first interview is laid back: typically two interviewers asking general, personality-focused questions.",
    skills: ['case-structure', 'quant-reasoning'],
  },
  'manpower-internship-guide': {
    family: 'other',
    processLine: "ManpowerGroup's interviews are behavioral: teamwork, problem-solving and learning agility.",
    skills: ['communication', 'sql-data'],
  },
  'marathon-petroleum-internship-guide': {
    family: 'operations',
    processLine: 'Marathon starts with a brief recruiter phone screen; some roles take online aptitude tests first.',
    skills: ['case-structure', 'operations'],
  },
  'marcum-internship-guide': {
    family: 'accounting-firm',
    processLine:
      "Marcum's first round is a casual chat with two staff members about your background and why public accounting.",
    skills: ['accounting', 'excel'],
  },
  'markel-internship-guide': { family: 'finance', processLine: null, skills: ['sql-data', 'coding-fundamentals'] },
  'marqeta-internship-guide': {
    family: 'software',
    processLine:
      'Marqeta starts with a 30-minute recruiter video call on your background, fintech interest and its values.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'marriott-internship-guide': {
    family: 'other',
    processLine: 'Marriott opens with a one-way HireVue of about 5 questions tied to its core values.',
    skills: ['operations', 'consumer-insight'],
  },
  'mars-internship-guide': {
    family: 'other',
    processLine: 'Mars opens with a HireVue: 2-5 recorded behavioral questions, 2 minutes each, STAR recommended.',
    skills: ['communication', 'sql-data'],
  },
  'marsh-and-mclennan-internship-guide': {
    family: 'finance',
    processLine: 'Marsh McLennan opens with a HireVue of behavioral questions on motivation and teamwork.',
    skills: ['communication', 'case-structure'],
  },
  'marvell-technology-internship-guide': {
    family: 'software',
    processLine:
      'Marvell runs a recruiter phone screen, then virtual technical interviews; AI use during interviews disqualifies.',
    skills: ['coding-fundamentals', 'product-sense'],
  },
  'mass-mutual-internship-guide': {
    family: 'finance',
    processLine:
      'MassMutual starts with a 20-30 minute recruiter call on motivation, availability and, for actuaries, exam progress.',
    skills: ['sql-data', 'financial-modeling'],
  },
  'mastec-internship-guide': {
    family: 'operations',
    processLine:
      'MasTec starts with a 15-30 minute recruiter call: background, motivation, and why construction and MasTec.',
    skills: ['operations', 'excel'],
  },
  'mastercard-internship-guide': {
    family: 'software',
    processLine: 'Mastercard starts with a 15-30 minute recruiter screen on your interest in Mastercard and payments.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'mattel-internship-guide': {
    family: 'marketing',
    processLine: 'Mattel starts with a talent acquisition screen on motivation, brand knowledge and fit.',
    skills: ['marketing-strategy', 'consumer-insight'],
  },
  'maximus-internship-guide': {
    family: 'other',
    processLine: 'Maximus starts with a recruiter screen, then a single Zoom interview with the hiring manager.',
    skills: ['sql-data', 'research'],
  },
  'mccann-internship-guide': {
    family: 'marketing',
    processLine: 'McCann starts with a recruiter screen, then discipline-specific team interviews.',
    skills: ['marketing-strategy', 'research'],
  },
  'mcdonalds-internship-guide': {
    family: 'other',
    processLine:
      "McDonald's opens with a recorded HireVue of basic behavioral questions, then a live recruiter screen.",
    skills: ['communication', 'case-structure'],
  },
  'mckesson-internship-guide': {
    family: 'other',
    processLine: 'McKesson starts with a simple recruiter Teams call, no cameras, confirming the role and basic fit.',
    skills: ['sql-data', 'quant-reasoning'],
  },
  'mckinsey-internship-guide': {
    family: 'consulting',
    processLine:
      "McKinsey's first round is two 45-60 minute sessions, each a case plus a PEI question, after the Solve game.",
    skills: ['case-structure', 'quant-reasoning'],
  },
  'mcmaster-carr-internship-guide': {
    family: 'operations',
    processLine:
      "McMaster-Carr's main round is a roughly 3-hour on-site with 2-3 behavioral interviews and a group exercise.",
    skills: ['communication', 'supply-chain'],
  },
  'medline-internship-guide': {
    family: 'operations',
    processLine: 'Medline starts with a recruiter or HR screen confirming fit and background.',
    skills: ['operations', 'quant-reasoning'],
  },
  'medtronic-internship-guide': {
    family: 'operations',
    processLine:
      "Medtronic's HR phone screen is 20-30 minutes on background and interests, after an Aon behavioral assessment.",
    skills: ['operations', 'supply-chain'],
  },
  'memorial-hermann-internship-guide': {
    family: 'other',
    processLine: 'Memorial Hermann starts with a 15-20 minute virtual or phone screen of basic behavioral questions.',
    skills: ['operations', 'sql-data'],
  },
  'mercedes-benz-internship-guide': {
    family: 'operations',
    processLine:
      "Mercedes-Benz's interviews usually start with a recruiter or HR screen, then a technical or hiring-manager round.",
    skills: ['operations', 'supply-chain'],
  },
  'merck-internship-guide': {
    family: 'other',
    processLine: 'Merck starts with a 15-30 minute recruiter screen: why Merck and why this role.',
    skills: ['sql-data', 'case-structure'],
  },
  'mercor-internship-guide': {
    family: 'software',
    processLine: 'Mercor opens with a 20-minute AI interview on your resume, projects and technical decisions.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'mercury-internship-guide': {
    family: 'software',
    processLine: 'Mercury starts with a recruiter screen on background and motivation, then a SQL pull-request review.',
    skills: ['sql-data', 'coding-fundamentals'],
  },
  'meta-internship-guide': {
    family: 'software',
    processLine: 'Meta starts with a short recruiter conversation on background and fit.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'metlife-internship-guide': {
    family: 'finance',
    processLine:
      'MetLife starts with a recruiter or phone screen on your background, track fit and work authorization.',
    skills: ['excel', 'quant-reasoning'],
  },
  'mgm-resorts-internship-guide': {
    family: 'other',
    processLine: 'MGM starts with an HR screen on motivation, guest-service orientation, and why MGM.',
    skills: ['case-structure', 'sql-data'],
  },
  'michaels-stores-internship-guide': {
    family: 'other',
    processLine:
      'Michaels starts with a talent-team screen on motivation, interest in creative retail, and department fit.',
    skills: ['sql-data', 'marketing-strategy'],
  },
  'micron-internship-guide': {
    family: 'software',
    processLine: "Micron's recruiter phone screen is 15-30 minutes on background, motivation and basic qualifications.",
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'microsoft-internship-guide': {
    family: 'software',
    processLine: "Microsoft's technical loop is two 45-60 minute rounds, after a Codility or HackerRank assessment.",
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'midjourney-internship-guide': {
    family: 'ai-ml',
    processLine: "Midjourney opens with a technical deep dive and review of your past work; it's not LeetCode-style.",
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'millennium-internship-guide': {
    family: 'finance',
    processLine:
      "Millennium's recruiter screen is 15-20 minutes on interest and eligibility, after a 90-120 minute assessment.",
    skills: ['sql-data', 'coding-fundamentals'],
  },
  'millerknoll-internship-guide': {
    family: 'operations',
    processLine:
      "MillerKnoll's first-round interview is structured and behavioral, on your design process or projects.",
    skills: ['communication', 'case-structure'],
  },
  'miro-internship-guide': {
    family: 'software',
    processLine: 'Miro starts with a 30-minute recruiter screen on your skills, resilience and motivation.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'mistral-ai-internship-guide': {
    family: 'ai-ml',
    processLine: 'Mistral starts with a 30-45 minute recruiter screen: why Mistral over other AI labs.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'mizuho-internship-guide': {
    family: 'finance',
    processLine:
      "Mizuho's first round is a HireVue or phone screen of behavioral and foundational technical questions.",
    skills: ['financial-modeling', 'quant-reasoning'],
  },
  'mlb-internship-guide': {
    family: 'other',
    processLine: 'MLB starts with a 15-30 minute HR screen: why MLB, availability, and teamwork questions.',
    skills: ['sql-data', 'excel'],
  },
  'modal-internship-guide': {
    family: 'software',
    processLine: 'Modal starts with a 30-minute recruiter screen on background, motivation and team preference.',
    skills: ['coding-fundamentals', 'product-sense'],
  },
  'moderna-internship-guide': {
    family: 'other',
    processLine:
      "Moderna's recruiter screen is 20-30 minutes on why Moderna and availability, after an online assessment.",
    skills: ['sql-data', 'operations'],
  },
  'moelis-internship-guide': {
    family: 'finance',
    processLine: "Moelis' first round is a 30-minute phone or Zoom interview, after the Suited assessment.",
    skills: ['financial-modeling', 'valuation'],
  },
  'mohawk-industries-internship-guide': {
    family: 'other',
    processLine: null,
    skills: ['case-structure', 'consumer-insight'],
  },
  'molina-healthcare-internship-guide': {
    family: 'other',
    processLine: 'Molina starts with a 15-30 minute recruiter phone screen on your background, logistics and fit.',
    skills: ['case-structure', 'sql-data'],
  },
  'molson-coors-internship-guide': {
    family: 'marketing',
    processLine: 'Molson Coors opens with a pre-recorded video interview of behavioral questions.',
    skills: ['communication', 'marketing-strategy'],
  },
  'mondelez-internship-guide': {
    family: 'marketing',
    processLine: "Mondelez's first interview is a roughly five-question competency video, after SHL reasoning tests.",
    skills: ['consumer-insight', 'marketing-strategy'],
  },
  'mongodb-internship-guide': {
    family: 'software',
    processLine: 'MongoDB starts with a 30-minute recruiter screen on your background, skills and why MongoDB.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'monster-beverage-internship-guide': { family: 'other', processLine: null, skills: ['sql-data', 'case-structure'] },
  'morgan-stanley-internship-guide': {
    family: 'finance',
    processLine: 'Morgan Stanley opens with a mandatory HireVue of mostly behavioral prompts for every applicant.',
    skills: ['communication', 'coding-fundamentals'],
  },
  'mortenson-internship-guide': {
    family: 'operations',
    processLine:
      'Mortenson starts with a phone or video screen on motivation, safety awareness and willingness to travel.',
    skills: ['quant-reasoning', 'excel'],
  },
  'mosaic-internship-guide': {
    family: 'operations',
    processLine:
      'Mosaic starts with a recruiter phone screen on motivation, your major and interest in fertilizer and mining.',
    skills: ['operations', 'case-structure'],
  },
  'moss-adams-internship-guide': {
    family: 'accounting-firm',
    processLine: "Moss Adams' first round is a virtual behavioral interview with a recruiter, including why the firm.",
    skills: ['communication', 'case-structure'],
  },
  'motorola-solutions-internship-guide': {
    family: 'software',
    processLine:
      'Motorola Solutions starts with a recruiter phone screen on eligibility, location and pay expectations.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'mott-macdonald-internship-guide': {
    family: 'operations',
    processLine: 'Mott MacDonald starts with a talent acquisition screening call, then a hiring manager interview.',
    skills: ['communication', 'supply-chain'],
  },
  'mr-cooper-internship-guide': {
    family: 'finance',
    processLine:
      'Mr. Cooper starts with a phone screen of about ten minutes, then a 30-minute behavioral manager interview.',
    skills: ['communication', 'sql-data'],
  },
  'mt-bank-internship-guide': {
    family: 'finance',
    processLine: 'M&T starts with a mostly behavioral recruiter or HR screen on your background and program fit.',
    skills: ['communication', 'coding-fundamentals'],
  },
  'murphy-usa-internship-guide': {
    family: 'other',
    processLine: null,
    skills: ['case-structure', 'marketing-strategy'],
  },
  'mutual-of-omaha-internship-guide': {
    family: 'finance',
    processLine:
      'Mutual of Omaha starts with a recruiter phone screen on motivation, track interest and company knowledge.',
    skills: ['sql-data', 'coding-fundamentals'],
  },
  'nasa-internship-guide': {
    family: 'other',
    processLine: "NASA mentors pick interns directly; many hold a phone or video interview, but it isn't required.",
    skills: ['sql-data', 'case-structure'],
  },
  'national-instruments-internship-guide': {
    family: 'software',
    processLine:
      "NI's technical interview is a live session with an engineer, after a C/C++ and coding online assessment.",
    skills: ['coding-fundamentals', 'product-sense'],
  },
  'nationwide-internship-guide': {
    family: 'finance',
    processLine: 'Nationwide typically runs a recruiter phone screen, then a team or panel interview, both STAR-heavy.',
    skills: ['communication', 'quant-reasoning'],
  },
  'naughty-dog-internship-guide': {
    family: 'software',
    processLine: "Naughty Dog's intern route is SIE's program: online application, recruiter screen, then interviews.",
    skills: ['coding-fundamentals', 'product-sense'],
  },
  'navan-internship-guide': {
    family: 'software',
    processLine: 'Navan opens with a HackerRank assessment, then a roughly 15-minute one-way video interview.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'nba-internship-guide': {
    family: 'other',
    processLine: 'The NBA starts with a one-way video interview for the most qualified applicants.',
    skills: ['operations', 'sql-data'],
  },
  'nera-economic-consulting-internship-guide': {
    family: 'consulting',
    processLine:
      'NERA starts with a roughly 30-minute phone screen: research background, why economic consulting and why NERA.',
    skills: ['communication', 'sql-data'],
  },
  'nestle-internship-guide': {
    family: 'marketing',
    processLine: 'Nestle opens with a HireVue of about 7 questions on motivation and values, after Cappfinity tests.',
    skills: ['product-sense', 'marketing-strategy'],
  },
  'netapp-internship-guide': {
    family: 'software',
    processLine: 'NetApp starts with a recruiter or HR screen, then one to three rounds depending on the team.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'netflix-internship-guide': {
    family: 'software',
    processLine: "Netflix's first live round is a 60-minute coding interview, after a CodeSignal assessment.",
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'netjets-internship-guide': {
    family: 'operations',
    processLine: 'NetJets starts with a phone interview on fit, background and department interest.',
    skills: ['case-structure', 'excel'],
  },
  'neurocrine-bioscience-internship-guide': {
    family: 'other',
    processLine: 'Neurocrine starts with a recruiter phone screen on motivation, neuroscience interest and track fit.',
    skills: ['sql-data', 'operations'],
  },
  'new-relic-internship-guide': {
    family: 'software',
    processLine: 'New Relic runs one to two technical interviews with engineers, after an online coding assessment.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'new-york-life-insurance-internship-guide': {
    family: 'finance',
    processLine: 'New York Life typically runs an HR behavioral screen, then a team interview.',
    skills: ['communication', 'sql-data'],
  },
  'new-york-times-internship-guide': {
    family: 'software',
    processLine: 'The Times starts with a recruiter call on your background, target team and timeline.',
    skills: ['sql-data', 'coding-fundamentals'],
  },
  'newmont-internship-guide': {
    family: 'operations',
    processLine: 'Newmont starts with a 30-minute recruiter screen on background, interest in mining and availability.',
    skills: ['case-structure', 'operations'],
  },
  'news-corp-internship-guide': {
    family: 'marketing',
    processLine:
      'Dow Jones corporate runs an HR phone screen, a department interview and a senior leadership interview.',
    skills: ['consumer-insight', 'marketing-analytics'],
  },
  'nextdoor-internship-guide': {
    family: 'software',
    processLine: 'Nextdoor starts with a 20-30 minute recruiter call on motivation, your resume and logistics.',
    skills: ['coding-fundamentals', 'product-sense'],
  },
  'nextera-energy-internship-guide': {
    family: 'operations',
    processLine:
      'NextEra opens with a HireVue of recorded behavioral questions; technical roles add two coding problems.',
    skills: ['operations', 'case-structure'],
  },
  'nfi-industries-internship-guide': {
    family: 'operations',
    processLine: null,
    skills: ['operations', 'supply-chain'],
  },
  'nfl-internship-guide': {
    family: 'marketing',
    processLine: 'The NFL starts with an on-demand recorded video interview, then a live video interview.',
    skills: ['marketing-strategy', 'research'],
  },
  'niagara-bottling-internship-guide': {
    family: 'operations',
    processLine: 'Niagara starts with a 20-30 minute recruiter call on your qualifications, availability and role fit.',
    skills: ['supply-chain', 'operations'],
  },
  'nickelodeon-internship-guide': {
    family: 'other',
    processLine: 'Nickelodeon usually runs one interview with the department head, on your experience or portfolio.',
    skills: ['sql-data', 'case-structure'],
  },
  'nih-internship-guide': { family: 'other', processLine: null, skills: ['sql-data', 'case-structure'] },
  'nike-internship-guide': {
    family: 'marketing',
    processLine:
      "Nike's first interview is a HireVue of 5-6 recorded behavioral questions, after game-based assessments.",
    skills: ['marketing-strategy', 'consumer-insight'],
  },
  'nintendo-internship-guide': {
    family: 'software',
    processLine: 'Nintendo starts with a 30-minute recruiter screen: background, motivation and why Nintendo.',
    skills: ['coding-fundamentals', 'product-sense'],
  },
  'nissan-internship-guide': {
    family: 'other',
    processLine: 'Nissan starts with a 15-30 minute recruiter screen on background, motivation and why Nissan.',
    skills: ['sql-data', 'operations'],
  },
  'nomura-internship-guide': {
    family: 'finance',
    processLine:
      "Nomura's first interview in the Americas is a phone call with a business-area associate; EMEA and APAC use HireVue.",
    skills: ['communication', 'markets'],
  },
  'nordstrom-internship-guide': {
    family: 'other',
    processLine: 'Nordstrom opens with a HireVue of behavioral and motivational questions.',
    skills: ['communication', 'product-sense'],
  },
  'norfolk-southern-internship-guide': {
    family: 'operations',
    processLine:
      "Norfolk Southern's first interview is a HireVue of recorded behavioral questions, after the NSMA assessment.",
    skills: ['operations', 'supply-chain'],
  },
  'northrop-grumman-internship-guide': {
    family: 'software',
    processLine: 'Northrop Grumman starts with a 20-30 minute recruiter screen on eligibility, location and basic fit.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'northwestern-mutual-internship-guide': {
    family: 'finance',
    processLine:
      'Northwestern Mutual starts with an Emerging Talent screening call, then team interviews, often virtual.',
    skills: ['coding-fundamentals', 'markets'],
  },
  'norwegian-cruise-line-internship-guide': {
    family: 'marketing',
    processLine:
      'Norwegian starts with a recruiter phone screen on motivation, brand knowledge and the cruise industry.',
    skills: ['marketing-strategy', 'marketing-analytics'],
  },
  'notion-internship-guide': {
    family: 'software',
    processLine: 'Notion starts with a 30-60 minute recruiter screen: why Notion and what draws you to the track.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'nov-internship-guide': {
    family: 'operations',
    processLine:
      'NOV runs a phone interview, then a panel on professionalism, teamwork and role-specific technical scenarios.',
    skills: ['operations', 'supply-chain'],
  },
  'novartis-internship-guide': {
    family: 'other',
    processLine:
      "Novartis' recruiter screen is 20-30 minutes on background and motivation, after a digital assessment.",
    skills: ['sql-data', 'case-structure'],
  },
  'novo-nordisk-internship-guide': {
    family: 'other',
    processLine: 'Novo Nordisk starts with an Early Talent recruiter phone screen; there is no online assessment.',
    skills: ['operations', 'sql-data'],
  },
  'nrg-energy-internship-guide': { family: 'other', processLine: null, skills: ['case-structure', 'consumer-insight'] },
  'nubank-internship-guide': {
    family: 'software',
    processLine: 'Nubank opens with a roughly 2-hour asynchronous coding challenge, then a group dynamics exercise.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'nucor-internship-guide': {
    family: 'operations',
    processLine: 'Nucor starts with a roughly 30-minute recruiter or hiring-manager screen, often a 2-on-1 video call.',
    skills: ['operations', 'excel'],
  },
  'nutanix-internship-guide': {
    family: 'software',
    processLine: 'Nutanix runs 1-2 interview rounds with hiring leaders on your motivation, background and fit.',
    skills: ['coding-fundamentals', 'product-sense'],
  },
  'nvidia-internship-guide': {
    family: 'software',
    processLine: 'NVIDIA starts with a short recruiter screen; many software roles then take a HackerRank assessment.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'nvr-internship-guide': {
    family: 'other',
    processLine: 'NVR starts with a recruiter phone screen, then a hiring manager or panel interview.',
    skills: ['operations', 'case-structure'],
  },
  'occidental-petroleum-internship-guide': {
    family: 'operations',
    processLine: 'Oxy starts with a recruiter phone or video screen, then a deeper hiring-manager phone interview.',
    skills: ['operations', 'quant-reasoning'],
  },
  'ogilvy-internship-guide': {
    family: 'marketing',
    processLine:
      "Ogilvy usually starts with a phone screen on the role and your background; there's no HireVue or online test.",
    skills: ['marketing-strategy', 'consumer-insight'],
  },
  'okta-internship-guide': {
    family: 'software',
    processLine: "Okta's recruiter screen is 30 minutes on fit and motivation, after a CodeSignal coding pre-screen.",
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'old-mission-internship-guide': {
    family: 'finance',
    processLine: "Old Mission's first interview is a 30-60 minute phone or video call, after a HackerRank assessment.",
    skills: ['coding-fundamentals', 'quant-reasoning'],
  },
  'old-republic-international-internship-guide': {
    family: 'finance',
    processLine: 'Old Republic starts with a behavioral HR phone screen on your background and interest in insurance.',
    skills: ['communication', 'financial-modeling'],
  },
  'oliver-wyman-internship-guide': {
    family: 'consulting',
    processLine:
      "Oliver Wyman's first round is two 30-minute interviews, one case and one fit, after an online assessment.",
    skills: ['case-structure', 'sql-data'],
  },
  'oneok-internship-guide': {
    family: 'operations',
    processLine: 'ONEOK starts with a recruiter phone screen on motivation, energy industry interest and role fit.',
    skills: ['quant-reasoning', 'excel'],
  },
  'openai-internship-guide': {
    family: 'ai-ml',
    processLine:
      'OpenAI starts with a 30-minute recruiter screen on background and motivation; it is not a technical test.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'optiver-internship-guide': {
    family: 'finance',
    processLine:
      "Optiver's first interview is a 45-60 minute phone or video session, after a five-part online assessment.",
    skills: ['quant-reasoning', 'coding-fundamentals'],
  },
  'oracle-internship-guide': {
    family: 'software',
    processLine: 'Oracle starts with a 20-30 minute non-technical recruiter screen on logistics, interest and fit.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'oreilly-auto-parts-internship-guide': {
    family: 'other',
    processLine:
      "O'Reilly's interview is casual and behavioral in STAR format; IT candidates take a HackerRank test first.",
    skills: ['sql-data', 'excel'],
  },
  'oscar-health-internship-guide': {
    family: 'software',
    processLine:
      'Oscar starts with a recruiter screen on your background, interest in healthcare technology and why Oscar.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'oshkosh-internship-guide': {
    family: 'operations',
    processLine:
      'Oshkosh starts with a roughly 15-minute recruiter phone screen on qualifications, motivation and location.',
    skills: ['case-structure', 'quant-reasoning'],
  },
  'otis-internship-guide': {
    family: 'operations',
    processLine:
      'Otis starts with an HR phone or video screen on your background and interest in the elevator industry.',
    skills: ['operations', 'excel'],
  },
  'oura-internship-guide': {
    family: 'software',
    processLine:
      'Oura starts with a get-to-know-you recruiter conversation on your background, motivation and mission fit.',
    skills: ['ml-fundamentals', 'coding-fundamentals'],
  },
  'ovintiv-internship-guide': {
    family: 'operations',
    processLine: 'Ovintiv starts with an HR phone screen on your background, interest in E&P and summer availability.',
    skills: ['excel', 'operations'],
  },
  'owens-and-minor-internship-guide': {
    family: 'operations',
    processLine:
      'Owens & Minor starts with an HR phone screen on your background and interest in healthcare distribution.',
    skills: ['supply-chain', 'excel'],
  },
  'owens-corning-internship-guide': {
    family: 'operations',
    processLine:
      "Owens Corning's rounds may include a recruiter phone screen, a behavioral interview and a technical assessment.",
    skills: ['operations', 'case-structure'],
  },
  'p-and-g-internship-guide': {
    family: 'marketing',
    processLine: 'P&G interviews are 45-60 minute behavioral STAR rounds, only after you pass two online assessments.',
    skills: ['marketing-strategy', 'consumer-insight'],
  },
  'paccar-internship-guide': {
    family: 'operations',
    processLine: "PACCAR runs a phone screen, then a behavioral panel; there's no coding assessment or HireVue.",
    skills: ['operations', 'excel'],
  },
  'pacific-life-internship-guide': {
    family: 'finance',
    processLine: "Pacific Life's first step may be a recorded video interview or a quantitative assessment.",
    skills: ['statistics', 'coding-fundamentals'],
  },
  'packaging-corp-of-america-internship-guide': {
    family: 'operations',
    processLine:
      'PCA runs a phone interview, then an onsite or virtual interview with behavioral and technical questions.',
    skills: ['operations', 'excel'],
  },
  'palantir-internship-guide': {
    family: 'software',
    processLine:
      "Palantir's first live round is a 60-minute technical phone screen, after a 90-minute HackerRank assessment.",
    skills: ['coding-fundamentals', 'product-sense'],
  },
  'palo-alto-networks-internship-guide': {
    family: 'software',
    processLine:
      'Palo Alto Networks starts with a 20-30 minute recruiter screen, including light Python, networking and cloud questions.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'paramount-internship-guide': {
    family: 'marketing',
    processLine:
      'Paramount starts with a 15-30 minute recruiter phone screen on your background and interest in entertainment.',
    skills: ['marketing-strategy', 'consumer-insight'],
  },
  'parker-hannifin-internship-guide': {
    family: 'operations',
    processLine:
      "Parker's first interview is primarily behavioral, on character, work ethic and teamwork, after a recruiter screen.",
    skills: ['case-structure', 'operations'],
  },
  'patientpoint-internship-guide': {
    family: 'software',
    processLine:
      'PatientPoint starts with a phone screen on your background and interest in healthcare marketing technology.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'paycor-internship-guide': {
    family: 'software',
    processLine: null,
    skills: ['coding-fundamentals', 'product-sense'],
  },
  'paypal-internship-guide': {
    family: 'software',
    processLine: 'PayPal starts with a 30-minute recruiter screen on background and your interest in fintech.',
    skills: ['sql-data', 'coding-fundamentals'],
  },
  'pbf-energy-internship-guide': {
    family: 'operations',
    processLine: 'PBF starts with a phone screen on your engineering background and interest in refining.',
    skills: ['operations', 'excel'],
  },
  'penske-automotive-internship-guide': {
    family: 'other',
    processLine:
      'Penske Automotive starts with a 15-20 minute recruiter phone interview on your background and why dealerships.',
    skills: ['case-structure', 'marketing-strategy'],
  },
  'pepsico-internship-guide': {
    family: 'other',
    processLine:
      "PepsiCo's first live interview is a recruiter phone or video screen with STAR questions on its GREAT5 principles.",
    skills: ['sql-data', 'case-structure'],
  },
  'perella-weinberg-internship-guide': {
    family: 'finance',
    processLine:
      "PWP's first round is a 30-45 minute interview run by Dartmouth Partners, half behavioral and half technical.",
    skills: ['financial-modeling', 'accounting'],
  },
  'performance-food-group-internship-guide': {
    family: 'operations',
    processLine: 'PFG starts with a short HR phone screen, then two senior leader interviews on motivation and fit.',
    skills: ['operations', 'supply-chain'],
  },
  'perplexity-internship-guide': {
    family: 'ai-ml',
    processLine: 'Perplexity starts with a 30-45 minute recruiter screen that probes Python and distributed systems.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'perry-homes-internship-guide': {
    family: 'operations',
    processLine:
      "Perry Homes' first round is a behavioral phone or virtual interview, including why residential construction.",
    skills: ['communication', 'excel'],
  },
  'pfizer-internship-guide': {
    family: 'other',
    processLine: "Pfizer's first interview is a HireVue of 3-5 one-way video questions, up to 2 minutes each.",
    skills: ['sql-data', 'case-structure'],
  },
  'pg-and-e-internship-guide': {
    family: 'operations',
    processLine:
      'PG&E starts with a recruiting phone screen on your background, interest in utilities and availability.',
    skills: ['excel', 'case-structure'],
  },
  'philadelphia-insurance-companies-internship-guide': {
    family: 'finance',
    processLine: null,
    skills: ['case-structure', 'coding-fundamentals'],
  },
  'philip-morris-internship-guide': {
    family: 'marketing',
    processLine:
      'PMI starts with a phone screen on your background and interest in its mission, then a behavioral and case interview.',
    skills: ['marketing-strategy', 'consumer-insight'],
  },
  'phillips-66-internship-guide': {
    family: 'operations',
    processLine: 'Phillips 66 opens with a HireVue: 5-6 recorded behavioral questions, about 30 minutes total.',
    skills: ['communication', 'case-structure'],
  },
  'physical-intelligence-internship-guide': {
    family: 'ai-ml',
    processLine:
      'Physical Intelligence likely starts with a 30-minute recruiter screen on your research interests and motivation.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'pika-internship-guide': {
    family: 'ai-ml',
    processLine:
      'Pika starts with a 15-30 minute recruiter screen on your background and interest in AI video generation.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'pilgrims-pride-internship-guide': {
    family: 'operations',
    processLine: "Pilgrim's opens with a virtual group interview where candidates do activities together.",
    skills: ['operations', 'excel'],
  },
  'pimco-internship-guide': {
    family: 'finance',
    processLine: 'PIMCO opens with a HireVue of recorded questions on why PIMCO, why fixed income and teamwork.',
    skills: ['communication', 'markets'],
  },
  'pinecone-internship-guide': {
    family: 'software',
    processLine:
      'Pinecone starts with a 30-minute recruiter screen on background, motivation and basic technical questions.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'pinterest-internship-guide': {
    family: 'software',
    processLine: "Pinterest's recruiter screen is 30 minutes on your interests, after a CodeSignal coding assessment.",
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'piper-sandler-internship-guide': {
    family: 'finance',
    processLine: 'Piper Sandler opens with a HireVue of recorded behavioral questions.',
    skills: ['markets', 'financial-modeling'],
  },
  'pjt-partners-internship-guide': {
    family: 'finance',
    processLine: "PJT's first round is a 30-minute phone or video screen, about half of it behavioral.",
    skills: ['valuation', 'financial-modeling'],
  },
  'pkf-oconnor-davies-internship-guide': {
    family: 'accounting-firm',
    processLine:
      "PKF O'Connor Davies interviews you with a manager, senior manager or partner about your past experience.",
    skills: ['audit', 'accounting'],
  },
  'plaid-internship-guide': {
    family: 'software',
    processLine: 'Plaid starts with a 30-minute non-technical recruiter screen on motivation, background and fit.',
    skills: ['coding-fundamentals', 'product-sense'],
  },
  'plains-all-american-pipeline-internship-guide': {
    family: 'operations',
    processLine:
      'Plains runs a conversational one-on-one behavioral interview on your background and industry knowledge.',
    skills: ['communication', 'excel'],
  },
  'plante-moran-internship-guide': {
    family: 'accounting-firm',
    processLine:
      'Plante Moran starts with a recruiter phone interview; there is no online assessment or technical test.',
    skills: ['tax', 'accounting'],
  },
  'pluralsight-internship-guide': {
    family: 'software',
    processLine: 'Pluralsight starts with a phone screen on your background and interest in edtech.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'pnc-internship-guide': {
    family: 'finance',
    processLine: 'PNC opens with a pre-recorded video screen for some roles, then a line-of-business interview.',
    skills: ['communication', 'markets'],
  },
  'point72-internship-guide': {
    family: 'finance',
    processLine: 'Point72 Academy has you submit a stock pitch on a mid-cap stock after a Wonderlic cognitive test.',
    skills: ['sql-data', 'financial-modeling'],
  },
  'porsche-internship-guide': {
    family: 'marketing',
    processLine:
      "Porsche's first interview is 30-45 minutes by phone or video on your background, motivation and why Porsche.",
    skills: ['marketing-strategy', 'marketing-analytics'],
  },
  'post-holdings-internship-guide': {
    family: 'marketing',
    processLine:
      "Post's interview is behavioral, on CPG interest, brand thinking and teamwork; manufacturing roles add technicals.",
    skills: ['marketing-strategy', 'product-sense'],
  },
  'postman-internship-guide': {
    family: 'software',
    processLine:
      'Postman opens with a HackerRank assessment of about three coding questions, then two technical interviews.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'ppg-industries-internship-guide': {
    family: 'operations',
    processLine: 'PPG starts with a phone screen on your background and interest in the coatings industry.',
    skills: ['operations', 'excel'],
  },
  'ppl-internship-guide': {
    family: 'operations',
    processLine: "PPL's interview mixes behavioral and technical components depending on your track.",
    skills: ['operations', 'quant-reasoning'],
  },
  'pratt-and-whitney-internship-guide': {
    family: 'operations',
    processLine:
      'Pratt & Whitney starts with a 15-30 minute recruiter screen: qualifications, why aerospace and why P&W.',
    skills: ['case-structure', 'operations'],
  },
  'precision-value-health-internship-guide': {
    family: 'consulting',
    processLine: 'Precision starts with a phone screen on your background and interest in pharmaceutical consulting.',
    skills: ['sql-data', 'excel'],
  },
  'principal-financial-internship-guide': {
    family: 'finance',
    processLine: 'Principal starts with a recruiter phone interview or an on-demand pre-recorded interview.',
    skills: ['case-structure', 'sql-data'],
  },
  'progressive-internship-guide': {
    family: 'finance',
    processLine:
      "Progressive's recruiter screen covers your background and fit; some tracks add a recorded video interview first.",
    skills: ['case-structure', 'sql-data'],
  },
  'prologis-internship-guide': { family: 'finance', processLine: null, skills: ['financial-modeling', 'sql-data'] },
  'prudential-financial-internship-guide': {
    family: 'finance',
    processLine:
      'Prudential opens with a roughly 35-minute HireVue of behavioral questions; tech roles add one coding question.',
    skills: ['coding-fundamentals', 'financial-modeling'],
  },
  'pseg-internship-guide': {
    family: 'operations',
    processLine: 'PSEG starts with a phone or video screen with a campus recruiter on your background and track fit.',
    skills: ['excel', 'operations'],
  },
  'publicis-sapient-internship-guide': {
    family: 'consulting',
    processLine:
      'Publicis Sapient starts with a roughly 15-minute recruiter call of basic behavioral questions, nothing technical.',
    skills: ['case-structure', 'sql-data'],
  },
  'publix-internship-guide': {
    family: 'operations',
    processLine: 'Publix interviews by panel, mostly behavioral with some general technical questions.',
    skills: ['operations', 'excel'],
  },
  'pulte-internship-guide': {
    family: 'operations',
    processLine: 'PulteGroup interviews you with the local division leadership team you would work for.',
    skills: ['case-structure', 'excel'],
  },
  'putnam-associates-internship-guide': {
    family: 'consulting',
    processLine:
      'Putnam starts with a 20-30 minute screen, then a round of a 30-minute pharma case plus behavioral questions.',
    skills: ['case-structure', 'sql-data'],
  },
  'pvh-internship-guide': {
    family: 'marketing',
    processLine: 'PVH starts with a virtual recruiter screen on your background, track fit and availability.',
    skills: ['marketing-strategy', 'consumer-insight'],
  },
  'pwc-internship-guide': {
    family: 'accounting-firm',
    processLine: "PwC's first interviews are two back-to-back behavioral rounds; most Advisory roles add a case.",
    skills: ['case-structure', 'excel'],
  },
  'qatalyst-partners-internship-guide': {
    family: 'finance',
    processLine:
      "Qatalyst's first round is a 30-minute technical screen with an Analyst: SaaS metrics, accounting and valuation.",
    skills: ['accounting', 'valuation'],
  },
  'qualcomm-internship-guide': {
    family: 'software',
    processLine: 'Qualcomm starts with a roughly 30-minute recruiter screen on your background and motivation.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'quanta-services-internship-guide': {
    family: 'operations',
    processLine:
      "Quanta's first interview is a 15-30 minute recruiting call on your background, goals and interest in the company.",
    skills: ['operations', 'excel'],
  },
  'quest-diagnostics-internship-guide': {
    family: 'other',
    processLine: 'Quest starts with a phone or recorded video screen, then a behavioral interview.',
    skills: ['communication', 'quant-reasoning'],
  },
  'qvc-internship-guide': {
    family: 'marketing',
    processLine: 'QVC starts with a 10-15 minute recruiter call: how you found QVC and what you know about it.',
    skills: ['marketing-strategy', 'marketing-analytics'],
  },
  'radio-flyer-internship-guide': {
    family: 'marketing',
    processLine:
      'Radio Flyer starts with a recruiter phone or video screen of culture-fit questions tied to its Flyer Code values.',
    skills: ['marketing-strategy', 'marketing-analytics'],
  },
  'ramp-internship-guide': {
    family: 'software',
    processLine:
      "Ramp's recruiter screen is 25-30 minutes on motivation and your projects, after a CTF or CodeSignal challenge.",
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'raymond-james-internship-guide': {
    family: 'finance',
    processLine:
      'Raymond James opens with a HireVue: four video answers plus a written essay analyzing financial data.',
    skills: ['communication', 'financial-modeling'],
  },
  'raytheon-internship-guide': {
    family: 'operations',
    processLine:
      "Raytheon's interview is 30-60 minutes with the hiring manager and team: STAR questions and light technical talk.",
    skills: ['case-structure', 'supply-chain'],
  },
  'rbc-capital-markets-internship-guide': {
    family: 'finance',
    processLine: "RBC's first round is a 60-minute phone or video interview with one or two analysts, after a HireVue.",
    skills: ['valuation', 'financial-modeling'],
  },
  'reckitt-internship-guide': {
    family: 'marketing',
    processLine: "Reckitt's first interview is a pre-recorded video of 3-5 questions, after an SHL assessment.",
    skills: ['marketing-strategy', 'consumer-insight'],
  },
  'recursion-internship-guide': {
    family: 'ai-ml',
    processLine:
      "Recursion's interviews reportedly cover mission fit, a technical or project discussion, and a cross-functional chat.",
    skills: ['coding-fundamentals', 'statistics'],
  },
  'red-bull-internship-guide': {
    family: 'marketing',
    processLine: "Red Bull's first interview is a recorded HireVue, after its Wingfinder personality assessment.",
    skills: ['marketing-strategy', 'consumer-insight'],
  },
  'reddit-internship-guide': {
    family: 'software',
    processLine: 'Reddit starts with a brief recruiter call on eligibility, timeline and mutual interest.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'regeneron-internship-guide': {
    family: 'other',
    processLine:
      'Regeneron starts with a 20-30 minute recruiter screen on qualifications and interest, then an AI-scored HireVue.',
    skills: ['sql-data', 'case-structure'],
  },
  'reinsurance-group-of-america-internship-guide': {
    family: 'finance',
    processLine: null,
    skills: ['sql-data', 'quant-reasoning'],
  },
  'reka-ai-internship-guide': {
    family: 'ai-ml',
    processLine:
      "Reka's likely first call is a 30-minute recruiter or hiring manager screen on your background and fit.",
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'relativity-space-internship-guide': {
    family: 'operations',
    processLine: 'Relativity starts with a 30-minute recruiter screen on your projects, goals and ITAR eligibility.',
    skills: ['case-structure', 'quant-reasoning'],
  },
  'reliance-internship-guide': {
    family: 'operations',
    processLine:
      'Reliance starts with a recruiter phone screen on your background, interests and fit for the role and subsidiary.',
    skills: ['supply-chain', 'excel'],
  },
  'replicate-internship-guide': {
    family: 'ai-ml',
    processLine: "Replicate hires through Cloudflare's intern program, starting with a 30-minute recruiter screen.",
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'replit-internship-guide': {
    family: 'software',
    processLine:
      'Replit starts with a short recruiter call on your career journey and goals, then a hiring manager interview.',
    skills: ['coding-fundamentals', 'product-sense'],
  },
  'republic-services-internship-guide': {
    family: 'operations',
    processLine:
      'Republic Services starts with a 20-30 minute recruiter screen: why environmental services and why Republic.',
    skills: ['operations', 'supply-chain'],
  },
  'retool-internship-guide': {
    family: 'software',
    processLine:
      'Retool starts with two intro calls, one with a recruiter and one with the hiring manager, on motivation and fit.',
    skills: ['sql-data', 'coding-fundamentals'],
  },
  'reynolds-american-internship-guide': {
    family: 'marketing',
    processLine: 'Reynolds (BAT) runs a screening step, then an assessment centre of individual and group activities.',
    skills: ['marketing-strategy', 'consumer-insight'],
  },
  'riot-games-internship-guide': {
    family: 'software',
    processLine:
      'Riot starts with a craft assessment, a HackerRank OA for SWE, before recruiter, craft and values interviews.',
    skills: ['coding-fundamentals', 'product-sense'],
  },
  'ripple-internship-guide': {
    family: 'software',
    processLine:
      "Ripple's recruiter screen covers background and fit, after an online assessment for engineering roles.",
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'rippling-internship-guide': {
    family: 'software',
    processLine: "Rippling's first live round is a 60-minute HackerRank coding interview, after an online assessment.",
    skills: ['coding-fundamentals', 'product-sense'],
  },
  'rivian-internship-guide': {
    family: 'software',
    processLine:
      'Rivian starts with a 30-45 minute recruiter screen on your background, motivation and mission alignment.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'ro-internship-guide': {
    family: 'software',
    processLine: 'Ro starts with a 30-60 minute recruiter screen on background, motivation and culture fit.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'robert-w-baird-internship-guide': {
    family: 'finance',
    processLine:
      "Baird's first round is a 30-minute phone or campus interview mixing behavioral and general technical questions.",
    skills: ['financial-modeling', 'accounting'],
  },
  'robinhood-internship-guide': {
    family: 'software',
    processLine:
      "Robinhood's recruiter screen is 30 minutes of basic behavioral questions, after a CodeSignal assessment.",
    skills: ['coding-fundamentals', 'product-sense'],
  },
  'roblox-internship-guide': {
    family: 'software',
    processLine: "Roblox's recruiter screen is about 30 minutes, after a 2-hour CodeSignal assessment with games.",
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'roche-internship-guide': {
    family: 'other',
    processLine:
      'Roche starts with a 20-30 minute HR phone or video screen on your background, availability and motivation.',
    skills: ['sql-data', 'case-structure'],
  },
  'rocket-companies-internship-guide': {
    family: 'finance',
    processLine:
      'Rocket starts with a 20-30 minute recruiter phone screen on motivation, fit and knowledge of its companies.',
    skills: ['case-structure', 'coding-fundamentals'],
  },
  'rocket-lab-internship-guide': {
    family: 'operations',
    processLine:
      'Rocket Lab starts with a 30-minute recruiter screen on motivation, background, role fit and ITAR status.',
    skills: ['case-structure', 'supply-chain'],
  },
  'rockstar-games-internship-guide': {
    family: 'software',
    processLine:
      'Rockstar starts with a 30-minute Zoom screen with a hiring manager on your background and motivation.',
    skills: ['sql-data', 'coding-fundamentals'],
  },
  'rockwell-automation-internship-guide': {
    family: 'software',
    processLine:
      "Rockwell's recruiter screening often includes an async video interview of recorded behavioral questions.",
    skills: ['communication', 'coding-fundamentals'],
  },
  'roland-berger-internship-guide': {
    family: 'consulting',
    processLine:
      "Roland Berger's first round is two 45-60 minute sessions, each mixing fit questions with a mini case.",
    skills: ['case-structure', 'quant-reasoning'],
  },
  'ross-stores-internship-guide': { family: 'other', processLine: null, skills: ['consumer-insight', 'excel'] },
  'rothschild-and-co-internship-guide': {
    family: 'finance',
    processLine:
      "Rothschild's first round is a 30-minute phone or HireVue interview: resume walkthrough and competency questions.",
    skills: ['financial-modeling', 'accounting'],
  },
  'royal-caribbean-internship-guide': {
    family: 'other',
    processLine: 'Royal Caribbean opens with a HireVue of 3-5 behavioral and situational questions.',
    skills: ['communication', 'sql-data'],
  },
  'rsm-internship-guide': {
    family: 'accounting-firm',
    processLine: "RSM's main interview is about 30 minutes: career goals, why RSM, and why your service line.",
    skills: ['communication', 'accounting'],
  },
  'rtx-internship-guide': {
    family: 'operations',
    processLine: 'RTX starts with a recruiter screen on basic qualifications, then a recorded HireVue for many roles.',
    skills: ['communication', 'case-structure'],
  },
  'runway-internship-guide': {
    family: 'ai-ml',
    processLine: 'Runway starts with a 30-minute recruiter screen on background, role fit and motivation for Runway.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'ryder-system-internship-guide': {
    family: 'operations',
    processLine:
      'Ryder starts with a 20-30 minute phone screen on your background, interest in supply chain and availability.',
    skills: ['communication', 'supply-chain'],
  },
  's-and-p-global-internship-guide': {
    family: 'finance',
    processLine: 'S&P Global starts with a recruiter or HR phone screen confirming fit, timing and pay expectations.',
    skills: ['sql-data', 'markets'],
  },
  'safe-superintelligence-internship-guide': {
    family: 'ai-ml',
    processLine: null,
    skills: ['ml-fundamentals', 'coding-fundamentals'],
  },
  'sakana-ai-internship-guide': {
    family: 'ai-ml',
    processLine: 'Sakana starts with a 30-minute recruiter screen on background, motivation and your AI/ML experience.',
    skills: ['ml-fundamentals', 'coding-fundamentals'],
  },
  'salesforce-internship-guide': {
    family: 'software',
    processLine:
      "Salesforce's recruiter screen is 30 minutes on background and motivation, after a coding OA for engineers.",
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'sallie-mae-internship-guide': {
    family: 'data-analytics',
    processLine: 'Sallie Mae starts with a 20-30 minute HR phone screen on motivation, fit, and why student lending.',
    skills: ['sql-data', 'quant-reasoning'],
  },
  'sambanova-internship-guide': {
    family: 'ai-ml',
    processLine:
      "SambaNova starts with a 15-30 minute recruiter screen on background and motivation; it isn't technical.",
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'samsara-internship-guide': {
    family: 'software',
    processLine: 'Samsara opens with a timed CoderPad or Codility assessment of 4-5 LeetCode-style questions.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'samsung-internship-guide': {
    family: 'software',
    processLine: 'Samsung usually runs two interview rounds; the format varies by Samsung entity.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'sandisk-internship-guide': {
    family: 'software',
    processLine: 'SanDisk starts with a recruiter screen, then one or two interviews, often one-on-one or by phone.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'sanmina-internship-guide': {
    family: 'operations',
    processLine: "Sanmina's interview is casual and behavioral: motivation, strengths and your engineering projects.",
    skills: ['communication', 'case-structure'],
  },
  'sanofi-internship-guide': {
    family: 'other',
    processLine:
      "Sanofi's first interview is a one-way HireVue of 3-5 questions, after a Plum psychometric assessment.",
    skills: ['sql-data', 'quant-reasoning'],
  },
  'sap-internship-guide': {
    family: 'software',
    processLine:
      "SAP's recruiter screen is 30 minutes on background and motivation, after a coding challenge for engineers.",
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'sas-internship-guide': {
    family: 'software',
    processLine:
      'SAS opens with a one-way HireVue of general and behavioral questions tied partly to its stated values.',
    skills: ['communication', 'coding-fundamentals'],
  },
  'scale-ai-internship-guide': {
    family: 'ai-ml',
    processLine:
      "Scale AI starts with a roughly 30-minute recruiter call on your background and the team you're targeting.",
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'scansource-internship-guide': {
    family: 'other',
    processLine:
      'ScanSource starts with a 15-30 minute behavioral phone screen: why ScanSource and how you handle stress.',
    skills: ['communication', 'sql-data'],
  },
  'schlumberger-internship-guide': {
    family: 'operations',
    processLine: 'SLB starts with an assessment: a coding OA for digital roles or an aptitude test for field roles.',
    skills: ['case-structure', 'operations'],
  },
  'seaboard-internship-guide': {
    family: 'operations',
    processLine:
      'Seaboard starts with a recruiter phone or video screen on your background and fit for the role and division.',
    skills: ['supply-chain', 'operations'],
  },
  'securian-financial-internship-guide': {
    family: 'finance',
    processLine:
      'Securian starts with a recruiter phone or video interview; some candidates first interview on campus.',
    skills: ['case-structure', 'financial-modeling'],
  },
  'sempra-internship-guide': {
    family: 'finance',
    processLine:
      'Sempra starts with a recruiter phone or video screen on your background, grades and interest in utility finance.',
    skills: ['financial-modeling', 'accounting'],
  },
  'sephora-internship-guide': {
    family: 'marketing',
    processLine: 'Sephora opens with an on-demand video interview of 3-5 behavioral questions.',
    skills: ['communication', 'marketing-strategy'],
  },
  'sequoia-capital-internship-guide': {
    family: 'finance',
    processLine: 'Sequoia screens with two rounds of written exercises before a partner or associate interview.',
    skills: ['coding-fundamentals', 'markets'],
  },
  'servicenow-internship-guide': {
    family: 'software',
    processLine:
      "ServiceNow's recruiter screen is 20-30 minutes on background and motivation, after a HackerRank test.",
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'shell-internship-guide': {
    family: 'operations',
    processLine:
      "Shell's first interview is an on-demand video of five recorded questions, after game-based assessments.",
    skills: ['operations', 'quant-reasoning'],
  },
  'sherwin-williams-internship-guide': {
    family: 'operations',
    processLine: 'Sherwin-Williams runs a conversational, team-fit interview with behavioral questions.',
    skills: ['communication', 'quant-reasoning'],
  },
  'shopify-internship-guide': {
    family: 'software',
    processLine:
      "Shopify's first interview is the Life Story round: 45-60 minutes walking through your life chronologically.",
    skills: ['communication', 'ml-fundamentals'],
  },
  'siemens-internship-guide': {
    family: 'software',
    processLine: 'Siemens starts with a 15-20 minute HR screening call on fit, motivation and eligibility.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'sierra-internship-guide': {
    family: 'ai-ml',
    processLine: "Sierra's first test is a take-home or online coding assessment of LeetCode medium-to-hard problems.",
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'sierra-space-internship-guide': {
    family: 'operations',
    processLine:
      'Sierra Space starts with a recruiter screen on US-person and clearance eligibility, your resume and motivation.',
    skills: ['operations', 'supply-chain'],
  },
  'sikich-internship-guide': {
    family: 'accounting-firm',
    processLine:
      'Sikich runs a conversational, low-pressure behavioral interview on public accounting, teamwork and why Sikich.',
    skills: ['accounting', 'audit'],
  },
  'silver-lake-internship-guide': {
    family: 'finance',
    processLine:
      "Silver Lake's first round is a roughly 30-minute behavioral fit interview: resume, why PE, why Silver Lake.",
    skills: ['communication', 'financial-modeling'],
  },
  'simon-kucher-partners-internship-guide': {
    family: 'consulting',
    processLine: "Simon-Kucher's first round is one 50-minute case and behavioral interview, after an aptitude test.",
    skills: ['case-structure', 'sql-data'],
  },
  'sirius-xm-internship-guide': {
    family: 'marketing',
    processLine: 'SiriusXM opens with a one-way HireVue video on your background and what you want to learn.',
    skills: ['communication', 'marketing-strategy'],
  },
  'skechers-internship-guide': {
    family: 'marketing',
    processLine: 'Skechers starts with an HR phone or video screen on your background and department fit.',
    skills: ['marketing-strategy', 'marketing-analytics'],
  },
  'skild-ai-internship-guide': {
    family: 'ai-ml',
    processLine: 'Skild AI starts with a 30-minute recruiter screen, then a CoderPad round implementing ML components.',
    skills: ['ml-fundamentals', 'coding-fundamentals'],
  },
  'slalom-build-internship-guide': {
    family: 'consulting',
    processLine:
      'Slalom starts with a 30-minute recruiter screen: your resume, why consulting, why Slalom and a teamwork story.',
    skills: ['sql-data', 'case-structure'],
  },
  'smithfield-foods-internship-guide': {
    family: 'operations',
    processLine:
      'Smithfield starts with a 20-30 minute recruiter phone screen on your background, goals and interest in Smithfield.',
    skills: ['operations', 'case-structure'],
  },
  'smucker-internship-guide': {
    family: 'marketing',
    processLine: 'Smucker starts with an HR phone or video screen on your background and interest in CPG.',
    skills: ['consumer-insight', 'marketing-strategy'],
  },
  'snap-internship-guide': {
    family: 'software',
    processLine: 'Snap starts with a 20-30 minute recruiter screen on your background and motivation.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'snowflake-internship-guide': {
    family: 'software',
    processLine:
      'Snowflake starts with a 30-minute recruiter screen with a high-level technical overview but no deep coding.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'snyk-internship-guide': {
    family: 'software',
    processLine:
      'Snyk starts with a recruiter screen on your background and why Snyk; the core technical round is a PR review.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'sofi-internship-guide': {
    family: 'software',
    processLine:
      'SoFi starts with a 20-30 minute recruiter call on logistics, motivation and basic technical competency.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'solomon-partners-internship-guide': {
    family: 'finance',
    processLine: 'Solomon starts with a brief HR phone screen on your background, motivation for IB and why Solomon.',
    skills: ['financial-modeling', 'valuation'],
  },
  'solventum-internship-guide': { family: 'operations', processLine: null, skills: ['operations', 'case-structure'] },
  'sonic-automotive-internship-guide': {
    family: 'other',
    processLine:
      'Sonic starts with a Talent Acquisition phone screen on your background and interest in automotive retail.',
    skills: ['sql-data', 'excel'],
  },
  'sony-internship-guide': {
    family: 'software',
    processLine: "Sony's first round is a 15-30 minute recruiter call or recorded video, depending on the division.",
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'sothebys-internship-guide': {
    family: 'marketing',
    processLine:
      "Sotheby's starts with a 20-30 minute HR call: why Sotheby's, why this department, and your passion for art.",
    skills: ['communication', 'marketing-strategy'],
  },
  'sourcegraph-internship-guide': {
    family: 'software',
    processLine:
      'Sourcegraph starts with a 30-minute recruiter video screen on background, why Sourcegraph and remote work.',
    skills: ['coding-fundamentals', 'product-sense'],
  },
  'southern-company-internship-guide': {
    family: 'operations',
    processLine:
      'Southern Company interviews often start as a first-round conversation at a campus career fair, then a final round.',
    skills: ['operations', 'case-structure'],
  },
  'southern-glazers-internship-guide': {
    family: 'operations',
    processLine:
      "Southern Glazer's runs about three rounds: recruiter phone screen, hiring manager call, and a final with a presentation.",
    skills: ['case-structure', 'supply-chain'],
  },
  'southwest-airlines-internship-guide': {
    family: 'other',
    processLine:
      'Southwest opens with a HireVue on-demand video interview focused on behavioral culture fit, not technical skills.',
    skills: ['sql-data', 'operations'],
  },
  'spacex-internship-guide': {
    family: 'operations',
    processLine:
      'SpaceX starts with a 30-45 minute recruiter phone screen on ITAR status, technical basics and why SpaceX.',
    skills: ['operations', 'case-structure'],
  },
  'spartannash-internship-guide': {
    family: 'operations',
    processLine:
      "SpartanNash's process appears to be a resume screen followed by behavioral interviews built on STAR examples.",
    skills: ['communication', 'operations'],
  },
  'spaulding-ridge-internship-guide': {
    family: 'data-analytics',
    processLine: 'Spaulding Ridge starts with a roughly 30-minute recruiter call on your background and motivation.',
    skills: ['sql-data', 'coding-fundamentals'],
  },
  'spirit-aerosystems-internship-guide': {
    family: 'operations',
    processLine:
      'Spirit AeroSystems starts with a 15-30 minute recruiter phone screen on your background and interest in aerospace.',
    skills: ['operations', 'supply-chain'],
  },
  'splunk-internship-guide': {
    family: 'software',
    processLine: 'Splunk starts with a 15-30 minute recruiter screen, then a Karat technical assessment.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'spotify-internship-guide': {
    family: 'other',
    processLine: 'Spotify starts with a recruiter call, then a technical or craft interview.',
    skills: ['sql-data', 'quant-reasoning'],
  },
  'sprout-social-internship-guide': {
    family: 'software',
    processLine:
      'Sprout Social starts with a 30-minute recruiter screen on your background, salary expectations and cultural alignment.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'sprouts-farmers-market-internship-guide': {
    family: 'other',
    processLine: null,
    skills: ['case-structure', 'quant-reasoning'],
  },
  'stability-ai-internship-guide': {
    family: 'ai-ml',
    processLine:
      'Stability AI starts with a 15-30 minute recruiter screen on your background, motivation and logistics.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'stanley-black-and-decker-internship-guide': {
    family: 'operations',
    processLine:
      'Stanley Black & Decker starts with an initial conversation, frequently virtual, then a team interview.',
    skills: ['operations', 'supply-chain'],
  },
  'staples-internship-guide': {
    family: 'other',
    processLine:
      'Staples starts with a 20-30 minute recruiter phone screen on your background, why retail and why Staples.',
    skills: ['sql-data', 'marketing-strategy'],
  },
  'starbucks-internship-guide': {
    family: 'other',
    processLine:
      'Starbucks starts with a 15-20 minute recruiter phone screen on why Starbucks and your interest in the track.',
    skills: ['sql-data', 'operations'],
  },
  'state-farm-internship-guide': {
    family: 'finance',
    processLine:
      "State Farm's first interview is a one-way HireVue video, after a timed pre-employment assessment on some tracks.",
    skills: ['sql-data', 'quant-reasoning'],
  },
  'state-street-internship-guide': {
    family: 'finance',
    processLine:
      'State Street opens with a Modern Hire video interview: 3-5 recorded behavioral questions, 2 minutes each.',
    skills: ['communication', 'markets'],
  },
  'stax-internship-guide': {
    family: 'consulting',
    processLine: 'Stax starts with a 20-30 minute HR screen: why consulting, why Stax, and its PE focus.',
    skills: ['market-sizing', 'sql-data'],
  },
  'steel-dynamics-internship-guide': {
    family: 'operations',
    processLine:
      'Steel Dynamics starts with a 15-30 minute recruiter or HR screen on qualifications and interest in steel.',
    skills: ['operations', 'excel'],
  },
  'steelcase-internship-guide': {
    family: 'operations',
    processLine:
      'Steelcase starts with a 15-30 minute recruiter phone screen on qualifications, availability and why Steelcase.',
    skills: ['case-structure', 'excel'],
  },
  'stellantis-internship-guide': {
    family: 'operations',
    processLine:
      "Stellantis starts with a recruiter or HR screen on fit, availability and resume basics; there's no coding test.",
    skills: ['excel', 'operations'],
  },
  'stepstone-group-internship-guide': {
    family: 'finance',
    processLine:
      'StepStone opens with a 20-30 minute recruiter call on your background and interest in private markets.',
    skills: ['financial-modeling', 'excel'],
  },
  'stifel-internship-guide': {
    family: 'finance',
    processLine:
      'Stifel starts with a HireVue: about 5 behavioral questions plus timed games on mental math and patterns.',
    skills: ['quant-reasoning', 'financial-modeling'],
  },
  'stihl-internship-guide': {
    family: 'other',
    processLine:
      "STIHL's interview varies by team, from a hard selective round to a friendly talk with your would-be supervisor.",
    skills: ['product-sense', 'marketing-strategy'],
  },
  'stonex-internship-guide': {
    family: 'finance',
    processLine: 'StoneX opens with a 15-minute pre-recorded video interview of behavioral and motivational questions.',
    skills: ['communication', 'sql-data'],
  },
  'strategy-internship-guide': {
    family: 'consulting',
    processLine: "Strategy&'s first round is two 45-minute interviews, each behavioral fit plus a candidate-led case.",
    skills: ['case-structure', 'quant-reasoning'],
  },
  'strava-internship-guide': {
    family: 'software',
    processLine:
      'Strava likely starts with a recruiter or phone screen on background and fit, then a role-specific coding round.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'stripe-internship-guide': {
    family: 'software',
    processLine:
      "Stripe's first live round is a 60-minute technical phone screen, after a 60-minute HackerRank assessment.",
    skills: ['coding-fundamentals', 'product-sense'],
  },
  'stryker-internship-guide': {
    family: 'operations',
    processLine: 'Stryker starts with a 15-30 minute recruiter phone screen, then a Gallup StrengthsFinder interview.',
    skills: ['case-structure', 'operations'],
  },
  'suno-internship-guide': {
    family: 'ai-ml',
    processLine: 'Suno starts with a 15-30 minute recruiter screen on your background and interest in AI and music.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'supabase-internship-guide': {
    family: 'software',
    processLine:
      'Supabase has no intern program; its full-time loop starts with a 30-minute recruiter screen on why Supabase.',
    skills: ['coding-fundamentals', 'product-sense'],
  },
  'super-micro-computer-internship-guide': {
    family: 'other',
    processLine:
      "Supermicro's one documented intern interview was an hour-long phone screen with behavioral and marketing questions.",
    skills: ['communication', 'case-structure'],
  },
  'susquehanna-sig-internship-guide': {
    family: 'finance',
    processLine: "SIG's phone screen covers your background and why SIG, after a 20-minute quantitative evaluation.",
    skills: ['quant-reasoning', 'statistics'],
  },
  'swift-internship-guide': {
    family: 'finance',
    processLine:
      'SWIFT starts with a friendly 15-30 minute talent acquisition phone screen on background, motivation and availability.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'swire-coca-cola-internship-guide': {
    family: 'other',
    processLine: 'Swire Coca-Cola starts with a phone interview on your interest in the position and role fit.',
    skills: ['sql-data', 'marketing-strategy'],
  },
  'synchrony-financial-internship-guide': {
    family: 'finance',
    processLine:
      'Synchrony starts with a recruiter phone screen on your background, motivation and track-specific interest.',
    skills: ['sql-data', 'quant-reasoning'],
  },
  'syneos-health-internship-guide': {
    family: 'consulting',
    processLine:
      'Syneos Health starts with a recruiter phone or video screen: why Syneos, why healthcare, and the CRO industry.',
    skills: ['quant-reasoning', 'research'],
  },
  'syngenta-internship-guide': {
    family: 'other',
    processLine:
      'Syngenta runs two behavior-based rounds: first with two team analysts, then with two hiring managers.',
    skills: ['communication', 'sql-data'],
  },
  'synopsys-internship-guide': {
    family: 'software',
    processLine:
      'Synopsys starts with a 20-30 minute non-technical recruiter screen, then a technical interview on C++ and algorithms.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'synovus-internship-guide': {
    family: 'finance',
    processLine: 'Synovus runs a phone interview, then conversational one-on-ones.',
    skills: ['financial-modeling', 'case-structure'],
  },
  'synthesia-internship-guide': {
    family: 'ai-ml',
    processLine: 'Synthesia starts with recruiter and hiring manager screens on background, motivation and team fit.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'sysco-internship-guide': {
    family: 'operations',
    processLine:
      "Sysco's screening is a recruiter phone interview or a digital assessment, sometimes with a video component.",
    skills: ['supply-chain', 'quant-reasoning'],
  },
  't-mobile-internship-guide': {
    family: 'software',
    processLine:
      "T-Mobile's recruiter screen is a mostly behavioral phone or video call, after an OA for some tech roles.",
    skills: ['communication', 'coding-fundamentals'],
  },
  't-rowe-price-internship-guide': {
    family: 'finance',
    processLine: "T. Rowe Price's first round is a roughly 45-minute asynchronous HireVue video assessment.",
    skills: ['financial-modeling', 'sql-data'],
  },
  'take-two-interactive-internship-guide': {
    family: 'software',
    processLine: "Take-Two's 2K program starts with a mandatory group scoping call, then a C++ coding assessment.",
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'tapestry-internship-guide': {
    family: 'marketing',
    processLine: 'Tapestry opens with a required HireVue video where you name your top three areas of interest.',
    skills: ['communication', 'marketing-strategy'],
  },
  'targa-resources-internship-guide': {
    family: 'operations',
    processLine: 'Targa starts with a brief recruiter phone screen on your background, interest in Targa and role fit.',
    skills: ['supply-chain', 'operations'],
  },
  'target-internship-guide': {
    family: 'other',
    processLine: 'Target opens with a HireVue: three to five recorded behavioral questions.',
    skills: ['communication', 'sql-data'],
  },
  'tata-consultancy-services-internship-guide': {
    family: 'software',
    processLine:
      'TCS reportedly starts with a phone screen on relocation, salary and visa, then technical and managerial rounds.',
    skills: ['coding-fundamentals', 'product-sense'],
  },
  'taylor-morrison-home-internship-guide': { family: 'operations', processLine: null, skills: ['operations', 'excel'] },
  'tbwa-internship-guide': {
    family: 'marketing',
    processLine: 'TBWA starts with a recruiter conversation on suitability, motivation and culture fit.',
    skills: ['marketing-strategy', 'research'],
  },
  'td-securities-internship-guide': {
    family: 'finance',
    processLine:
      "TD Securities' first round is a 30-minute phone or video interview mixing behavioral and technical questions.",
    skills: ['accounting', 'financial-modeling'],
  },
  'td-synnex-internship-guide': {
    family: 'operations',
    processLine:
      'TD SYNNEX starts with a brief intro phone screen on your experience and why you applied, then a manager interview.',
    skills: ['supply-chain', 'operations'],
  },
  'tempus-ai-internship-guide': {
    family: 'data-analytics',
    processLine: 'Tempus likely starts with a recruiter screen on motivation, interest in precision medicine and fit.',
    skills: ['sql-data', 'statistics'],
  },
  'tenet-healthcare-internship-guide': {
    family: 'other',
    processLine: 'Tenet starts with an HR phone or video screen on your background, why healthcare and why Tenet.',
    skills: ['sql-data', 'excel'],
  },
  'tesla-internship-guide': {
    family: 'software',
    processLine:
      'Tesla starts with a 15-30 minute recruiter screen: resume check, why Tesla, and a brief project walkthrough.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'texas-instruments-internship-guide': {
    family: 'software',
    processLine:
      'TI starts with a 20-30 minute recruiter screen on logistics and role fit, then a HackerRank assessment.',
    skills: ['coding-fundamentals', 'product-sense'],
  },
  'textron-internship-guide': {
    family: 'operations',
    processLine:
      'Textron starts with a 15-30 minute recruiter phone screen on your resume, motivation and work authorization.',
    skills: ['operations', 'quant-reasoning'],
  },
  'the-carlyle-group-internship-guide': {
    family: 'finance',
    processLine: "Carlyle's first round is a 30-minute video or phone screen with a recruiter or team member.",
    skills: ['financial-modeling', 'valuation'],
  },
  'the-hartford-internship-guide': {
    family: 'finance',
    processLine:
      'The Hartford runs 2-3 rounds: a recruiter phone screen, then a behavioral hiring manager interview on camera.',
    skills: ['communication', 'quant-reasoning'],
  },
  'the-trade-desk-internship-guide': {
    family: 'software',
    processLine:
      "The Trade Desk's recruiter screen is about 30 minutes, after a 90-minute four-level CodeSignal assessment.",
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'thermo-fisher-internship-guide': {
    family: 'other',
    processLine:
      'Thermo Fisher starts with a 15-30 minute recruiter screen of STAR behavioral questions tied to its 4i Values.',
    skills: ['communication', 'sql-data'],
  },
  'thinking-machines-lab-internship-guide': {
    family: 'ai-ml',
    processLine:
      "Thinking Machines' full-time loop starts with a recruiter screen on your research interests and why TML.",
    skills: ['ml-fundamentals', 'coding-fundamentals'],
  },
  'thor-industries-internship-guide': {
    family: 'operations',
    processLine: 'THOR starts with an HR phone or video screen on your background, interest in RVs and role fit.',
    skills: ['operations', 'excel'],
  },
  'thrivent-internship-guide': {
    family: 'finance',
    processLine:
      'Thrivent starts with an HR phone or video screen on your background, interest in Thrivent and role fit.',
    skills: ['financial-modeling', 'coding-fundamentals'],
  },
  'tiaa-internship-guide': {
    family: 'finance',
    processLine:
      'TIAA starts with a recruiter conversation on your interests and team fit, then one or two behavioral interviews.',
    skills: ['communication', 'case-structure'],
  },
  'tjx-companies-internship-guide': {
    family: 'other',
    processLine: 'TJX opens with a HireVue of about five questions, including one where you allocate product.',
    skills: ['communication', 'sql-data'],
  },
  'toast-internship-guide': {
    family: 'software',
    processLine:
      'Toast starts with a roughly 30-minute recruiter screen on background, fit and logistics, then a HackerRank test.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'together-ai-internship-guide': {
    family: 'ai-ml',
    processLine: 'Together AI starts with a recruiter screen confirming the role, your background and team interest.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'toll-brothers-internship-guide': {
    family: 'operations',
    processLine: 'Toll Brothers starts with a recruiter or hiring-manager phone call on your background and fit.',
    skills: ['operations', 'case-structure'],
  },
  'totalenergies-internship-guide': {
    family: 'operations',
    processLine: 'TotalEnergies starts with a casual recruiter or HR phone interview, often within a week of applying.',
    skills: ['operations', 'quant-reasoning'],
  },
  'tower-research-capital-internship-guide': {
    family: 'finance',
    processLine:
      "Tower's technical interviews test programming, quantitative reasoning and CS fundamentals, after a 90-minute OA.",
    skills: ['coding-fundamentals', 'quant-reasoning'],
  },
  'toyota-internship-guide': {
    family: 'operations',
    processLine:
      "Toyota's recruiter screen is 15-20 minutes on background and motivation, after an online assessment for most roles.",
    skills: ['case-structure', 'excel'],
  },
  'tpg-internship-guide': {
    family: 'finance',
    processLine:
      "TPG's first round is a 30-45 minute call: resume, why TPG, and technical warm-ups on LBOs and accounting.",
    skills: ['accounting', 'financial-modeling'],
  },
  'tractor-supply-internship-guide': {
    family: 'other',
    processLine: 'Tractor Supply starts with a recruiter or HR phone call, then team and hiring manager interviews.',
    skills: ['marketing-strategy', 'sql-data'],
  },
  'trane-technologies-internship-guide': {
    family: 'operations',
    processLine:
      'Trane Technologies starts with a recruiter phone screen, then STAR behavioral and technical interviews.',
    skills: ['quant-reasoning', 'communication'],
  },
  'transdigm-internship-guide': {
    family: 'operations',
    processLine:
      'TransDigm starts with a subsidiary HR phone screen on your background, engineering interests and availability.',
    skills: ['operations', 'communication'],
  },
  'travelers-internship-guide': {
    family: 'finance',
    processLine: 'Travelers starts with a 20-30 minute recruiter phone screen: why insurance and why Travelers.',
    skills: ['valuation', 'sql-data'],
  },
  'trimble-internship-guide': {
    family: 'software',
    processLine:
      'Trimble starts with a 15-30 minute recruiter screen of behavioral questions on your background and why Trimble.',
    skills: ['communication', 'coding-fundamentals'],
  },
  'trinity-life-sciences-internship-guide': {
    family: 'consulting',
    processLine:
      "Trinity's first round pairs values-based behavioral questions with a life-sciences commercial strategy case.",
    skills: ['case-structure', 'quant-reasoning'],
  },
  'truist-internship-guide': {
    family: 'finance',
    processLine: "Truist's investment banking track opens with a HireVue of behavioral and motivational questions.",
    skills: ['communication', 'financial-modeling'],
  },
  'tsmc-internship-guide': {
    family: 'operations',
    processLine:
      "TSMC's first interview is 30-60 minutes with the hiring manager; IT/SWE roles take a HackerRank test first.",
    skills: ['case-structure', 'quant-reasoning'],
  },
  'twilio-internship-guide': {
    family: 'software',
    processLine:
      'Twilio starts with a 15-30 minute recruiter screen on background and fit, then a HackerRank assessment.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'two-sigma-internship-guide': {
    family: 'finance',
    processLine:
      'Two Sigma opens with a technical screen: a coding assessment for SWE or a probability phone screen for QR.',
    skills: ['coding-fundamentals', 'quant-reasoning'],
  },
  'tyson-foods-internship-guide': {
    family: 'other',
    processLine: 'Tyson starts with a 30-45 minute behavioral phone or video screen tied to its RIGHT Behaviors.',
    skills: ['communication', 'operations'],
  },
  'uber-internship-guide': {
    family: 'software',
    processLine:
      "Uber's recruiter screen is 30 minutes of behavioral and logistics questions, after a CodeSignal assessment.",
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'ubisoft-internship-guide': {
    family: 'software',
    processLine: 'Ubisoft starts with a 15-20 minute recruiter call on basic fit, role interest and logistics.',
    skills: ['coding-fundamentals', 'product-sense'],
  },
  'ubs-internship-guide': {
    family: 'finance',
    processLine: "UBS's first interview is a pre-recorded HireVue of six questions, after AON online assessments.",
    skills: ['case-structure', 'markets'],
  },
  'ulta-beauty-internship-guide': {
    family: 'marketing',
    processLine: 'Ulta opens with an on-demand video screen: why Ulta, why DREAM, and high-level behavioral questions.',
    skills: ['communication', 'marketing-strategy'],
  },
  'unilever-internship-guide': {
    family: 'marketing',
    processLine:
      "Unilever's interview is a HireVue: three recorded behavioral questions plus one case question, after online tests.",
    skills: ['consumer-insight', 'marketing-strategy'],
  },
  'union-pacific-internship-guide': {
    family: 'operations',
    processLine:
      'Union Pacific starts with a short recruiter or team conversation, then one or two mostly behavioral rounds.',
    skills: ['communication', 'quant-reasoning'],
  },
  'united-airlines-internship-guide': {
    family: 'other',
    processLine: 'United runs one or two STAR behavioral interviews, after an online assessment for some roles.',
    skills: ['sql-data', 'operations'],
  },
  'united-natural-foods-internship-guide': { family: 'operations', processLine: null, skills: ['operations', 'excel'] },
  'united-rentals-internship-guide': {
    family: 'operations',
    processLine:
      'United Rentals starts with a phone screen, then an interview with the branch manager or local managers.',
    skills: ['excel', 'operations'],
  },
  'unitedhealth-group-internship-guide': {
    family: 'data-analytics',
    processLine:
      'UnitedHealth Group opens with an on-demand video interview of behavioral prompts, sent within 24-48 hours.',
    skills: ['communication', 'sql-data'],
  },
  'unity-internship-guide': {
    family: 'software',
    processLine: 'Unity starts with a roughly 30-minute recruiter phone screen, then a Codility coding assessment.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'universal-health-services-internship-guide': {
    family: 'other',
    processLine: 'UHS starts with a recruiter phone screen on your background, motivation and career goals.',
    skills: ['communication', 'case-structure'],
  },
  'unum-internship-guide': {
    family: 'finance',
    processLine:
      'Unum opens with a self-paced pre-recorded video of behavioral and motivational questions, sent right after you apply.',
    skills: ['sql-data', 'quant-reasoning'],
  },
  'ups-internship-guide': {
    family: 'operations',
    processLine: 'UPS starts with a recruiter or phone interview on your background, availability and fit.',
    skills: ['operations', 'supply-chain'],
  },
  'us-bank-internship-guide': {
    family: 'finance',
    processLine:
      'U.S. Bank starts with a recruiter phone screen, scheduled for 30 minutes, on background, fit and logistics.',
    skills: ['accounting', 'quant-reasoning'],
  },
  'us-foods-internship-guide': {
    family: 'operations',
    processLine: 'US Foods starts with a brief 20-30 minute behavioral phone or video screen.',
    skills: ['communication', 'supply-chain'],
  },
  'us-steel-internship-guide': {
    family: 'operations',
    processLine: 'U.S. Steel starts with an HR phone screen on your background, interests and why heavy manufacturing.',
    skills: ['supply-chain', 'excel'],
  },
  'usaa-internship-guide': {
    family: 'finance',
    processLine:
      "USAA's recruiter screen is roughly 15 minutes on your education and why USAA, after an online assessment.",
    skills: ['sql-data', 'quant-reasoning'],
  },
  'usertesting-internship-guide': {
    family: 'software',
    processLine: "UserTesting's first round is a hiring manager call on program expectations and company culture.",
    skills: ['coding-fundamentals', 'product-sense'],
  },
  'valero-energy-internship-guide': {
    family: 'operations',
    processLine:
      'Valero runs one behavioral interview by phone, video or on-site; interns report no technical questions.',
    skills: ['operations', 'quant-reasoning'],
  },
  'valve-internship-guide': {
    family: 'software',
    processLine: 'Valve has no internship; full-time candidates face a full day of back-to-back pair interviews.',
    skills: ['product-sense', 'coding-fundamentals'],
  },
  'vanguard-internship-guide': {
    family: 'finance',
    processLine:
      "Vanguard's HireVue video screen follows a game-based assessment, with questions on your background and why Vanguard.",
    skills: ['financial-modeling', 'sql-data'],
  },
  'vanta-internship-guide': {
    family: 'software',
    processLine:
      "Vanta's early-career loop starts with a 30-45 minute recruiter screen on background and career goals.",
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'vaynermedia-internship-guide': {
    family: 'marketing',
    processLine:
      'VaynerMedia starts with a recruiter screen on your background and interest in social and advertising.',
    skills: ['research', 'marketing-strategy'],
  },
  'venture-global-internship-guide': {
    family: 'operations',
    processLine: null,
    skills: ['operations', 'supply-chain'],
  },
  'vercel-internship-guide': {
    family: 'software',
    processLine:
      "Vercel's core round is a live, project-based technical interview where you reason aloud; it isn't LeetCode.",
    skills: ['coding-fundamentals', 'product-sense'],
  },
  'veris-insights-internship-guide': { family: 'consulting', processLine: null, skills: ['sql-data', 'research'] },
  'verizon-internship-guide': {
    family: 'software',
    processLine:
      "Verizon's first interview is a self-recorded video of six behavioral questions, after a personality assessment.",
    skills: ['sql-data', 'coding-fundamentals'],
  },
  'vertex-pharmaceuticals-internship-guide': {
    family: 'other',
    processLine:
      'Vertex starts with a 30-minute HR recruiter screen on qualifications, interest in Vertex and culture fit.',
    skills: ['case-structure', 'sql-data'],
  },
  'vertiv-internship-guide': {
    family: 'operations',
    processLine:
      'Vertiv starts with a recruiter phone screen of behavioral questions on fit and motivation for the role.',
    skills: ['communication', 'case-structure'],
  },
  'vf-corporation-internship-guide': {
    family: 'marketing',
    processLine:
      'VF starts with an HR phone screen on fit and motivation, then a Zoom interview with the hiring manager.',
    skills: ['marketing-strategy', 'consumer-insight'],
  },
  'viatris-internship-guide': {
    family: 'other',
    processLine: 'Viatris starts with an HR phone screen on your background, academic interests and role fit.',
    skills: ['sql-data', 'excel'],
  },
  'virtu-financial-internship-guide': {
    family: 'finance',
    processLine: "Virtu's HR phone screen covers motivation plus one brainteaser, after a HackerRank assessment.",
    skills: ['coding-fundamentals', 'quant-reasoning'],
  },
  'visa-internship-guide': {
    family: 'software',
    processLine: "Visa's recruiter screen is 15-30 minutes, after a four-question CodeSignal assessment.",
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'vista-equity-partners-internship-guide': {
    family: 'finance',
    processLine:
      "Vista's first round is a 30-minute phone interview: resume, why Vista, why PE, after a CCAT cognitive test.",
    skills: ['financial-modeling', 'coding-fundamentals'],
  },
  'vistra-internship-guide': {
    family: 'operations',
    processLine: 'Vistra starts with an HR phone screen on your background, engineering interests and availability.',
    skills: ['operations', 'excel'],
  },
  'vmware-internship-guide': {
    family: 'software',
    processLine:
      'VMware starts with a 30-minute recruiter screen on qualifications, career interests and team matching.',
    skills: ['coding-fundamentals', 'product-sense'],
  },
  'volkswagen-internship-guide': {
    family: 'operations',
    processLine:
      'Volkswagen starts with an HR phone screen on your background, interest in the role and basic qualifications.',
    skills: ['case-structure', 'operations'],
  },
  'voya-financial-internship-guide': {
    family: 'finance',
    processLine: 'Voya starts with a brief recruiter phone call confirming your background and interest.',
    skills: ['sql-data', 'quant-reasoning'],
  },
  'wabtec-internship-guide': {
    family: 'operations',
    processLine:
      "Wabtec's interview is behavioral for all tracks, with technical problem-solving for engineering and digital.",
    skills: ['operations', 'excel'],
  },
  'walgreens-internship-guide': {
    family: 'other',
    processLine:
      "Walgreens' recruiter phone or video screen confirms role fit, after a HireVue or skills test for some roles.",
    skills: ['sql-data', 'quant-reasoning'],
  },
  'walmart-internship-guide': {
    family: 'other',
    processLine:
      'Walmart starts with an online assessment: a judgment test for corporate roles or HackerRank for tech.',
    skills: ['sql-data', 'operations'],
  },
  'warburg-pincus-internship-guide': {
    family: 'finance',
    processLine: "Warburg Pincus' first round is two 30-minute virtual interviews with VPs or Principals.",
    skills: ['communication', 'financial-modeling'],
  },
  'warner-bros-discovery-internship-guide': {
    family: 'software',
    processLine:
      'WBD opens with a HireVue of five behavioral questions; tech roles add a 30-minute multiple-choice test.',
    skills: ['coding-fundamentals', 'product-sense'],
  },
  'warner-music-group-internship-guide': {
    family: 'marketing',
    processLine:
      'Warner Music Group interviews at least once, recorded or live, with the hiring manager and/or a panel.',
    skills: ['communication', 'research'],
  },
  'waste-management-internship-guide': {
    family: 'operations',
    processLine:
      'WM starts with a 20-30 minute phone screen on your background, why environmental services and why WM.',
    skills: ['supply-chain', 'quant-reasoning'],
  },
  'wayfair-internship-guide': {
    family: 'software',
    processLine: 'Wayfair starts with a roughly 30-minute recruiter call, then a HackerRank assessment for tech roles.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'waymo-internship-guide': {
    family: 'software',
    processLine:
      'Waymo starts with a 30-minute recruiter screen on your background, interest in autonomous driving and team fit.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'weaver-internship-guide': {
    family: 'accounting-firm',
    processLine: "Weaver's first interview is with a recruiter or manager, primarily behavioral.",
    skills: ['communication', 'accounting'],
  },
  'weaviate-internship-guide': {
    family: 'software',
    processLine: 'Weaviate starts with an informal 30-minute intro chat about your ambitions, not a technical test.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'wec-energy-internship-guide': {
    family: 'operations',
    processLine: 'WEC Energy interviews with the hiring team: behavioral questions plus technical ones for your track.',
    skills: ['operations', 'excel'],
  },
  'weights-and-biases-internship-guide': {
    family: 'ai-ml',
    processLine: 'W&B starts with a 30-minute recruiter screen and a 45-minute hiring manager screen.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'wellington-management-internship-guide': {
    family: 'finance',
    processLine: 'Wellington opens with a conversational, non-technical HR phone screen on your background and goals.',
    skills: ['case-structure', 'financial-modeling'],
  },
  'wells-fargo-internship-guide': {
    family: 'finance',
    processLine: "Wells Fargo's first interview is a HireVue of 3-7 behavioral questions, after an online assessment.",
    skills: ['financial-modeling', 'coding-fundamentals'],
  },
  'welltower-internship-guide': {
    family: 'finance',
    processLine: 'Welltower starts with a 20-30 minute recruiter screen: why healthcare real estate and why Welltower.',
    skills: ['financial-modeling', 'accounting'],
  },
  'wesco-international-internship-guide': {
    family: 'operations',
    processLine:
      "WESCO's hiring team interviews are mostly behavioral and situational, after a possible screening assessment.",
    skills: ['supply-chain', 'case-structure'],
  },
  'west-monroe-internship-guide': {
    family: 'consulting',
    processLine:
      "West Monroe's loop is virtual or in person, built around a case round plus values-based behavioral questions.",
    skills: ['case-structure', 'sql-data'],
  },
  'western-and-southern-financial-internship-guide': {
    family: 'finance',
    processLine:
      'Western & Southern starts with a phone interview with a campus recruiter on your background and track interest.',
    skills: ['sql-data', 'coding-fundamentals'],
  },
  'western-digital-internship-guide': {
    family: 'software',
    processLine:
      'Western Digital starts with a recruiter phone screen, then technical interviews with hiring managers.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'westlake-internship-guide': {
    family: 'operations',
    processLine: "Westlake's interview is behavioral for all tracks, with technical questions for engineering roles.",
    skills: ['operations', 'excel'],
  },
  'wex-internship-guide': {
    family: 'software',
    processLine: 'WEX interviews run 30-45 minutes by phone, video or in person, after an initial screen.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'whirlpool-internship-guide': {
    family: 'operations',
    processLine:
      "Whirlpool's first interview is a recruiter phone screen or group panel, after a mandatory online assessment.",
    skills: ['case-structure', 'operations'],
  },
  'whoop-internship-guide': {
    family: 'software',
    processLine: 'WHOOP starts with a roughly 30-minute recruiter screen on background, motivation and logistics.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'wieden-kennedy-internship-guide': {
    family: 'marketing',
    processLine: 'W+K starts with a recruiter screen, then a hiring-manager interview: why advertising, why W+K.',
    skills: ['consumer-insight', 'marketing-strategy'],
  },
  'william-blair-internship-guide': {
    family: 'finance',
    processLine:
      'William Blair opens with a 20-30 minute HireVue, mostly behavioral: why banking, why William Blair, teamwork.',
    skills: ['financial-modeling', 'accounting'],
  },
  'williams-internship-guide': {
    family: 'operations',
    processLine: 'Williams may start with a brief self-recorded video screen, then a panel interview.',
    skills: ['quant-reasoning', 'operations'],
  },
  'willis-towers-watson-internship-guide': {
    family: 'consulting',
    processLine: "WTW's first round is two interviews, each behavioral plus a case, after a HireVue assessment.",
    skills: ['case-structure', 'sql-data'],
  },
  'windsurf-internship-guide': {
    family: 'ai-ml',
    processLine: 'Windsurf starts with a coding assessment where any AI tool is allowed.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'wintrust-financial-internship-guide': {
    family: 'finance',
    processLine:
      'Wintrust starts with a phone or video screen on your background, interest in Wintrust and the 3.0 GPA bar.',
    skills: ['case-structure', 'financial-modeling'],
  },
  'wipfli-internship-guide': {
    family: 'accounting-firm',
    processLine: 'Wipfli starts with a 15-minute phone screen on behavioral questions and your fit with the firm.',
    skills: ['communication', 'tax'],
  },
  'wise-internship-guide': {
    family: 'software',
    processLine:
      'Wise opens with the async Maki Assessment: timed cognitive and CS multiple choice plus recorded behavioral answers.',
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'wisenbaker-builder-services-internship-guide': {
    family: 'operations',
    processLine:
      "Wisenbaker's interview is quick, often the day after a campus fair, on mindset, work ethic and interest in construction.",
    skills: ['excel', 'operations'],
  },
  'withum-internship-guide': {
    family: 'accounting-firm',
    processLine:
      "Withum starts with a behavioral recruiter screening call; there's no online assessment or case study.",
    skills: ['case-structure', 'accounting'],
  },
  'wiz-internship-guide': {
    family: 'software',
    processLine: "Wiz's full-time loop starts with a recruiter screen on motivation, background and role fit.",
    skills: ['coding-fundamentals', 'product-sense'],
  },
  'wolf-trap-foundation-internship-guide': {
    family: 'other',
    processLine: null,
    skills: ['marketing-strategy', 'case-structure'],
  },
  'wolverine-trading-internship-guide': {
    family: 'finance',
    processLine: 'Wolverine starts with a 15-20 minute recruiter phone screen.',
    skills: ['statistics', 'sql-data'],
  },
  'workday-internship-guide': {
    family: 'software',
    processLine: "Workday's recruiter screen is 30 minutes on background and why Workday, after a HackerRank OA.",
    skills: ['coding-fundamentals', 'sql-data'],
  },
  'world-bank-internship-guide': {
    family: 'other',
    processLine:
      'World Bank Pioneers interviews come after a timed Coderbyte multiple-choice assessment, with the hiring unit.',
    skills: ['sql-data', 'quant-reasoning'],
  },
  'world-kinect-internship-guide': { family: 'operations', processLine: null, skills: ['operations', 'supply-chain'] },
  'world-labs-internship-guide': {
    family: 'ai-ml',
    processLine: null,
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'wpp-internship-guide': {
    family: 'marketing',
    processLine: 'WPP agencies start with a short 20-minute interview on why advertising and why this agency.',
    skills: ['consumer-insight', 'marketing-analytics'],
  },
  'wr-berkley-internship-guide': {
    family: 'finance',
    processLine:
      'W.R. Berkley interviews are run by each operating unit, on your interest in insurance and risk thinking.',
    skills: ['sql-data', 'quant-reasoning'],
  },
  'writer-internship-guide': {
    family: 'ai-ml',
    processLine:
      "Writer's full-time loop starts with a roughly 30-minute recruiter screen; no intern roles are posted.",
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'xai-internship-guide': {
    family: 'ai-ml',
    processLine:
      'xAI starts with a 15-30 minute call with an engineer, not a recruiter, on concrete examples of your past work.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'xcel-energy-internship-guide': {
    family: 'operations',
    processLine: 'Xcel Energy starts with a short recruiter or hiring-manager screen, then a panel interview.',
    skills: ['communication', 'operations'],
  },
  'xpo-internship-guide': {
    family: 'operations',
    processLine:
      "XPO's first round reportedly felt like a personality and fit conversation, followed by a technical second round.",
    skills: ['operations', 'supply-chain'],
  },
  'xylem-internship-guide': {
    family: 'operations',
    processLine:
      'Xylem starts with a recruiter or hiring manager screen validating your work history and interest in water tech.',
    skills: ['operations', 'supply-chain'],
  },
  'yhb-internship-guide': {
    family: 'accounting-firm',
    processLine: "YHB's first round is a recruiter screen focused on getting to know your traits and work style.",
    skills: ['accounting', 'case-structure'],
  },
  'yum-brands-internship-guide': {
    family: 'marketing',
    processLine: 'Yum! Brands interviews mix behavioral questions with track-specific case questions.',
    skills: ['marketing-strategy', 'consumer-insight'],
  },
  'zapier-internship-guide': {
    family: 'software',
    processLine:
      "Zapier's full-time loop starts with a remote video recruiter screen on motivation and remote-culture fit.",
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'zimmer-biomet-internship-guide': {
    family: 'operations',
    processLine: "Zimmer Biomet's interview mixes behavioral and technical questions specific to your track.",
    skills: ['operations', 'communication'],
  },
  'zoetis-internship-guide': {
    family: 'other',
    processLine: 'Zoetis starts with a roughly 30-minute recruiter phone screen, mostly behavioral.',
    skills: ['communication', 'case-structure'],
  },
  'zoom-internship-guide': {
    family: 'software',
    processLine: 'Zoom starts with a 15-30 minute recruiter phone screen, then a 60-90 minute coding assessment.',
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'zoox-internship-guide': {
    family: 'software',
    processLine:
      "Zoox's recruiter screen is 30 minutes on background and interests, after a 90-minute coding assessment.",
    skills: ['coding-fundamentals', 'ml-fundamentals'],
  },
  'zs-associates-internship-guide': {
    family: 'consulting',
    processLine: 'ZS runs candidate-led case and behavioral interviews after a timed aptitude test.',
    skills: ['case-structure', 'sql-data'],
  },
  'zscaler-internship-guide': {
    family: 'software',
    processLine:
      "Zscaler's recruiter screen is about 30 minutes, after a HackerRank test with coding and networking questions.",
    skills: ['coding-fundamentals', 'product-sense'],
  },
  'zurich-north-america-internship-guide': {
    family: 'finance',
    processLine:
      "Zurich's interview mixes behavioral and role-specific questions; actuarial candidates discuss exam progress.",
    skills: ['statistics', 'quant-reasoning'],
  },
};
